/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type ProcessAccountSyncResponse = {
  __typename: "ProcessAccountSyncResponse",
  data?: ProcessAccountSyncData | null,
  status?: number | null,
  errors?: Array< string | null > | null,
};

export type ProcessAccountSyncData = {
  __typename: "ProcessAccountSyncData",
  tenantIDs?: Array< string | null > | null,
  assetsTypeInfo?: number | null,
  modelsInfo?: number | null,
  assetsInfo?: AssetsSyncInfo | null,
  locationInfo?: LocationsSyncInfo | null,
};

export type AssetsSyncInfo = {
  __typename: "AssetsSyncInfo",
  newAssets?: number | null,
  updatedAssets?: number | null,
};

export type LocationsSyncInfo = {
  __typename: "LocationsSyncInfo",
  newCountries?: number | null,
  newStates?: number | null,
  newCities?: number | null,
  newBuildings?: number | null,
};

export type DataSyncResponse = {
  __typename: "DataSyncResponse",
  data?:  Array<ProcessAccountSyncData | null > | null,
  status?: number | null,
  errors?: Array< string | null > | null,
};

export type UserCognitoSyncResponse = {
  __typename: "UserCognitoSyncResponse",
  data?: boolean | null,
  status?: number | null,
  errors?: Array< string | null > | null,
};

export type AssetInput = {
  assetTag: string,
  description: string,
  makeId: string,
  modelId: string,
  tenantId: string,
  state: string,
  usefulLife?: number | null,
  acquisitionCostValue?: number | null,
  lastMaintenanceDate?: string | null,
  nextScheduledMaintenanceDate?: string | null,
  assignedToId?: string | null,
  assetTypeId: string,
  condition?: string | null,
  maintenanceCostValue?: number | null,
  currentBookValue?: number | null,
  installDate?: string | null,
  decommissionDate?: string | null,
  locationId?: string | null,
  image?: string | null,
  purchaseOrderId?: string | null,
  utilizationData?: string | null,
  reasonForDecommission?: string | null,
  serialNumber: string,
  thirdPartyId?: string | null,
  totalCostOfOwnershipValue?: number | null,
  repairCostValue?: number | null,
  warrantyExpiration?: string | null,
  downTime?: string | null,
  isParent?: boolean | null,
  thirdPartyParentId?: string | null,
  thirdPartyHierarchyPath?: Array< string | null > | null,
};

export type AssetResponse = {
  __typename: "AssetResponse",
  data?: Asset | null,
  status?: number | null,
  errors?: Array< string | null > | null,
};

export type Asset = {
  __typename: "Asset",
  id: string,
  number?: number | null,
  displayNumber?: string | null,
  userId?: string | null,
  assetTag: string,
  description: string,
  makeId: string,
  modelId: string,
  state: string,
  usefulLife?: number | null,
  acquisitionCostValue?: number | null,
  lastMaintenanceDate?: string | null,
  nextScheduledMaintenanceDate?: string | null,
  assignedToId?: string | null,
  assetTypeId: string,
  condition?: string | null,
  maintenanceCostValue?: number | null,
  currentBookValue?: number | null,
  installDate?: string | null,
  decommissionDate?: string | null,
  locationId?: string | null,
  image?: string | null,
  purchaseOrderId?: string | null,
  utilizationData?: string | null,
  reasonForDecommission?: string | null,
  serialNumber: string,
  thirdPartyId?: string | null,
  source?: string | null,
  totalCostOfOwnershipValue?: number | null,
  repairCostValue?: number | null,
  warrantyExpiration?: string | null,
  downTime?: string | null,
  tenantId: string,
  createdAt: string,
  createdBy?: string | null,
  updatedAt?: string | null,
  updatedBy?: string | null,
  model?: Model | null,
  assetType?: AssetType | null,
  manufacturer?: Manufacturer | null,
  tenant?: Tenant | null,
  woCount?: number | null,
  findingsCount?: number | null,
  user?: User | null,
  assetRisk?: number | null,
  location?: Location | null,
  isParent?: boolean | null,
  thirdPartyParentId?: string | null,
  thirdPartyHierarchyPath?: Array< string | null > | null,
};

export type Model = {
  __typename: "Model",
  id: string,
  tenantId: string,
  createdAt: string,
  createdBy?: string | null,
  updatedAt?: string | null,
  updatedBy?: string | null,
  oemPartNumber?: string | null,
  name: string,
  manufacturerId: string,
  assetTypeId: string,
  probability?: number | null,
  severity?: number | null,
  riskScore?: number | null,
  picture?: string | null,
  specification?: string | null,
  usefulLife?: number | null,
  inUseStatus?: InUseStatus | null,
  thirdPartyId?: string | null,
  thirdPartySource?: string | null,
  tenant?: Tenant | null,
  manufacturer?: Manufacturer | null,
  assetType?: AssetType | null,
  createdByUser?: User | null,
  updatedByUser?: User | null,
};

export enum InUseStatus {
  newlyCreated = "newlyCreated",
  inUse = "inUse",
  deprecated = "deprecated",
}


export type Tenant = {
  __typename: "Tenant",
  id: string,
  createdAt: string,
  createdBy?: string | null,
  updatedAt?: string | null,
  updatedBy?: string | null,
  name: string,
  address?: string | null,
  contacts?: string | null,
  isActive?: boolean | null,
  cognitoGroupName?: string | null,
  tisId?: string | null,
  plan?: TenantPlan | null,
  tisSyncedAt?: string | null,
};

export enum TenantPlan {
  starter = "starter",
  basic = "basic",
  advanced = "advanced",
  professional = "professional",
  enterprise = "enterprise",
  max = "max",
}


export type Manufacturer = {
  __typename: "Manufacturer",
  id: string,
  name: string,
  description?: string | null,
  countryId?: string | null,
  website?: string | null,
  contactPerson?: string | null,
  contactEmail?: string | null,
  contactPhone?: string | null,
  address?: string | null,
  warrantyPolicies?: string | null,
  slaDetails?: string | null,
  vendorPortalLink?: string | null,
  createdAt: string,
  createdBy: string,
  createdByUser?: User | null,
  updatedAt?: string | null,
  updatedBy?: string | null,
  updatedByUser?: User | null,
  thirdPartyId?: string | null,
  thirdPartySource?: string | null,
  tenantId?: string | null,
  tenant?: Tenant | null,
  inUseStatus?: InUseStatus | null,
};

export type User = {
  __typename: "User",
  id: string,
  tenantId?: string | null,
  createdAt?: string | null,
  createdBy?: string | null,
  updatedAt?: string | null,
  updatedBy?: string | null,
  groups?: string | null,
  email: string,
  name: string,
  phone?: string | null,
  role?: string | null,
  address?: string | null,
  location?: string | null,
  tenant?: Tenant | null,
  createdByUser?: User | null,
  updatedByUser?: User | null,
};

export type AssetType = {
  __typename: "AssetType",
  id: string,
  tenantId?: string | null,
  tenant?: Tenant | null,
  createdAt: string,
  createdBy?: string | null,
  createdByUser?: User | null,
  updatedAt?: string | null,
  updatedBy?: string | null,
  updatedByUser?: User | null,
  name: string,
  description?: string | null,
  category?: string | null,
  criticalityLevel?: number | null,
  expectedUsefulLife?: number | null,
  defaultWarrantyPeriod?: number | null,
  defaultRiskScore?: number | null,
  manufacturerRecommendations?: string | null,
  image?: string | null,
  thirdPartyId?: string | null,
  thirdPartySource?: string | null,
  inUseStatus?: string | null,
};

export type Location = {
  __typename: "Location",
  id: string,
  tenantId: string,
  tenant?: Tenant | null,
  createdAt: string,
  createdBy?: string | null,
  updatedAt?: string | null,
  updatedBy?: string | null,
  name: string,
  notes?: string | null,
  lat?: number | null,
  lng?: number | null,
  level?: string | null,
  parentId?: string | null,
  rootId?: string | null,
  thirdPartyId?: string | null,
  source?: string | null,
  inUseStatus?: InUseStatus | null,
  address?: string | null,
  buildingAddress?: string | null,
  parent?: Location | null,
  tisSyncedAt?: string | null,
};

export type SeeWorkOrderAsUserResponse = {
  __typename: "SeeWorkOrderAsUserResponse",
  data?: boolean | null,
  status?: number | null,
  errors?: Array< string | null > | null,
};

export type WorkOrderInput = {
  userId?: string | null,
  locationId?: string | null,
  dueDate?: string | null,
  startDate?: string | null,
  endDate?: string | null,
  plannedStartDate?: string | null,
  plannedEndDate?: string | null,
  assetId?: string | null,
  assignmentGroupId?: string | null,
  assignedToId?: string | null,
  businessDownTime?: number | null,
  downTimeStart?: string | null,
  downTimeEnd?: string | null,
  category?: string | null,
  checklist?: string | null,
  closedNotes?: string | null,
  notes?: string | null,
  title?: string | null,
  description?: string | null,
  actualEffort?: number | null,
  expectedOperationalDate?: string | null,
  impact?: number | null,
  priority?: number | null,
  dependsOnWorkOrderId?: string | null,
  state?: string | null,
  type?: string | null,
  closedById?: string | null,
  closedAt?: string | null,
  templateId?: string | null,
  findingId?: string | null,
  alertId?: string | null,
  tenantId?: string | null,
  isArchived?: boolean | null,
};

export type WorkOrderResponse = {
  __typename: "WorkOrderResponse",
  data?: WorkOrder | null,
  status?: number | null,
  errors?: Array< string | null > | null,
};

export type WorkOrder = {
  __typename: "WorkOrder",
  id?: string | null,
  displayNumber?: string | null,
  tenantId?: string | null,
  tenant?: Tenant | null,
  createdAt?: string | null,
  createdBy?: string | null,
  createdByUser?: User | null,
  updatedAt?: string | null,
  updatedBy?: string | null,
  updatedByUser?: User | null,
  number?: number | null,
  userId?: string | null,
  user?: User | null,
  locationId?: string | null,
  location?: Location | null,
  dueDate?: string | null,
  startDate?: string | null,
  endDate?: string | null,
  duration?: string | null,
  plannedStartDate?: string | null,
  plannedEndDate?: string | null,
  assetId?: string | null,
  asset?: Asset | null,
  assignmentGroupId?: string | null,
  assignedToId?: string | null,
  assignedTo?: User | null,
  businessDownTime?: number | null,
  downTimeStart?: string | null,
  downTimeEnd?: string | null,
  category?: string | null,
  checklist?: string | null,
  closedNotes?: string | null,
  closedAt?: string | null,
  closedById?: string | null,
  closedBy?: User | null,
  notes?: string | null,
  title?: string | null,
  description?: string | null,
  estimatedCostValue?: number | null,
  actualCostValue?: number | null,
  estimatedEffort?: number | null,
  actualEffort?: number | null,
  expectedOperationalDate?: string | null,
  impact?: number | null,
  priority?: number | null,
  dependsOnWorkOrderId?: string | null,
  dependsOnWorkOrder?: WorkOrder | null,
  state?: string | null,
  type?: string | null,
  templateId?: string | null,
  isArchived?: boolean | null,
  findingId?: string | null,
  seenByAssignee?: boolean | null,
  assignmentDateTime?: string | null,
  seenDateTime?: string | null,
  startOfWorkDateTime?: string | null,
  endOfWorkDateTime?: string | null,
};

export type BulkUpdateData = {
  values: string,
  ids?: Array< string | null > | null,
  params?: QueryListParams | null,
  requirements?: string | null,
};

export type QueryListParams = {
  filter?: string | null,
  sortBy?: SortByParams | null,
  skip?: number | null,
  take?: number | null,
  requireTotalCount?: boolean | null,
};

export type SortByParams = {
  field: string,
  direction?: SortDirection | null,
};

export enum SortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type BulkUpdateResponse = {
  __typename: "BulkUpdateResponse",
  updatedCount?: number | null,
  status?: number | null,
  errors?: Array< string | null > | null,
};

export type WorkOrderListResponse = {
  __typename: "WorkOrderListResponse",
  data?:  Array<WorkOrder | null > | null,
  totalCount?: number | null,
  status?: number | null,
  errors?: Array< string | null > | null,
};

export type WorkOrderTemplateInput = {
  number?: number | null,
  title: string,
  type?: string | null,
  category?: string | null,
  description?: string | null,
  userId?: string | null,
  locationId?: string | null,
  assignmentGroupId?: string | null,
  notes?: string | null,
  estimatedCostValue?: number | null,
  estimatedEffort?: number | null,
  impact?: number | null,
  priority?: number | null,
  tenantId?: string | null,
  executionInterval?: string | null,
  assetManufacturerId?: string | null,
  assetModelId?: string | null,
  assetTypeId?: string | null,
};

export type WorkOrderTemplateResponse = {
  __typename: "WorkOrderTemplateResponse",
  data?: WorkOrderTemplate | null,
  status?: number | null,
  errors?: Array< string | null > | null,
};

export type WorkOrderTemplate = {
  __typename: "WorkOrderTemplate",
  id?: string | null,
  displayNumber?: string | null,
  tenantId?: string | null,
  createdAt?: string | null,
  createdBy?: string | null,
  createdByUser?: User | null,
  updatedAt?: string | null,
  updatedBy?: string | null,
  updatedByUser?: User | null,
  number?: number | null,
  title: string,
  type?: string | null,
  category?: string | null,
  description?: string | null,
  userId?: string | null,
  locationId?: string | null,
  assignmentGroupId?: string | null,
  notes?: string | null,
  estimatedCostValue?: number | null,
  estimatedEffort?: number | null,
  impact?: number | null,
  priority?: number | null,
  executionInterval?: string | null,
  assetManufacturerId?: string | null,
  assetModelId?: string | null,
  assetTypeId?: string | null,
  tenant?: Tenant | null,
  manufacturer?: Manufacturer | null,
  assetType?: AssetType | null,
  model?: Model | null,
};

export type CreateModelInput = {
  oemPartNumber?: string | null,
  name: string,
  manufacturerId: string,
  assetTypeId: string,
  probability?: number | null,
  severity?: number | null,
  picture?: string | null,
  specification?: string | null,
  tenantId?: string | null,
  usefulLife?: number | null,
  inUseStatus?: InUseStatus | null,
};

export type ModelResponse = {
  __typename: "ModelResponse",
  data?: Model | null,
  status?: number | null,
  errors?: Array< string | null > | null,
};

export type UpdateModelInput = {
  oemPartNumber?: string | null,
  name?: string | null,
  manufacturerId?: string | null,
  assetTypeId?: string | null,
  probability?: number | null,
  tenantId?: string | null,
  severity?: number | null,
  picture?: string | null,
  specification?: string | null,
  usefulLife?: number | null,
  inUseStatus?: InUseStatus | null,
};

export type ManufacturerInput = {
  name: string,
  description?: string | null,
  countryId?: string | null,
  website?: string | null,
  contactPerson?: string | null,
  contactEmail?: string | null,
  contactPhone?: string | null,
  address?: string | null,
  warrantyPolicies?: string | null,
  slaDetails?: string | null,
  vendorPortalLink?: string | null,
  inUseStatus: InUseStatus,
  tenantId?: string | null,
};

export type ManufacturerResponse = {
  __typename: "ManufacturerResponse",
  data?: Manufacturer | null,
  status?: number | null,
  errors?: Array< string | null > | null,
};

export type FindingInput = {
  shortDescription?: string | null,
  priority?: number | null,
  estimatedRepairCost?: number | null,
  plannedRepairDate?: string | null,
  description?: string | null,
  cause?: string | null,
  symptom?: string | null,
  picture?: string | null,
  reportedOn?: string | null,
  workOrderId?: string | null,
  type: FindingType,
  assetId: string,
  reportedById: string,
  status: FindingStatus,
  tenantId?: string | null,
  isArchived?: boolean | null,
  alertId?: string | null,
};

export enum FindingType {
  missed_maintenance = "missed_maintenance",
  deficiency = "deficiency",
  defect = "defect",
  issue = "issue",
}


export enum FindingStatus {
  new = "new",
  planned = "planned",
  in_progress = "in_progress",
  wo_created = "wo_created",
  in_review = "in_review",
  resolved = "resolved",
}


export type FindingResponse = {
  __typename: "FindingResponse",
  data?: Finding | null,
  status?: number | null,
  errors?: Array< string | null > | null,
};

export type Finding = {
  __typename: "Finding",
  id: string,
  tenantId?: string | null,
  tenant?: Tenant | null,
  createdAt?: string | null,
  createdBy?: string | null,
  updatedAt?: string | null,
  updatedBy?: string | null,
  number?: number | null,
  displayNumber?: string | null,
  shortDescription?: string | null,
  priority?: number | null,
  estimatedRepairCost?: number | null,
  plannedRepairDate?: string | null,
  description?: string | null,
  cause?: string | null,
  symptom?: string | null,
  picture?: string | null,
  reportedOn?: string | null,
  workOrderId?: string | null,
  type?: FindingType | null,
  reportedById?: string | null,
  status?: FindingStatus | null,
  assetId?: string | null,
  asset?: Asset | null,
  locationId?: string | null,
  model?: Model | null,
  isArchived?: boolean | null,
  thirdPartyId?: string | null,
  thirdPartySource?: string | null,
};

export type UpdateFindingInput = {
  shortDescription?: string | null,
  priority?: number | null,
  estimatedRepairCost?: number | null,
  plannedRepairDate?: string | null,
  description?: string | null,
  cause?: string | null,
  symptom?: string | null,
  picture?: string | null,
  reportedOn?: string | null,
  workOrderId?: string | null,
  type?: FindingType | null,
  assetId?: string | null,
  locationId?: string | null,
  tenantId?: string | null,
  reportedById?: string | null,
  status?: FindingStatus | null,
  isArchived?: boolean | null,
  alertId?: string | null,
};

export type UserInput = {
  email?: string | null,
  name?: string | null,
  phone?: string | null,
  role?: string | null,
  address?: string | null,
  location?: string | null,
};

export type UserResponse = {
  __typename: "UserResponse",
  data?: User | null,
  status?: number | null,
  errors?: Array< string | null > | null,
};

export type TenantInput = {
  name: string,
  address?: string | null,
  contacts?: string | null,
  isActive?: boolean | null,
  cognitoGroupName?: string | null,
  tisId?: string | null,
  plan?: TenantPlan | null,
};

export type TenantResponse = {
  __typename: "TenantResponse",
  data?: Tenant | null,
  status?: number | null,
  errors?: Array< string | null > | null,
};

export type LocationInput = {
  name: string,
  notes?: string | null,
  lat?: number | null,
  lng?: number | null,
  level: string,
  parentId?: string | null,
  rootId?: string | null,
  inUseStatus?: InUseStatus | null,
  address?: string | null,
  tenantId?: string | null,
};

export type LocationResponse = {
  __typename: "LocationResponse",
  data?: Location | null,
  status?: number | null,
  errors?: Array< string | null > | null,
};

export type ExpenseInput = {
  title: string,
  description?: string | null,
  type?: string | null,
  status?: string | null,
  number?: number | null,
  amount?: number | null,
  purchaseOrderId?: string | null,
  workOrderId?: string | null,
  tenantId?: string | null,
};

export type ExpenseResponse = {
  __typename: "ExpenseResponse",
  data?: Expense | null,
  status?: number | null,
  errors?: Array< string | null > | null,
};

export type Expense = {
  __typename: "Expense",
  id: string,
  displayNumber?: string | null,
  tenantId: string,
  createdAt: string,
  createdBy?: string | null,
  updatedAt?: string | null,
  updatedBy?: string | null,
  title: string,
  description?: string | null,
  type?: string | null,
  status?: string | null,
  number?: number | null,
  amount?: number | null,
  purchaseOrderId?: string | null,
  workOrderId?: string | null,
  user?: User | null,
  updatedByUser?: User | null,
  workOrder?: WorkOrder | null,
  tenant?: Tenant | null,
};

export type AssetTypeInput = {
  name: string,
  description?: string | null,
  category?: string | null,
  criticalityLevel?: number | null,
  expectedUsefulLife?: number | null,
  defaultWarrantyPeriod?: number | null,
  defaultRiskScore?: number | null,
  manufacturerRecommendations?: string | null,
  image?: string | null,
  inUseStatus?: string | null,
  tenantId?: string | null,
};

export type AssetTypeResponse = {
  __typename: "AssetTypeResponse",
  data?: AssetType | null,
  status?: number | null,
  errors?: Array< string | null > | null,
};

export type AttachmentInput = {
  fileName: string,
  originalFileName: string,
  path: string,
  mimeType: string,
  size: number,
  description?: string | null,
  relatedTable: string,
  relatedItem: string,
  relatedField?: string | null,
  type: string,
};

export type AttachmentResponse = {
  __typename: "AttachmentResponse",
  data?: Attachment | null,
  status?: number | null,
  errors?: Array< string | null > | null,
};

export type Attachment = {
  __typename: "Attachment",
  id: string,
  tenantId: string,
  createdAt: string,
  createdBy?: string | null,
  updatedAt?: string | null,
  updatedBy?: string | null,
  fileName: string,
  originalFileName: string,
  path: string,
  downloadUrl?: string | null,
  mimeType: string,
  size: number,
  description?: string | null,
  relatedTable: string,
  relatedItem: string,
  type: string,
};

export type DeleteAttachmentCleanInput = {
  relatedField?: string | null,
};

export type AttachmentUploadBaseData = {
  contentType: string,
  fileName: string,
  size?: number | null,
  relatedTable?: string | null,
  relatedItem?: string | null,
  type?: string | null,
};

export type AttachmentUploadUrlResponse = {
  __typename: "AttachmentUploadUrlResponse",
  data?:  Array<AttachmentUploadUrl | null > | null,
  status?: number | null,
  errors?: Array< string | null > | null,
};

export type AttachmentUploadUrl = {
  __typename: "AttachmentUploadUrl",
  uploadUrl: string,
  uploadName: string,
  originalFileName: string,
};

export type AlertInput = {
  state: AlertState,
};

export enum AlertState {
  new = "new",
  ignored = "ignored",
  processed = "processed",
  resolved = "resolved",
  duplicated = "duplicated",
}


export type AlertResponse = {
  __typename: "AlertResponse",
  data?: Alert | null,
  status?: number | null,
  errors?: Array< string | null > | null,
};

export type Alert = {
  __typename: "Alert",
  id: string,
  number: number,
  displayNumber?: string | null,
  asset?: Asset | null,
  assetId?: string | null,
  daysFailed?: string | null,
  tisStatus?: string | null,
  state: AlertState,
  firstException?: string | null,
  worstException?: string | null,
  lastException?: string | null,
  impactComfort?: string | null,
  impactEnergy?: string | null,
  impactReliability?: string | null,
  testValue?: string | null,
  exceptionName?: string | null,
  suggestionDescription?: string | null,
  suggestionCauses?: string | null,
  workOrder?: WorkOrder | null,
  workOrderId?: string | null,
  finding?: Finding | null,
  findingId?: string | null,
  thirdPartyId?: string | null,
  thirdPartySource?: string | null,
  tenant?: Tenant | null,
  tenantId: string,
  createdAt?: string | null,
  createdBy?: string | null,
  updatedAt?: string | null,
  updatedBy?: string | null,
};

export type DashboardStatsInput = {
  totalAssets?: boolean | null,
  assetsPerLocation?: boolean | null,
  assetsPerCondition?: boolean | null,
  assetsPerType?: boolean | null,
  assetsPerExpenses?: boolean | null,
  totalWorkOrders?: boolean | null,
  workOrdersPerCategory?: boolean | null,
  workOrdersPerPriority?: boolean | null,
  workOrdersPerState?: boolean | null,
  workOrdersPerDueData?: boolean | null,
  workOrdersPerDueDate?: boolean | null,
  totalFindings?: boolean | null,
  findingsPerType?: boolean | null,
  findingsPerPriority?: boolean | null,
  findingsPerAssetModel?: boolean | null,
  workOrdersSLAData?: boolean | null,
};

export type DashboardStatsResponse = {
  __typename: "DashboardStatsResponse",
  status?: number | null,
  data?: DashboardStats | null,
  errors?: Array< string | null > | null,
};

export type DashboardStats = {
  __typename: "DashboardStats",
  totalAssets?: number | null,
  assetsPerLocation?:  Array<DashboardStatsPoint | null > | null,
  assetsPerCondition?:  Array<DashboardStatsPoint | null > | null,
  assetsPerType?:  Array<DashboardStatsPoint | null > | null,
  assetsPerExpenses?:  Array<DashboardStatsPoint | null > | null,
  totalFindings?: number | null,
  findingsPerType?:  Array<DashboardStatsPoint | null > | null,
  findingsPerPriority?:  Array<DashboardStatsPoint | null > | null,
  findingsPerAssetModel?:  Array<DashboardStatsPoint | null > | null,
  all?: WorkOrderStats | null,
  user?: WorkOrderStats | null,
};

export type DashboardStatsPoint = {
  __typename: "DashboardStatsPoint",
  label?: string | null,
  itemCount?: number | null,
  value?: number | null,
  percentage?: number | null,
  filterByValue?: string | null,
};

export type WorkOrderStats = {
  __typename: "WorkOrderStats",
  totalWorkOrders?: number | null,
  workOrdersPerCategory?:  Array<DashboardStatsPoint | null > | null,
  workOrdersPerPriority?:  Array<DashboardStatsPoint | null > | null,
  workOrdersPerState?:  Array<DashboardStatsPoint | null > | null,
  workOrdersPerDueData?:  Array<DashboardStatsPoint | null > | null,
  workOrdersPerDueDate?:  Array<DashboardStatsPoint | null > | null,
  workOrdersSLAData?:  Array<WorkOrdersSLAData | null > | null,
};

export type WorkOrdersSLAData = {
  __typename: "WorkOrdersSLAData",
  key?: string | null,
  warningValue?: number | null,
  thresholdValue?: number | null,
  statsPoints?:  Array<DashboardStatsPoint | null > | null,
};

export type CurrentUserResponse = {
  __typename: "CurrentUserResponse",
  data?: CurrentUserData | null,
  status?: number | null,
  errors?: Array< string | null > | null,
};

export type CurrentUserData = {
  __typename: "CurrentUserData",
  user: User,
  tenants:  Array<UserTenantData >,
  tenantIDs: Array< string >,
};

export type UserTenantData = {
  __typename: "UserTenantData",
  tenant: Tenant,
  role: string,
};

export type AssetListResponse = {
  __typename: "AssetListResponse",
  data?:  Array<Asset | null > | null,
  totalCount?: number | null,
  status?: number | null,
  errors?: Array< string | null > | null,
};

export type AssetPropsCountsResponse = {
  __typename: "AssetPropsCountsResponse",
  data?: AssetPropsCounts | null,
  status?: number | null,
  errors?: Array< string | null > | null,
};

export type AssetPropsCounts = {
  __typename: "AssetPropsCounts",
  assets?: number | null,
  types?: number | null,
  manufacturers?: number | null,
  models?: number | null,
  locations?: number | null,
};

export type AssetRelatedCountsResponse = {
  __typename: "AssetRelatedCountsResponse",
  data?: AssetRelatedCounts | null,
  status?: number | null,
  errors?: Array< string | null > | null,
};

export type AssetRelatedCounts = {
  __typename: "AssetRelatedCounts",
  workOrders?: number | null,
  findings?: number | null,
};

export type WorkOrderPropsCountsResponse = {
  __typename: "WorkOrderPropsCountsResponse",
  data?: WorkOrderPropsCounts | null,
  status?: number | null,
  errors?: Array< string | null > | null,
};

export type WorkOrderPropsCounts = {
  __typename: "WorkOrderPropsCounts",
  workOrders?: number | null,
  templates?: number | null,
};

export type WorkOrderRelatedCountsResponse = {
  __typename: "WorkOrderRelatedCountsResponse",
  data?: WorkOrderRelatedCounts | null,
  status?: number | null,
  errors?: Array< string | null > | null,
};

export type WorkOrderRelatedCounts = {
  __typename: "WorkOrderRelatedCounts",
  expenses?: number | null,
};

export type WorkOrderTemplateListResponse = {
  __typename: "WorkOrderTemplateListResponse",
  data?:  Array<WorkOrderTemplate | null > | null,
  totalCount?: number | null,
  status?: number | null,
  errors?: Array< string | null > | null,
};

export type ManufacturerListResponse = {
  __typename: "ManufacturerListResponse",
  data?:  Array<Manufacturer | null > | null,
  totalCount?: number | null,
  status?: number | null,
  errors?: Array< string | null > | null,
};

export type ModelListResponse = {
  __typename: "ModelListResponse",
  data?:  Array<Model | null > | null,
  totalCount?: number | null,
  status?: number | null,
  errors?: Array< string | null > | null,
};

export type UserQueryListParams = {
  filter?: string | null,
  sortBy?: SortByParams | null,
  skip?: number | null,
  take?: number | null,
  requireTotalCount?: boolean | null,
  accessTo?: AccessTo | null,
};

export type AccessTo = {
  resource: string,
  ids: Array< string | null >,
};

export type UserListResponse = {
  __typename: "UserListResponse",
  data?:  Array<User | null > | null,
  totalCount?: number | null,
  status?: number | null,
  errors?: Array< string | null > | null,
};

export type TenantListResponse = {
  __typename: "TenantListResponse",
  data?:  Array<Tenant | null > | null,
  totalCount?: number | null,
  status?: number | null,
  errors?: Array< string | null > | null,
};

export type LocationListResponse = {
  __typename: "LocationListResponse",
  data?:  Array<Location | null > | null,
  totalCount?: number | null,
  status?: number | null,
  errors?: Array< string | null > | null,
};

export type ExpenseListResponse = {
  __typename: "ExpenseListResponse",
  data?:  Array<Expense | null > | null,
  totalCount?: number | null,
  status?: number | null,
  errors?: Array< string | null > | null,
};

export type AssetTypeListResponse = {
  __typename: "AssetTypeListResponse",
  data?:  Array<AssetType | null > | null,
  totalCount?: number | null,
  status?: number | null,
  errors?: Array< string | null > | null,
};

export type FindingListResponse = {
  __typename: "FindingListResponse",
  data?:  Array<Finding | null > | null,
  totalCount?: number | null,
  status?: number | null,
  errors?: Array< string | null > | null,
};

export type AttachmentListResponse = {
  __typename: "AttachmentListResponse",
  data?:  Array<Attachment | null > | null,
  totalCount?: number | null,
  status?: number | null,
  errors?: Array< string | null > | null,
};

export type AlertListResponse = {
  __typename: "AlertListResponse",
  data?:  Array<Alert | null > | null,
  totalCount?: number | null,
  status?: number | null,
  errors?: Array< string | null > | null,
};

export type ProcessAccountSyncMutationVariables = {
  tisAccountId: string,
};

export type ProcessAccountSyncMutation = {
  processAccountSync?:  {
    __typename: "ProcessAccountSyncResponse",
    data?:  {
      __typename: "ProcessAccountSyncData",
      tenantIDs?: Array< string | null > | null,
      assetsTypeInfo?: number | null,
      modelsInfo?: number | null,
      assetsInfo?:  {
        __typename: "AssetsSyncInfo",
        newAssets?: number | null,
        updatedAssets?: number | null,
      } | null,
      locationInfo?:  {
        __typename: "LocationsSyncInfo",
        newCountries?: number | null,
        newStates?: number | null,
        newCities?: number | null,
        newBuildings?: number | null,
      } | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type SyncTenantListTisDataMutationVariables = {
  tenantIDs: Array< string | null >,
};

export type SyncTenantListTisDataMutation = {
  syncTenantListTisData?:  {
    __typename: "DataSyncResponse",
    data?:  Array< {
      __typename: "ProcessAccountSyncData",
      tenantIDs?: Array< string | null > | null,
      assetsTypeInfo?: number | null,
      modelsInfo?: number | null,
      assetsInfo?:  {
        __typename: "AssetsSyncInfo",
        newAssets?: number | null,
        updatedAssets?: number | null,
      } | null,
      locationInfo?:  {
        __typename: "LocationsSyncInfo",
        newCountries?: number | null,
        newStates?: number | null,
        newCities?: number | null,
        newBuildings?: number | null,
      } | null,
    } | null > | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type FetchCognitoUsersMutationVariables = {
};

export type FetchCognitoUsersMutation = {
  fetchCognitoUsers?:  {
    __typename: "UserCognitoSyncResponse",
    data?: boolean | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type CreateAssetMutationVariables = {
  data: AssetInput,
};

export type CreateAssetMutation = {
  createAsset?:  {
    __typename: "AssetResponse",
    data?:  {
      __typename: "Asset",
      id: string,
      number?: number | null,
      displayNumber?: string | null,
      userId?: string | null,
      assetTag: string,
      description: string,
      makeId: string,
      modelId: string,
      state: string,
      usefulLife?: number | null,
      acquisitionCostValue?: number | null,
      lastMaintenanceDate?: string | null,
      nextScheduledMaintenanceDate?: string | null,
      assignedToId?: string | null,
      assetTypeId: string,
      condition?: string | null,
      maintenanceCostValue?: number | null,
      currentBookValue?: number | null,
      installDate?: string | null,
      decommissionDate?: string | null,
      locationId?: string | null,
      image?: string | null,
      purchaseOrderId?: string | null,
      utilizationData?: string | null,
      reasonForDecommission?: string | null,
      serialNumber: string,
      thirdPartyId?: string | null,
      source?: string | null,
      totalCostOfOwnershipValue?: number | null,
      repairCostValue?: number | null,
      warrantyExpiration?: string | null,
      downTime?: string | null,
      tenantId: string,
      createdAt: string,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      model?:  {
        __typename: "Model",
        id: string,
        tenantId: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        oemPartNumber?: string | null,
        name: string,
        manufacturerId: string,
        assetTypeId: string,
        probability?: number | null,
        severity?: number | null,
        riskScore?: number | null,
        picture?: string | null,
        specification?: string | null,
        usefulLife?: number | null,
        inUseStatus?: InUseStatus | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        manufacturer?:  {
          __typename: "Manufacturer",
          id: string,
          name: string,
          description?: string | null,
          countryId?: string | null,
          website?: string | null,
          contactPerson?: string | null,
          contactEmail?: string | null,
          contactPhone?: string | null,
          address?: string | null,
          warrantyPolicies?: string | null,
          slaDetails?: string | null,
          vendorPortalLink?: string | null,
          createdAt: string,
          createdBy: string,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          inUseStatus?: InUseStatus | null,
        } | null,
        assetType?:  {
          __typename: "AssetType",
          id: string,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          name: string,
          description?: string | null,
          category?: string | null,
          criticalityLevel?: number | null,
          expectedUsefulLife?: number | null,
          defaultWarrantyPeriod?: number | null,
          defaultRiskScore?: number | null,
          manufacturerRecommendations?: string | null,
          image?: string | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          inUseStatus?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      assetType?:  {
        __typename: "AssetType",
        id: string,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt: string,
        createdBy?: string | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        name: string,
        description?: string | null,
        category?: string | null,
        criticalityLevel?: number | null,
        expectedUsefulLife?: number | null,
        defaultWarrantyPeriod?: number | null,
        defaultRiskScore?: number | null,
        manufacturerRecommendations?: string | null,
        image?: string | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        inUseStatus?: string | null,
      } | null,
      manufacturer?:  {
        __typename: "Manufacturer",
        id: string,
        name: string,
        description?: string | null,
        countryId?: string | null,
        website?: string | null,
        contactPerson?: string | null,
        contactEmail?: string | null,
        contactPhone?: string | null,
        address?: string | null,
        warrantyPolicies?: string | null,
        slaDetails?: string | null,
        vendorPortalLink?: string | null,
        createdAt: string,
        createdBy: string,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        inUseStatus?: InUseStatus | null,
      } | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      woCount?: number | null,
      findingsCount?: number | null,
      user?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      assetRisk?: number | null,
      location?:  {
        __typename: "Location",
        id: string,
        tenantId: string,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        notes?: string | null,
        lat?: number | null,
        lng?: number | null,
        level?: string | null,
        parentId?: string | null,
        rootId?: string | null,
        thirdPartyId?: string | null,
        source?: string | null,
        inUseStatus?: InUseStatus | null,
        address?: string | null,
        buildingAddress?: string | null,
        parent?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        tisSyncedAt?: string | null,
      } | null,
      isParent?: boolean | null,
      thirdPartyParentId?: string | null,
      thirdPartyHierarchyPath?: Array< string | null > | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type UpdateAssetMutationVariables = {
  id: string,
  data: AssetInput,
};

export type UpdateAssetMutation = {
  updateAsset?:  {
    __typename: "AssetResponse",
    data?:  {
      __typename: "Asset",
      id: string,
      number?: number | null,
      displayNumber?: string | null,
      userId?: string | null,
      assetTag: string,
      description: string,
      makeId: string,
      modelId: string,
      state: string,
      usefulLife?: number | null,
      acquisitionCostValue?: number | null,
      lastMaintenanceDate?: string | null,
      nextScheduledMaintenanceDate?: string | null,
      assignedToId?: string | null,
      assetTypeId: string,
      condition?: string | null,
      maintenanceCostValue?: number | null,
      currentBookValue?: number | null,
      installDate?: string | null,
      decommissionDate?: string | null,
      locationId?: string | null,
      image?: string | null,
      purchaseOrderId?: string | null,
      utilizationData?: string | null,
      reasonForDecommission?: string | null,
      serialNumber: string,
      thirdPartyId?: string | null,
      source?: string | null,
      totalCostOfOwnershipValue?: number | null,
      repairCostValue?: number | null,
      warrantyExpiration?: string | null,
      downTime?: string | null,
      tenantId: string,
      createdAt: string,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      model?:  {
        __typename: "Model",
        id: string,
        tenantId: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        oemPartNumber?: string | null,
        name: string,
        manufacturerId: string,
        assetTypeId: string,
        probability?: number | null,
        severity?: number | null,
        riskScore?: number | null,
        picture?: string | null,
        specification?: string | null,
        usefulLife?: number | null,
        inUseStatus?: InUseStatus | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        manufacturer?:  {
          __typename: "Manufacturer",
          id: string,
          name: string,
          description?: string | null,
          countryId?: string | null,
          website?: string | null,
          contactPerson?: string | null,
          contactEmail?: string | null,
          contactPhone?: string | null,
          address?: string | null,
          warrantyPolicies?: string | null,
          slaDetails?: string | null,
          vendorPortalLink?: string | null,
          createdAt: string,
          createdBy: string,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          inUseStatus?: InUseStatus | null,
        } | null,
        assetType?:  {
          __typename: "AssetType",
          id: string,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          name: string,
          description?: string | null,
          category?: string | null,
          criticalityLevel?: number | null,
          expectedUsefulLife?: number | null,
          defaultWarrantyPeriod?: number | null,
          defaultRiskScore?: number | null,
          manufacturerRecommendations?: string | null,
          image?: string | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          inUseStatus?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      assetType?:  {
        __typename: "AssetType",
        id: string,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt: string,
        createdBy?: string | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        name: string,
        description?: string | null,
        category?: string | null,
        criticalityLevel?: number | null,
        expectedUsefulLife?: number | null,
        defaultWarrantyPeriod?: number | null,
        defaultRiskScore?: number | null,
        manufacturerRecommendations?: string | null,
        image?: string | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        inUseStatus?: string | null,
      } | null,
      manufacturer?:  {
        __typename: "Manufacturer",
        id: string,
        name: string,
        description?: string | null,
        countryId?: string | null,
        website?: string | null,
        contactPerson?: string | null,
        contactEmail?: string | null,
        contactPhone?: string | null,
        address?: string | null,
        warrantyPolicies?: string | null,
        slaDetails?: string | null,
        vendorPortalLink?: string | null,
        createdAt: string,
        createdBy: string,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        inUseStatus?: InUseStatus | null,
      } | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      woCount?: number | null,
      findingsCount?: number | null,
      user?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      assetRisk?: number | null,
      location?:  {
        __typename: "Location",
        id: string,
        tenantId: string,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        notes?: string | null,
        lat?: number | null,
        lng?: number | null,
        level?: string | null,
        parentId?: string | null,
        rootId?: string | null,
        thirdPartyId?: string | null,
        source?: string | null,
        inUseStatus?: InUseStatus | null,
        address?: string | null,
        buildingAddress?: string | null,
        parent?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        tisSyncedAt?: string | null,
      } | null,
      isParent?: boolean | null,
      thirdPartyParentId?: string | null,
      thirdPartyHierarchyPath?: Array< string | null > | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type DeleteAssetMutationVariables = {
  id: string,
};

export type DeleteAssetMutation = {
  deleteAsset?:  {
    __typename: "AssetResponse",
    data?:  {
      __typename: "Asset",
      id: string,
      number?: number | null,
      displayNumber?: string | null,
      userId?: string | null,
      assetTag: string,
      description: string,
      makeId: string,
      modelId: string,
      state: string,
      usefulLife?: number | null,
      acquisitionCostValue?: number | null,
      lastMaintenanceDate?: string | null,
      nextScheduledMaintenanceDate?: string | null,
      assignedToId?: string | null,
      assetTypeId: string,
      condition?: string | null,
      maintenanceCostValue?: number | null,
      currentBookValue?: number | null,
      installDate?: string | null,
      decommissionDate?: string | null,
      locationId?: string | null,
      image?: string | null,
      purchaseOrderId?: string | null,
      utilizationData?: string | null,
      reasonForDecommission?: string | null,
      serialNumber: string,
      thirdPartyId?: string | null,
      source?: string | null,
      totalCostOfOwnershipValue?: number | null,
      repairCostValue?: number | null,
      warrantyExpiration?: string | null,
      downTime?: string | null,
      tenantId: string,
      createdAt: string,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      model?:  {
        __typename: "Model",
        id: string,
        tenantId: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        oemPartNumber?: string | null,
        name: string,
        manufacturerId: string,
        assetTypeId: string,
        probability?: number | null,
        severity?: number | null,
        riskScore?: number | null,
        picture?: string | null,
        specification?: string | null,
        usefulLife?: number | null,
        inUseStatus?: InUseStatus | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        manufacturer?:  {
          __typename: "Manufacturer",
          id: string,
          name: string,
          description?: string | null,
          countryId?: string | null,
          website?: string | null,
          contactPerson?: string | null,
          contactEmail?: string | null,
          contactPhone?: string | null,
          address?: string | null,
          warrantyPolicies?: string | null,
          slaDetails?: string | null,
          vendorPortalLink?: string | null,
          createdAt: string,
          createdBy: string,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          inUseStatus?: InUseStatus | null,
        } | null,
        assetType?:  {
          __typename: "AssetType",
          id: string,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          name: string,
          description?: string | null,
          category?: string | null,
          criticalityLevel?: number | null,
          expectedUsefulLife?: number | null,
          defaultWarrantyPeriod?: number | null,
          defaultRiskScore?: number | null,
          manufacturerRecommendations?: string | null,
          image?: string | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          inUseStatus?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      assetType?:  {
        __typename: "AssetType",
        id: string,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt: string,
        createdBy?: string | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        name: string,
        description?: string | null,
        category?: string | null,
        criticalityLevel?: number | null,
        expectedUsefulLife?: number | null,
        defaultWarrantyPeriod?: number | null,
        defaultRiskScore?: number | null,
        manufacturerRecommendations?: string | null,
        image?: string | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        inUseStatus?: string | null,
      } | null,
      manufacturer?:  {
        __typename: "Manufacturer",
        id: string,
        name: string,
        description?: string | null,
        countryId?: string | null,
        website?: string | null,
        contactPerson?: string | null,
        contactEmail?: string | null,
        contactPhone?: string | null,
        address?: string | null,
        warrantyPolicies?: string | null,
        slaDetails?: string | null,
        vendorPortalLink?: string | null,
        createdAt: string,
        createdBy: string,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        inUseStatus?: InUseStatus | null,
      } | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      woCount?: number | null,
      findingsCount?: number | null,
      user?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      assetRisk?: number | null,
      location?:  {
        __typename: "Location",
        id: string,
        tenantId: string,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        notes?: string | null,
        lat?: number | null,
        lng?: number | null,
        level?: string | null,
        parentId?: string | null,
        rootId?: string | null,
        thirdPartyId?: string | null,
        source?: string | null,
        inUseStatus?: InUseStatus | null,
        address?: string | null,
        buildingAddress?: string | null,
        parent?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        tisSyncedAt?: string | null,
      } | null,
      isParent?: boolean | null,
      thirdPartyParentId?: string | null,
      thirdPartyHierarchyPath?: Array< string | null > | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type SeeWorkOrderAsUserMutationVariables = {
  workOrderId: string,
};

export type SeeWorkOrderAsUserMutation = {
  seeWorkOrderAsUser?:  {
    __typename: "SeeWorkOrderAsUserResponse",
    data?: boolean | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type CreateWorkOrderMutationVariables = {
  data: WorkOrderInput,
};

export type CreateWorkOrderMutation = {
  createWorkOrder?:  {
    __typename: "WorkOrderResponse",
    data?:  {
      __typename: "WorkOrder",
      id?: string | null,
      displayNumber?: string | null,
      tenantId?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      createdAt?: string | null,
      createdBy?: string | null,
      createdByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      updatedByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      number?: number | null,
      userId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      locationId?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        tenantId: string,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        notes?: string | null,
        lat?: number | null,
        lng?: number | null,
        level?: string | null,
        parentId?: string | null,
        rootId?: string | null,
        thirdPartyId?: string | null,
        source?: string | null,
        inUseStatus?: InUseStatus | null,
        address?: string | null,
        buildingAddress?: string | null,
        parent?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        tisSyncedAt?: string | null,
      } | null,
      dueDate?: string | null,
      startDate?: string | null,
      endDate?: string | null,
      duration?: string | null,
      plannedStartDate?: string | null,
      plannedEndDate?: string | null,
      assetId?: string | null,
      asset?:  {
        __typename: "Asset",
        id: string,
        number?: number | null,
        displayNumber?: string | null,
        userId?: string | null,
        assetTag: string,
        description: string,
        makeId: string,
        modelId: string,
        state: string,
        usefulLife?: number | null,
        acquisitionCostValue?: number | null,
        lastMaintenanceDate?: string | null,
        nextScheduledMaintenanceDate?: string | null,
        assignedToId?: string | null,
        assetTypeId: string,
        condition?: string | null,
        maintenanceCostValue?: number | null,
        currentBookValue?: number | null,
        installDate?: string | null,
        decommissionDate?: string | null,
        locationId?: string | null,
        image?: string | null,
        purchaseOrderId?: string | null,
        utilizationData?: string | null,
        reasonForDecommission?: string | null,
        serialNumber: string,
        thirdPartyId?: string | null,
        source?: string | null,
        totalCostOfOwnershipValue?: number | null,
        repairCostValue?: number | null,
        warrantyExpiration?: string | null,
        downTime?: string | null,
        tenantId: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        model?:  {
          __typename: "Model",
          id: string,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          oemPartNumber?: string | null,
          name: string,
          manufacturerId: string,
          assetTypeId: string,
          probability?: number | null,
          severity?: number | null,
          riskScore?: number | null,
          picture?: string | null,
          specification?: string | null,
          usefulLife?: number | null,
          inUseStatus?: InUseStatus | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        assetType?:  {
          __typename: "AssetType",
          id: string,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          name: string,
          description?: string | null,
          category?: string | null,
          criticalityLevel?: number | null,
          expectedUsefulLife?: number | null,
          defaultWarrantyPeriod?: number | null,
          defaultRiskScore?: number | null,
          manufacturerRecommendations?: string | null,
          image?: string | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          inUseStatus?: string | null,
        } | null,
        manufacturer?:  {
          __typename: "Manufacturer",
          id: string,
          name: string,
          description?: string | null,
          countryId?: string | null,
          website?: string | null,
          contactPerson?: string | null,
          contactEmail?: string | null,
          contactPhone?: string | null,
          address?: string | null,
          warrantyPolicies?: string | null,
          slaDetails?: string | null,
          vendorPortalLink?: string | null,
          createdAt: string,
          createdBy: string,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          inUseStatus?: InUseStatus | null,
        } | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        woCount?: number | null,
        findingsCount?: number | null,
        user?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        assetRisk?: number | null,
        location?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        isParent?: boolean | null,
        thirdPartyParentId?: string | null,
        thirdPartyHierarchyPath?: Array< string | null > | null,
      } | null,
      assignmentGroupId?: string | null,
      assignedToId?: string | null,
      assignedTo?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      businessDownTime?: number | null,
      downTimeStart?: string | null,
      downTimeEnd?: string | null,
      category?: string | null,
      checklist?: string | null,
      closedNotes?: string | null,
      closedAt?: string | null,
      closedById?: string | null,
      closedBy?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      notes?: string | null,
      title?: string | null,
      description?: string | null,
      estimatedCostValue?: number | null,
      actualCostValue?: number | null,
      estimatedEffort?: number | null,
      actualEffort?: number | null,
      expectedOperationalDate?: string | null,
      impact?: number | null,
      priority?: number | null,
      dependsOnWorkOrderId?: string | null,
      dependsOnWorkOrder?:  {
        __typename: "WorkOrder",
        id?: string | null,
        displayNumber?: string | null,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt?: string | null,
        createdBy?: string | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        number?: number | null,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        locationId?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        dueDate?: string | null,
        startDate?: string | null,
        endDate?: string | null,
        duration?: string | null,
        plannedStartDate?: string | null,
        plannedEndDate?: string | null,
        assetId?: string | null,
        asset?:  {
          __typename: "Asset",
          id: string,
          number?: number | null,
          displayNumber?: string | null,
          userId?: string | null,
          assetTag: string,
          description: string,
          makeId: string,
          modelId: string,
          state: string,
          usefulLife?: number | null,
          acquisitionCostValue?: number | null,
          lastMaintenanceDate?: string | null,
          nextScheduledMaintenanceDate?: string | null,
          assignedToId?: string | null,
          assetTypeId: string,
          condition?: string | null,
          maintenanceCostValue?: number | null,
          currentBookValue?: number | null,
          installDate?: string | null,
          decommissionDate?: string | null,
          locationId?: string | null,
          image?: string | null,
          purchaseOrderId?: string | null,
          utilizationData?: string | null,
          reasonForDecommission?: string | null,
          serialNumber: string,
          thirdPartyId?: string | null,
          source?: string | null,
          totalCostOfOwnershipValue?: number | null,
          repairCostValue?: number | null,
          warrantyExpiration?: string | null,
          downTime?: string | null,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          model?:  {
            __typename: "Model",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            oemPartNumber?: string | null,
            name: string,
            manufacturerId: string,
            assetTypeId: string,
            probability?: number | null,
            severity?: number | null,
            riskScore?: number | null,
            picture?: string | null,
            specification?: string | null,
            usefulLife?: number | null,
            inUseStatus?: InUseStatus | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          woCount?: number | null,
          findingsCount?: number | null,
          user?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          assetRisk?: number | null,
          location?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          isParent?: boolean | null,
          thirdPartyParentId?: string | null,
          thirdPartyHierarchyPath?: Array< string | null > | null,
        } | null,
        assignmentGroupId?: string | null,
        assignedToId?: string | null,
        assignedTo?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        businessDownTime?: number | null,
        downTimeStart?: string | null,
        downTimeEnd?: string | null,
        category?: string | null,
        checklist?: string | null,
        closedNotes?: string | null,
        closedAt?: string | null,
        closedById?: string | null,
        closedBy?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        notes?: string | null,
        title?: string | null,
        description?: string | null,
        estimatedCostValue?: number | null,
        actualCostValue?: number | null,
        estimatedEffort?: number | null,
        actualEffort?: number | null,
        expectedOperationalDate?: string | null,
        impact?: number | null,
        priority?: number | null,
        dependsOnWorkOrderId?: string | null,
        dependsOnWorkOrder?:  {
          __typename: "WorkOrder",
          id?: string | null,
          displayNumber?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt?: string | null,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          number?: number | null,
          userId?: string | null,
          user?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          locationId?: string | null,
          location?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          dueDate?: string | null,
          startDate?: string | null,
          endDate?: string | null,
          duration?: string | null,
          plannedStartDate?: string | null,
          plannedEndDate?: string | null,
          assetId?: string | null,
          asset?:  {
            __typename: "Asset",
            id: string,
            number?: number | null,
            displayNumber?: string | null,
            userId?: string | null,
            assetTag: string,
            description: string,
            makeId: string,
            modelId: string,
            state: string,
            usefulLife?: number | null,
            acquisitionCostValue?: number | null,
            lastMaintenanceDate?: string | null,
            nextScheduledMaintenanceDate?: string | null,
            assignedToId?: string | null,
            assetTypeId: string,
            condition?: string | null,
            maintenanceCostValue?: number | null,
            currentBookValue?: number | null,
            installDate?: string | null,
            decommissionDate?: string | null,
            locationId?: string | null,
            image?: string | null,
            purchaseOrderId?: string | null,
            utilizationData?: string | null,
            reasonForDecommission?: string | null,
            serialNumber: string,
            thirdPartyId?: string | null,
            source?: string | null,
            totalCostOfOwnershipValue?: number | null,
            repairCostValue?: number | null,
            warrantyExpiration?: string | null,
            downTime?: string | null,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            woCount?: number | null,
            findingsCount?: number | null,
            assetRisk?: number | null,
            isParent?: boolean | null,
            thirdPartyParentId?: string | null,
            thirdPartyHierarchyPath?: Array< string | null > | null,
          } | null,
          assignmentGroupId?: string | null,
          assignedToId?: string | null,
          assignedTo?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          businessDownTime?: number | null,
          downTimeStart?: string | null,
          downTimeEnd?: string | null,
          category?: string | null,
          checklist?: string | null,
          closedNotes?: string | null,
          closedAt?: string | null,
          closedById?: string | null,
          closedBy?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          notes?: string | null,
          title?: string | null,
          description?: string | null,
          estimatedCostValue?: number | null,
          actualCostValue?: number | null,
          estimatedEffort?: number | null,
          actualEffort?: number | null,
          expectedOperationalDate?: string | null,
          impact?: number | null,
          priority?: number | null,
          dependsOnWorkOrderId?: string | null,
          dependsOnWorkOrder?:  {
            __typename: "WorkOrder",
            id?: string | null,
            displayNumber?: string | null,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            number?: number | null,
            userId?: string | null,
            locationId?: string | null,
            dueDate?: string | null,
            startDate?: string | null,
            endDate?: string | null,
            duration?: string | null,
            plannedStartDate?: string | null,
            plannedEndDate?: string | null,
            assetId?: string | null,
            assignmentGroupId?: string | null,
            assignedToId?: string | null,
            businessDownTime?: number | null,
            downTimeStart?: string | null,
            downTimeEnd?: string | null,
            category?: string | null,
            checklist?: string | null,
            closedNotes?: string | null,
            closedAt?: string | null,
            closedById?: string | null,
            notes?: string | null,
            title?: string | null,
            description?: string | null,
            estimatedCostValue?: number | null,
            actualCostValue?: number | null,
            estimatedEffort?: number | null,
            actualEffort?: number | null,
            expectedOperationalDate?: string | null,
            impact?: number | null,
            priority?: number | null,
            dependsOnWorkOrderId?: string | null,
            state?: string | null,
            type?: string | null,
            templateId?: string | null,
            isArchived?: boolean | null,
            findingId?: string | null,
            seenByAssignee?: boolean | null,
            assignmentDateTime?: string | null,
            seenDateTime?: string | null,
            startOfWorkDateTime?: string | null,
            endOfWorkDateTime?: string | null,
          } | null,
          state?: string | null,
          type?: string | null,
          templateId?: string | null,
          isArchived?: boolean | null,
          findingId?: string | null,
          seenByAssignee?: boolean | null,
          assignmentDateTime?: string | null,
          seenDateTime?: string | null,
          startOfWorkDateTime?: string | null,
          endOfWorkDateTime?: string | null,
        } | null,
        state?: string | null,
        type?: string | null,
        templateId?: string | null,
        isArchived?: boolean | null,
        findingId?: string | null,
        seenByAssignee?: boolean | null,
        assignmentDateTime?: string | null,
        seenDateTime?: string | null,
        startOfWorkDateTime?: string | null,
        endOfWorkDateTime?: string | null,
      } | null,
      state?: string | null,
      type?: string | null,
      templateId?: string | null,
      isArchived?: boolean | null,
      findingId?: string | null,
      seenByAssignee?: boolean | null,
      assignmentDateTime?: string | null,
      seenDateTime?: string | null,
      startOfWorkDateTime?: string | null,
      endOfWorkDateTime?: string | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type UpdateWorkOrderMutationVariables = {
  id: string,
  data: WorkOrderInput,
};

export type UpdateWorkOrderMutation = {
  updateWorkOrder?:  {
    __typename: "WorkOrderResponse",
    data?:  {
      __typename: "WorkOrder",
      id?: string | null,
      displayNumber?: string | null,
      tenantId?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      createdAt?: string | null,
      createdBy?: string | null,
      createdByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      updatedByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      number?: number | null,
      userId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      locationId?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        tenantId: string,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        notes?: string | null,
        lat?: number | null,
        lng?: number | null,
        level?: string | null,
        parentId?: string | null,
        rootId?: string | null,
        thirdPartyId?: string | null,
        source?: string | null,
        inUseStatus?: InUseStatus | null,
        address?: string | null,
        buildingAddress?: string | null,
        parent?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        tisSyncedAt?: string | null,
      } | null,
      dueDate?: string | null,
      startDate?: string | null,
      endDate?: string | null,
      duration?: string | null,
      plannedStartDate?: string | null,
      plannedEndDate?: string | null,
      assetId?: string | null,
      asset?:  {
        __typename: "Asset",
        id: string,
        number?: number | null,
        displayNumber?: string | null,
        userId?: string | null,
        assetTag: string,
        description: string,
        makeId: string,
        modelId: string,
        state: string,
        usefulLife?: number | null,
        acquisitionCostValue?: number | null,
        lastMaintenanceDate?: string | null,
        nextScheduledMaintenanceDate?: string | null,
        assignedToId?: string | null,
        assetTypeId: string,
        condition?: string | null,
        maintenanceCostValue?: number | null,
        currentBookValue?: number | null,
        installDate?: string | null,
        decommissionDate?: string | null,
        locationId?: string | null,
        image?: string | null,
        purchaseOrderId?: string | null,
        utilizationData?: string | null,
        reasonForDecommission?: string | null,
        serialNumber: string,
        thirdPartyId?: string | null,
        source?: string | null,
        totalCostOfOwnershipValue?: number | null,
        repairCostValue?: number | null,
        warrantyExpiration?: string | null,
        downTime?: string | null,
        tenantId: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        model?:  {
          __typename: "Model",
          id: string,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          oemPartNumber?: string | null,
          name: string,
          manufacturerId: string,
          assetTypeId: string,
          probability?: number | null,
          severity?: number | null,
          riskScore?: number | null,
          picture?: string | null,
          specification?: string | null,
          usefulLife?: number | null,
          inUseStatus?: InUseStatus | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        assetType?:  {
          __typename: "AssetType",
          id: string,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          name: string,
          description?: string | null,
          category?: string | null,
          criticalityLevel?: number | null,
          expectedUsefulLife?: number | null,
          defaultWarrantyPeriod?: number | null,
          defaultRiskScore?: number | null,
          manufacturerRecommendations?: string | null,
          image?: string | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          inUseStatus?: string | null,
        } | null,
        manufacturer?:  {
          __typename: "Manufacturer",
          id: string,
          name: string,
          description?: string | null,
          countryId?: string | null,
          website?: string | null,
          contactPerson?: string | null,
          contactEmail?: string | null,
          contactPhone?: string | null,
          address?: string | null,
          warrantyPolicies?: string | null,
          slaDetails?: string | null,
          vendorPortalLink?: string | null,
          createdAt: string,
          createdBy: string,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          inUseStatus?: InUseStatus | null,
        } | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        woCount?: number | null,
        findingsCount?: number | null,
        user?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        assetRisk?: number | null,
        location?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        isParent?: boolean | null,
        thirdPartyParentId?: string | null,
        thirdPartyHierarchyPath?: Array< string | null > | null,
      } | null,
      assignmentGroupId?: string | null,
      assignedToId?: string | null,
      assignedTo?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      businessDownTime?: number | null,
      downTimeStart?: string | null,
      downTimeEnd?: string | null,
      category?: string | null,
      checklist?: string | null,
      closedNotes?: string | null,
      closedAt?: string | null,
      closedById?: string | null,
      closedBy?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      notes?: string | null,
      title?: string | null,
      description?: string | null,
      estimatedCostValue?: number | null,
      actualCostValue?: number | null,
      estimatedEffort?: number | null,
      actualEffort?: number | null,
      expectedOperationalDate?: string | null,
      impact?: number | null,
      priority?: number | null,
      dependsOnWorkOrderId?: string | null,
      dependsOnWorkOrder?:  {
        __typename: "WorkOrder",
        id?: string | null,
        displayNumber?: string | null,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt?: string | null,
        createdBy?: string | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        number?: number | null,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        locationId?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        dueDate?: string | null,
        startDate?: string | null,
        endDate?: string | null,
        duration?: string | null,
        plannedStartDate?: string | null,
        plannedEndDate?: string | null,
        assetId?: string | null,
        asset?:  {
          __typename: "Asset",
          id: string,
          number?: number | null,
          displayNumber?: string | null,
          userId?: string | null,
          assetTag: string,
          description: string,
          makeId: string,
          modelId: string,
          state: string,
          usefulLife?: number | null,
          acquisitionCostValue?: number | null,
          lastMaintenanceDate?: string | null,
          nextScheduledMaintenanceDate?: string | null,
          assignedToId?: string | null,
          assetTypeId: string,
          condition?: string | null,
          maintenanceCostValue?: number | null,
          currentBookValue?: number | null,
          installDate?: string | null,
          decommissionDate?: string | null,
          locationId?: string | null,
          image?: string | null,
          purchaseOrderId?: string | null,
          utilizationData?: string | null,
          reasonForDecommission?: string | null,
          serialNumber: string,
          thirdPartyId?: string | null,
          source?: string | null,
          totalCostOfOwnershipValue?: number | null,
          repairCostValue?: number | null,
          warrantyExpiration?: string | null,
          downTime?: string | null,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          model?:  {
            __typename: "Model",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            oemPartNumber?: string | null,
            name: string,
            manufacturerId: string,
            assetTypeId: string,
            probability?: number | null,
            severity?: number | null,
            riskScore?: number | null,
            picture?: string | null,
            specification?: string | null,
            usefulLife?: number | null,
            inUseStatus?: InUseStatus | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          woCount?: number | null,
          findingsCount?: number | null,
          user?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          assetRisk?: number | null,
          location?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          isParent?: boolean | null,
          thirdPartyParentId?: string | null,
          thirdPartyHierarchyPath?: Array< string | null > | null,
        } | null,
        assignmentGroupId?: string | null,
        assignedToId?: string | null,
        assignedTo?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        businessDownTime?: number | null,
        downTimeStart?: string | null,
        downTimeEnd?: string | null,
        category?: string | null,
        checklist?: string | null,
        closedNotes?: string | null,
        closedAt?: string | null,
        closedById?: string | null,
        closedBy?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        notes?: string | null,
        title?: string | null,
        description?: string | null,
        estimatedCostValue?: number | null,
        actualCostValue?: number | null,
        estimatedEffort?: number | null,
        actualEffort?: number | null,
        expectedOperationalDate?: string | null,
        impact?: number | null,
        priority?: number | null,
        dependsOnWorkOrderId?: string | null,
        dependsOnWorkOrder?:  {
          __typename: "WorkOrder",
          id?: string | null,
          displayNumber?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt?: string | null,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          number?: number | null,
          userId?: string | null,
          user?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          locationId?: string | null,
          location?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          dueDate?: string | null,
          startDate?: string | null,
          endDate?: string | null,
          duration?: string | null,
          plannedStartDate?: string | null,
          plannedEndDate?: string | null,
          assetId?: string | null,
          asset?:  {
            __typename: "Asset",
            id: string,
            number?: number | null,
            displayNumber?: string | null,
            userId?: string | null,
            assetTag: string,
            description: string,
            makeId: string,
            modelId: string,
            state: string,
            usefulLife?: number | null,
            acquisitionCostValue?: number | null,
            lastMaintenanceDate?: string | null,
            nextScheduledMaintenanceDate?: string | null,
            assignedToId?: string | null,
            assetTypeId: string,
            condition?: string | null,
            maintenanceCostValue?: number | null,
            currentBookValue?: number | null,
            installDate?: string | null,
            decommissionDate?: string | null,
            locationId?: string | null,
            image?: string | null,
            purchaseOrderId?: string | null,
            utilizationData?: string | null,
            reasonForDecommission?: string | null,
            serialNumber: string,
            thirdPartyId?: string | null,
            source?: string | null,
            totalCostOfOwnershipValue?: number | null,
            repairCostValue?: number | null,
            warrantyExpiration?: string | null,
            downTime?: string | null,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            woCount?: number | null,
            findingsCount?: number | null,
            assetRisk?: number | null,
            isParent?: boolean | null,
            thirdPartyParentId?: string | null,
            thirdPartyHierarchyPath?: Array< string | null > | null,
          } | null,
          assignmentGroupId?: string | null,
          assignedToId?: string | null,
          assignedTo?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          businessDownTime?: number | null,
          downTimeStart?: string | null,
          downTimeEnd?: string | null,
          category?: string | null,
          checklist?: string | null,
          closedNotes?: string | null,
          closedAt?: string | null,
          closedById?: string | null,
          closedBy?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          notes?: string | null,
          title?: string | null,
          description?: string | null,
          estimatedCostValue?: number | null,
          actualCostValue?: number | null,
          estimatedEffort?: number | null,
          actualEffort?: number | null,
          expectedOperationalDate?: string | null,
          impact?: number | null,
          priority?: number | null,
          dependsOnWorkOrderId?: string | null,
          dependsOnWorkOrder?:  {
            __typename: "WorkOrder",
            id?: string | null,
            displayNumber?: string | null,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            number?: number | null,
            userId?: string | null,
            locationId?: string | null,
            dueDate?: string | null,
            startDate?: string | null,
            endDate?: string | null,
            duration?: string | null,
            plannedStartDate?: string | null,
            plannedEndDate?: string | null,
            assetId?: string | null,
            assignmentGroupId?: string | null,
            assignedToId?: string | null,
            businessDownTime?: number | null,
            downTimeStart?: string | null,
            downTimeEnd?: string | null,
            category?: string | null,
            checklist?: string | null,
            closedNotes?: string | null,
            closedAt?: string | null,
            closedById?: string | null,
            notes?: string | null,
            title?: string | null,
            description?: string | null,
            estimatedCostValue?: number | null,
            actualCostValue?: number | null,
            estimatedEffort?: number | null,
            actualEffort?: number | null,
            expectedOperationalDate?: string | null,
            impact?: number | null,
            priority?: number | null,
            dependsOnWorkOrderId?: string | null,
            state?: string | null,
            type?: string | null,
            templateId?: string | null,
            isArchived?: boolean | null,
            findingId?: string | null,
            seenByAssignee?: boolean | null,
            assignmentDateTime?: string | null,
            seenDateTime?: string | null,
            startOfWorkDateTime?: string | null,
            endOfWorkDateTime?: string | null,
          } | null,
          state?: string | null,
          type?: string | null,
          templateId?: string | null,
          isArchived?: boolean | null,
          findingId?: string | null,
          seenByAssignee?: boolean | null,
          assignmentDateTime?: string | null,
          seenDateTime?: string | null,
          startOfWorkDateTime?: string | null,
          endOfWorkDateTime?: string | null,
        } | null,
        state?: string | null,
        type?: string | null,
        templateId?: string | null,
        isArchived?: boolean | null,
        findingId?: string | null,
        seenByAssignee?: boolean | null,
        assignmentDateTime?: string | null,
        seenDateTime?: string | null,
        startOfWorkDateTime?: string | null,
        endOfWorkDateTime?: string | null,
      } | null,
      state?: string | null,
      type?: string | null,
      templateId?: string | null,
      isArchived?: boolean | null,
      findingId?: string | null,
      seenByAssignee?: boolean | null,
      assignmentDateTime?: string | null,
      seenDateTime?: string | null,
      startOfWorkDateTime?: string | null,
      endOfWorkDateTime?: string | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type DeleteWorkOrderMutationVariables = {
  id: string,
};

export type DeleteWorkOrderMutation = {
  deleteWorkOrder?:  {
    __typename: "WorkOrderResponse",
    data?:  {
      __typename: "WorkOrder",
      id?: string | null,
      displayNumber?: string | null,
      tenantId?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      createdAt?: string | null,
      createdBy?: string | null,
      createdByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      updatedByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      number?: number | null,
      userId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      locationId?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        tenantId: string,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        notes?: string | null,
        lat?: number | null,
        lng?: number | null,
        level?: string | null,
        parentId?: string | null,
        rootId?: string | null,
        thirdPartyId?: string | null,
        source?: string | null,
        inUseStatus?: InUseStatus | null,
        address?: string | null,
        buildingAddress?: string | null,
        parent?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        tisSyncedAt?: string | null,
      } | null,
      dueDate?: string | null,
      startDate?: string | null,
      endDate?: string | null,
      duration?: string | null,
      plannedStartDate?: string | null,
      plannedEndDate?: string | null,
      assetId?: string | null,
      asset?:  {
        __typename: "Asset",
        id: string,
        number?: number | null,
        displayNumber?: string | null,
        userId?: string | null,
        assetTag: string,
        description: string,
        makeId: string,
        modelId: string,
        state: string,
        usefulLife?: number | null,
        acquisitionCostValue?: number | null,
        lastMaintenanceDate?: string | null,
        nextScheduledMaintenanceDate?: string | null,
        assignedToId?: string | null,
        assetTypeId: string,
        condition?: string | null,
        maintenanceCostValue?: number | null,
        currentBookValue?: number | null,
        installDate?: string | null,
        decommissionDate?: string | null,
        locationId?: string | null,
        image?: string | null,
        purchaseOrderId?: string | null,
        utilizationData?: string | null,
        reasonForDecommission?: string | null,
        serialNumber: string,
        thirdPartyId?: string | null,
        source?: string | null,
        totalCostOfOwnershipValue?: number | null,
        repairCostValue?: number | null,
        warrantyExpiration?: string | null,
        downTime?: string | null,
        tenantId: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        model?:  {
          __typename: "Model",
          id: string,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          oemPartNumber?: string | null,
          name: string,
          manufacturerId: string,
          assetTypeId: string,
          probability?: number | null,
          severity?: number | null,
          riskScore?: number | null,
          picture?: string | null,
          specification?: string | null,
          usefulLife?: number | null,
          inUseStatus?: InUseStatus | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        assetType?:  {
          __typename: "AssetType",
          id: string,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          name: string,
          description?: string | null,
          category?: string | null,
          criticalityLevel?: number | null,
          expectedUsefulLife?: number | null,
          defaultWarrantyPeriod?: number | null,
          defaultRiskScore?: number | null,
          manufacturerRecommendations?: string | null,
          image?: string | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          inUseStatus?: string | null,
        } | null,
        manufacturer?:  {
          __typename: "Manufacturer",
          id: string,
          name: string,
          description?: string | null,
          countryId?: string | null,
          website?: string | null,
          contactPerson?: string | null,
          contactEmail?: string | null,
          contactPhone?: string | null,
          address?: string | null,
          warrantyPolicies?: string | null,
          slaDetails?: string | null,
          vendorPortalLink?: string | null,
          createdAt: string,
          createdBy: string,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          inUseStatus?: InUseStatus | null,
        } | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        woCount?: number | null,
        findingsCount?: number | null,
        user?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        assetRisk?: number | null,
        location?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        isParent?: boolean | null,
        thirdPartyParentId?: string | null,
        thirdPartyHierarchyPath?: Array< string | null > | null,
      } | null,
      assignmentGroupId?: string | null,
      assignedToId?: string | null,
      assignedTo?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      businessDownTime?: number | null,
      downTimeStart?: string | null,
      downTimeEnd?: string | null,
      category?: string | null,
      checklist?: string | null,
      closedNotes?: string | null,
      closedAt?: string | null,
      closedById?: string | null,
      closedBy?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      notes?: string | null,
      title?: string | null,
      description?: string | null,
      estimatedCostValue?: number | null,
      actualCostValue?: number | null,
      estimatedEffort?: number | null,
      actualEffort?: number | null,
      expectedOperationalDate?: string | null,
      impact?: number | null,
      priority?: number | null,
      dependsOnWorkOrderId?: string | null,
      dependsOnWorkOrder?:  {
        __typename: "WorkOrder",
        id?: string | null,
        displayNumber?: string | null,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt?: string | null,
        createdBy?: string | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        number?: number | null,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        locationId?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        dueDate?: string | null,
        startDate?: string | null,
        endDate?: string | null,
        duration?: string | null,
        plannedStartDate?: string | null,
        plannedEndDate?: string | null,
        assetId?: string | null,
        asset?:  {
          __typename: "Asset",
          id: string,
          number?: number | null,
          displayNumber?: string | null,
          userId?: string | null,
          assetTag: string,
          description: string,
          makeId: string,
          modelId: string,
          state: string,
          usefulLife?: number | null,
          acquisitionCostValue?: number | null,
          lastMaintenanceDate?: string | null,
          nextScheduledMaintenanceDate?: string | null,
          assignedToId?: string | null,
          assetTypeId: string,
          condition?: string | null,
          maintenanceCostValue?: number | null,
          currentBookValue?: number | null,
          installDate?: string | null,
          decommissionDate?: string | null,
          locationId?: string | null,
          image?: string | null,
          purchaseOrderId?: string | null,
          utilizationData?: string | null,
          reasonForDecommission?: string | null,
          serialNumber: string,
          thirdPartyId?: string | null,
          source?: string | null,
          totalCostOfOwnershipValue?: number | null,
          repairCostValue?: number | null,
          warrantyExpiration?: string | null,
          downTime?: string | null,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          model?:  {
            __typename: "Model",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            oemPartNumber?: string | null,
            name: string,
            manufacturerId: string,
            assetTypeId: string,
            probability?: number | null,
            severity?: number | null,
            riskScore?: number | null,
            picture?: string | null,
            specification?: string | null,
            usefulLife?: number | null,
            inUseStatus?: InUseStatus | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          woCount?: number | null,
          findingsCount?: number | null,
          user?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          assetRisk?: number | null,
          location?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          isParent?: boolean | null,
          thirdPartyParentId?: string | null,
          thirdPartyHierarchyPath?: Array< string | null > | null,
        } | null,
        assignmentGroupId?: string | null,
        assignedToId?: string | null,
        assignedTo?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        businessDownTime?: number | null,
        downTimeStart?: string | null,
        downTimeEnd?: string | null,
        category?: string | null,
        checklist?: string | null,
        closedNotes?: string | null,
        closedAt?: string | null,
        closedById?: string | null,
        closedBy?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        notes?: string | null,
        title?: string | null,
        description?: string | null,
        estimatedCostValue?: number | null,
        actualCostValue?: number | null,
        estimatedEffort?: number | null,
        actualEffort?: number | null,
        expectedOperationalDate?: string | null,
        impact?: number | null,
        priority?: number | null,
        dependsOnWorkOrderId?: string | null,
        dependsOnWorkOrder?:  {
          __typename: "WorkOrder",
          id?: string | null,
          displayNumber?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt?: string | null,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          number?: number | null,
          userId?: string | null,
          user?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          locationId?: string | null,
          location?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          dueDate?: string | null,
          startDate?: string | null,
          endDate?: string | null,
          duration?: string | null,
          plannedStartDate?: string | null,
          plannedEndDate?: string | null,
          assetId?: string | null,
          asset?:  {
            __typename: "Asset",
            id: string,
            number?: number | null,
            displayNumber?: string | null,
            userId?: string | null,
            assetTag: string,
            description: string,
            makeId: string,
            modelId: string,
            state: string,
            usefulLife?: number | null,
            acquisitionCostValue?: number | null,
            lastMaintenanceDate?: string | null,
            nextScheduledMaintenanceDate?: string | null,
            assignedToId?: string | null,
            assetTypeId: string,
            condition?: string | null,
            maintenanceCostValue?: number | null,
            currentBookValue?: number | null,
            installDate?: string | null,
            decommissionDate?: string | null,
            locationId?: string | null,
            image?: string | null,
            purchaseOrderId?: string | null,
            utilizationData?: string | null,
            reasonForDecommission?: string | null,
            serialNumber: string,
            thirdPartyId?: string | null,
            source?: string | null,
            totalCostOfOwnershipValue?: number | null,
            repairCostValue?: number | null,
            warrantyExpiration?: string | null,
            downTime?: string | null,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            woCount?: number | null,
            findingsCount?: number | null,
            assetRisk?: number | null,
            isParent?: boolean | null,
            thirdPartyParentId?: string | null,
            thirdPartyHierarchyPath?: Array< string | null > | null,
          } | null,
          assignmentGroupId?: string | null,
          assignedToId?: string | null,
          assignedTo?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          businessDownTime?: number | null,
          downTimeStart?: string | null,
          downTimeEnd?: string | null,
          category?: string | null,
          checklist?: string | null,
          closedNotes?: string | null,
          closedAt?: string | null,
          closedById?: string | null,
          closedBy?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          notes?: string | null,
          title?: string | null,
          description?: string | null,
          estimatedCostValue?: number | null,
          actualCostValue?: number | null,
          estimatedEffort?: number | null,
          actualEffort?: number | null,
          expectedOperationalDate?: string | null,
          impact?: number | null,
          priority?: number | null,
          dependsOnWorkOrderId?: string | null,
          dependsOnWorkOrder?:  {
            __typename: "WorkOrder",
            id?: string | null,
            displayNumber?: string | null,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            number?: number | null,
            userId?: string | null,
            locationId?: string | null,
            dueDate?: string | null,
            startDate?: string | null,
            endDate?: string | null,
            duration?: string | null,
            plannedStartDate?: string | null,
            plannedEndDate?: string | null,
            assetId?: string | null,
            assignmentGroupId?: string | null,
            assignedToId?: string | null,
            businessDownTime?: number | null,
            downTimeStart?: string | null,
            downTimeEnd?: string | null,
            category?: string | null,
            checklist?: string | null,
            closedNotes?: string | null,
            closedAt?: string | null,
            closedById?: string | null,
            notes?: string | null,
            title?: string | null,
            description?: string | null,
            estimatedCostValue?: number | null,
            actualCostValue?: number | null,
            estimatedEffort?: number | null,
            actualEffort?: number | null,
            expectedOperationalDate?: string | null,
            impact?: number | null,
            priority?: number | null,
            dependsOnWorkOrderId?: string | null,
            state?: string | null,
            type?: string | null,
            templateId?: string | null,
            isArchived?: boolean | null,
            findingId?: string | null,
            seenByAssignee?: boolean | null,
            assignmentDateTime?: string | null,
            seenDateTime?: string | null,
            startOfWorkDateTime?: string | null,
            endOfWorkDateTime?: string | null,
          } | null,
          state?: string | null,
          type?: string | null,
          templateId?: string | null,
          isArchived?: boolean | null,
          findingId?: string | null,
          seenByAssignee?: boolean | null,
          assignmentDateTime?: string | null,
          seenDateTime?: string | null,
          startOfWorkDateTime?: string | null,
          endOfWorkDateTime?: string | null,
        } | null,
        state?: string | null,
        type?: string | null,
        templateId?: string | null,
        isArchived?: boolean | null,
        findingId?: string | null,
        seenByAssignee?: boolean | null,
        assignmentDateTime?: string | null,
        seenDateTime?: string | null,
        startOfWorkDateTime?: string | null,
        endOfWorkDateTime?: string | null,
      } | null,
      state?: string | null,
      type?: string | null,
      templateId?: string | null,
      isArchived?: boolean | null,
      findingId?: string | null,
      seenByAssignee?: boolean | null,
      assignmentDateTime?: string | null,
      seenDateTime?: string | null,
      startOfWorkDateTime?: string | null,
      endOfWorkDateTime?: string | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type BulkUpdateWorkOrderMutationVariables = {
  data?: BulkUpdateData | null,
};

export type BulkUpdateWorkOrderMutation = {
  bulkUpdateWorkOrder?:  {
    __typename: "BulkUpdateResponse",
    updatedCount?: number | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type CreateWorkOrdersByTemplateListMutationVariables = {
  assetIdList: Array< string | null >,
  templateIdList: Array< string | null >,
};

export type CreateWorkOrdersByTemplateListMutation = {
  createWorkOrdersByTemplateList?:  {
    __typename: "WorkOrderListResponse",
    data?:  Array< {
      __typename: "WorkOrder",
      id?: string | null,
      displayNumber?: string | null,
      tenantId?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      createdAt?: string | null,
      createdBy?: string | null,
      createdByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      updatedByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      number?: number | null,
      userId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      locationId?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        tenantId: string,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        notes?: string | null,
        lat?: number | null,
        lng?: number | null,
        level?: string | null,
        parentId?: string | null,
        rootId?: string | null,
        thirdPartyId?: string | null,
        source?: string | null,
        inUseStatus?: InUseStatus | null,
        address?: string | null,
        buildingAddress?: string | null,
        parent?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        tisSyncedAt?: string | null,
      } | null,
      dueDate?: string | null,
      startDate?: string | null,
      endDate?: string | null,
      duration?: string | null,
      plannedStartDate?: string | null,
      plannedEndDate?: string | null,
      assetId?: string | null,
      asset?:  {
        __typename: "Asset",
        id: string,
        number?: number | null,
        displayNumber?: string | null,
        userId?: string | null,
        assetTag: string,
        description: string,
        makeId: string,
        modelId: string,
        state: string,
        usefulLife?: number | null,
        acquisitionCostValue?: number | null,
        lastMaintenanceDate?: string | null,
        nextScheduledMaintenanceDate?: string | null,
        assignedToId?: string | null,
        assetTypeId: string,
        condition?: string | null,
        maintenanceCostValue?: number | null,
        currentBookValue?: number | null,
        installDate?: string | null,
        decommissionDate?: string | null,
        locationId?: string | null,
        image?: string | null,
        purchaseOrderId?: string | null,
        utilizationData?: string | null,
        reasonForDecommission?: string | null,
        serialNumber: string,
        thirdPartyId?: string | null,
        source?: string | null,
        totalCostOfOwnershipValue?: number | null,
        repairCostValue?: number | null,
        warrantyExpiration?: string | null,
        downTime?: string | null,
        tenantId: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        model?:  {
          __typename: "Model",
          id: string,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          oemPartNumber?: string | null,
          name: string,
          manufacturerId: string,
          assetTypeId: string,
          probability?: number | null,
          severity?: number | null,
          riskScore?: number | null,
          picture?: string | null,
          specification?: string | null,
          usefulLife?: number | null,
          inUseStatus?: InUseStatus | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        assetType?:  {
          __typename: "AssetType",
          id: string,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          name: string,
          description?: string | null,
          category?: string | null,
          criticalityLevel?: number | null,
          expectedUsefulLife?: number | null,
          defaultWarrantyPeriod?: number | null,
          defaultRiskScore?: number | null,
          manufacturerRecommendations?: string | null,
          image?: string | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          inUseStatus?: string | null,
        } | null,
        manufacturer?:  {
          __typename: "Manufacturer",
          id: string,
          name: string,
          description?: string | null,
          countryId?: string | null,
          website?: string | null,
          contactPerson?: string | null,
          contactEmail?: string | null,
          contactPhone?: string | null,
          address?: string | null,
          warrantyPolicies?: string | null,
          slaDetails?: string | null,
          vendorPortalLink?: string | null,
          createdAt: string,
          createdBy: string,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          inUseStatus?: InUseStatus | null,
        } | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        woCount?: number | null,
        findingsCount?: number | null,
        user?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        assetRisk?: number | null,
        location?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        isParent?: boolean | null,
        thirdPartyParentId?: string | null,
        thirdPartyHierarchyPath?: Array< string | null > | null,
      } | null,
      assignmentGroupId?: string | null,
      assignedToId?: string | null,
      assignedTo?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      businessDownTime?: number | null,
      downTimeStart?: string | null,
      downTimeEnd?: string | null,
      category?: string | null,
      checklist?: string | null,
      closedNotes?: string | null,
      closedAt?: string | null,
      closedById?: string | null,
      closedBy?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      notes?: string | null,
      title?: string | null,
      description?: string | null,
      estimatedCostValue?: number | null,
      actualCostValue?: number | null,
      estimatedEffort?: number | null,
      actualEffort?: number | null,
      expectedOperationalDate?: string | null,
      impact?: number | null,
      priority?: number | null,
      dependsOnWorkOrderId?: string | null,
      dependsOnWorkOrder?:  {
        __typename: "WorkOrder",
        id?: string | null,
        displayNumber?: string | null,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt?: string | null,
        createdBy?: string | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        number?: number | null,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        locationId?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        dueDate?: string | null,
        startDate?: string | null,
        endDate?: string | null,
        duration?: string | null,
        plannedStartDate?: string | null,
        plannedEndDate?: string | null,
        assetId?: string | null,
        asset?:  {
          __typename: "Asset",
          id: string,
          number?: number | null,
          displayNumber?: string | null,
          userId?: string | null,
          assetTag: string,
          description: string,
          makeId: string,
          modelId: string,
          state: string,
          usefulLife?: number | null,
          acquisitionCostValue?: number | null,
          lastMaintenanceDate?: string | null,
          nextScheduledMaintenanceDate?: string | null,
          assignedToId?: string | null,
          assetTypeId: string,
          condition?: string | null,
          maintenanceCostValue?: number | null,
          currentBookValue?: number | null,
          installDate?: string | null,
          decommissionDate?: string | null,
          locationId?: string | null,
          image?: string | null,
          purchaseOrderId?: string | null,
          utilizationData?: string | null,
          reasonForDecommission?: string | null,
          serialNumber: string,
          thirdPartyId?: string | null,
          source?: string | null,
          totalCostOfOwnershipValue?: number | null,
          repairCostValue?: number | null,
          warrantyExpiration?: string | null,
          downTime?: string | null,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          model?:  {
            __typename: "Model",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            oemPartNumber?: string | null,
            name: string,
            manufacturerId: string,
            assetTypeId: string,
            probability?: number | null,
            severity?: number | null,
            riskScore?: number | null,
            picture?: string | null,
            specification?: string | null,
            usefulLife?: number | null,
            inUseStatus?: InUseStatus | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          woCount?: number | null,
          findingsCount?: number | null,
          user?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          assetRisk?: number | null,
          location?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          isParent?: boolean | null,
          thirdPartyParentId?: string | null,
          thirdPartyHierarchyPath?: Array< string | null > | null,
        } | null,
        assignmentGroupId?: string | null,
        assignedToId?: string | null,
        assignedTo?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        businessDownTime?: number | null,
        downTimeStart?: string | null,
        downTimeEnd?: string | null,
        category?: string | null,
        checklist?: string | null,
        closedNotes?: string | null,
        closedAt?: string | null,
        closedById?: string | null,
        closedBy?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        notes?: string | null,
        title?: string | null,
        description?: string | null,
        estimatedCostValue?: number | null,
        actualCostValue?: number | null,
        estimatedEffort?: number | null,
        actualEffort?: number | null,
        expectedOperationalDate?: string | null,
        impact?: number | null,
        priority?: number | null,
        dependsOnWorkOrderId?: string | null,
        dependsOnWorkOrder?:  {
          __typename: "WorkOrder",
          id?: string | null,
          displayNumber?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt?: string | null,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          number?: number | null,
          userId?: string | null,
          user?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          locationId?: string | null,
          location?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          dueDate?: string | null,
          startDate?: string | null,
          endDate?: string | null,
          duration?: string | null,
          plannedStartDate?: string | null,
          plannedEndDate?: string | null,
          assetId?: string | null,
          asset?:  {
            __typename: "Asset",
            id: string,
            number?: number | null,
            displayNumber?: string | null,
            userId?: string | null,
            assetTag: string,
            description: string,
            makeId: string,
            modelId: string,
            state: string,
            usefulLife?: number | null,
            acquisitionCostValue?: number | null,
            lastMaintenanceDate?: string | null,
            nextScheduledMaintenanceDate?: string | null,
            assignedToId?: string | null,
            assetTypeId: string,
            condition?: string | null,
            maintenanceCostValue?: number | null,
            currentBookValue?: number | null,
            installDate?: string | null,
            decommissionDate?: string | null,
            locationId?: string | null,
            image?: string | null,
            purchaseOrderId?: string | null,
            utilizationData?: string | null,
            reasonForDecommission?: string | null,
            serialNumber: string,
            thirdPartyId?: string | null,
            source?: string | null,
            totalCostOfOwnershipValue?: number | null,
            repairCostValue?: number | null,
            warrantyExpiration?: string | null,
            downTime?: string | null,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            woCount?: number | null,
            findingsCount?: number | null,
            assetRisk?: number | null,
            isParent?: boolean | null,
            thirdPartyParentId?: string | null,
            thirdPartyHierarchyPath?: Array< string | null > | null,
          } | null,
          assignmentGroupId?: string | null,
          assignedToId?: string | null,
          assignedTo?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          businessDownTime?: number | null,
          downTimeStart?: string | null,
          downTimeEnd?: string | null,
          category?: string | null,
          checklist?: string | null,
          closedNotes?: string | null,
          closedAt?: string | null,
          closedById?: string | null,
          closedBy?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          notes?: string | null,
          title?: string | null,
          description?: string | null,
          estimatedCostValue?: number | null,
          actualCostValue?: number | null,
          estimatedEffort?: number | null,
          actualEffort?: number | null,
          expectedOperationalDate?: string | null,
          impact?: number | null,
          priority?: number | null,
          dependsOnWorkOrderId?: string | null,
          dependsOnWorkOrder?:  {
            __typename: "WorkOrder",
            id?: string | null,
            displayNumber?: string | null,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            number?: number | null,
            userId?: string | null,
            locationId?: string | null,
            dueDate?: string | null,
            startDate?: string | null,
            endDate?: string | null,
            duration?: string | null,
            plannedStartDate?: string | null,
            plannedEndDate?: string | null,
            assetId?: string | null,
            assignmentGroupId?: string | null,
            assignedToId?: string | null,
            businessDownTime?: number | null,
            downTimeStart?: string | null,
            downTimeEnd?: string | null,
            category?: string | null,
            checklist?: string | null,
            closedNotes?: string | null,
            closedAt?: string | null,
            closedById?: string | null,
            notes?: string | null,
            title?: string | null,
            description?: string | null,
            estimatedCostValue?: number | null,
            actualCostValue?: number | null,
            estimatedEffort?: number | null,
            actualEffort?: number | null,
            expectedOperationalDate?: string | null,
            impact?: number | null,
            priority?: number | null,
            dependsOnWorkOrderId?: string | null,
            state?: string | null,
            type?: string | null,
            templateId?: string | null,
            isArchived?: boolean | null,
            findingId?: string | null,
            seenByAssignee?: boolean | null,
            assignmentDateTime?: string | null,
            seenDateTime?: string | null,
            startOfWorkDateTime?: string | null,
            endOfWorkDateTime?: string | null,
          } | null,
          state?: string | null,
          type?: string | null,
          templateId?: string | null,
          isArchived?: boolean | null,
          findingId?: string | null,
          seenByAssignee?: boolean | null,
          assignmentDateTime?: string | null,
          seenDateTime?: string | null,
          startOfWorkDateTime?: string | null,
          endOfWorkDateTime?: string | null,
        } | null,
        state?: string | null,
        type?: string | null,
        templateId?: string | null,
        isArchived?: boolean | null,
        findingId?: string | null,
        seenByAssignee?: boolean | null,
        assignmentDateTime?: string | null,
        seenDateTime?: string | null,
        startOfWorkDateTime?: string | null,
        endOfWorkDateTime?: string | null,
      } | null,
      state?: string | null,
      type?: string | null,
      templateId?: string | null,
      isArchived?: boolean | null,
      findingId?: string | null,
      seenByAssignee?: boolean | null,
      assignmentDateTime?: string | null,
      seenDateTime?: string | null,
      startOfWorkDateTime?: string | null,
      endOfWorkDateTime?: string | null,
    } | null > | null,
    totalCount?: number | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type CreateWorkOrderTemplateMutationVariables = {
  data: WorkOrderTemplateInput,
};

export type CreateWorkOrderTemplateMutation = {
  createWorkOrderTemplate?:  {
    __typename: "WorkOrderTemplateResponse",
    data?:  {
      __typename: "WorkOrderTemplate",
      id?: string | null,
      displayNumber?: string | null,
      tenantId?: string | null,
      createdAt?: string | null,
      createdBy?: string | null,
      createdByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      updatedByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      number?: number | null,
      title: string,
      type?: string | null,
      category?: string | null,
      description?: string | null,
      userId?: string | null,
      locationId?: string | null,
      assignmentGroupId?: string | null,
      notes?: string | null,
      estimatedCostValue?: number | null,
      estimatedEffort?: number | null,
      impact?: number | null,
      priority?: number | null,
      executionInterval?: string | null,
      assetManufacturerId?: string | null,
      assetModelId?: string | null,
      assetTypeId?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      manufacturer?:  {
        __typename: "Manufacturer",
        id: string,
        name: string,
        description?: string | null,
        countryId?: string | null,
        website?: string | null,
        contactPerson?: string | null,
        contactEmail?: string | null,
        contactPhone?: string | null,
        address?: string | null,
        warrantyPolicies?: string | null,
        slaDetails?: string | null,
        vendorPortalLink?: string | null,
        createdAt: string,
        createdBy: string,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        inUseStatus?: InUseStatus | null,
      } | null,
      assetType?:  {
        __typename: "AssetType",
        id: string,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt: string,
        createdBy?: string | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        name: string,
        description?: string | null,
        category?: string | null,
        criticalityLevel?: number | null,
        expectedUsefulLife?: number | null,
        defaultWarrantyPeriod?: number | null,
        defaultRiskScore?: number | null,
        manufacturerRecommendations?: string | null,
        image?: string | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        inUseStatus?: string | null,
      } | null,
      model?:  {
        __typename: "Model",
        id: string,
        tenantId: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        oemPartNumber?: string | null,
        name: string,
        manufacturerId: string,
        assetTypeId: string,
        probability?: number | null,
        severity?: number | null,
        riskScore?: number | null,
        picture?: string | null,
        specification?: string | null,
        usefulLife?: number | null,
        inUseStatus?: InUseStatus | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        manufacturer?:  {
          __typename: "Manufacturer",
          id: string,
          name: string,
          description?: string | null,
          countryId?: string | null,
          website?: string | null,
          contactPerson?: string | null,
          contactEmail?: string | null,
          contactPhone?: string | null,
          address?: string | null,
          warrantyPolicies?: string | null,
          slaDetails?: string | null,
          vendorPortalLink?: string | null,
          createdAt: string,
          createdBy: string,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          inUseStatus?: InUseStatus | null,
        } | null,
        assetType?:  {
          __typename: "AssetType",
          id: string,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          name: string,
          description?: string | null,
          category?: string | null,
          criticalityLevel?: number | null,
          expectedUsefulLife?: number | null,
          defaultWarrantyPeriod?: number | null,
          defaultRiskScore?: number | null,
          manufacturerRecommendations?: string | null,
          image?: string | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          inUseStatus?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type UpdateWorkOrderTemplateMutationVariables = {
  id: string,
  data: WorkOrderTemplateInput,
};

export type UpdateWorkOrderTemplateMutation = {
  updateWorkOrderTemplate?:  {
    __typename: "WorkOrderTemplateResponse",
    data?:  {
      __typename: "WorkOrderTemplate",
      id?: string | null,
      displayNumber?: string | null,
      tenantId?: string | null,
      createdAt?: string | null,
      createdBy?: string | null,
      createdByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      updatedByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      number?: number | null,
      title: string,
      type?: string | null,
      category?: string | null,
      description?: string | null,
      userId?: string | null,
      locationId?: string | null,
      assignmentGroupId?: string | null,
      notes?: string | null,
      estimatedCostValue?: number | null,
      estimatedEffort?: number | null,
      impact?: number | null,
      priority?: number | null,
      executionInterval?: string | null,
      assetManufacturerId?: string | null,
      assetModelId?: string | null,
      assetTypeId?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      manufacturer?:  {
        __typename: "Manufacturer",
        id: string,
        name: string,
        description?: string | null,
        countryId?: string | null,
        website?: string | null,
        contactPerson?: string | null,
        contactEmail?: string | null,
        contactPhone?: string | null,
        address?: string | null,
        warrantyPolicies?: string | null,
        slaDetails?: string | null,
        vendorPortalLink?: string | null,
        createdAt: string,
        createdBy: string,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        inUseStatus?: InUseStatus | null,
      } | null,
      assetType?:  {
        __typename: "AssetType",
        id: string,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt: string,
        createdBy?: string | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        name: string,
        description?: string | null,
        category?: string | null,
        criticalityLevel?: number | null,
        expectedUsefulLife?: number | null,
        defaultWarrantyPeriod?: number | null,
        defaultRiskScore?: number | null,
        manufacturerRecommendations?: string | null,
        image?: string | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        inUseStatus?: string | null,
      } | null,
      model?:  {
        __typename: "Model",
        id: string,
        tenantId: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        oemPartNumber?: string | null,
        name: string,
        manufacturerId: string,
        assetTypeId: string,
        probability?: number | null,
        severity?: number | null,
        riskScore?: number | null,
        picture?: string | null,
        specification?: string | null,
        usefulLife?: number | null,
        inUseStatus?: InUseStatus | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        manufacturer?:  {
          __typename: "Manufacturer",
          id: string,
          name: string,
          description?: string | null,
          countryId?: string | null,
          website?: string | null,
          contactPerson?: string | null,
          contactEmail?: string | null,
          contactPhone?: string | null,
          address?: string | null,
          warrantyPolicies?: string | null,
          slaDetails?: string | null,
          vendorPortalLink?: string | null,
          createdAt: string,
          createdBy: string,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          inUseStatus?: InUseStatus | null,
        } | null,
        assetType?:  {
          __typename: "AssetType",
          id: string,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          name: string,
          description?: string | null,
          category?: string | null,
          criticalityLevel?: number | null,
          expectedUsefulLife?: number | null,
          defaultWarrantyPeriod?: number | null,
          defaultRiskScore?: number | null,
          manufacturerRecommendations?: string | null,
          image?: string | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          inUseStatus?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type DeleteWorkOrderTemplateMutationVariables = {
  id: string,
};

export type DeleteWorkOrderTemplateMutation = {
  deleteWorkOrderTemplate?:  {
    __typename: "WorkOrderTemplateResponse",
    data?:  {
      __typename: "WorkOrderTemplate",
      id?: string | null,
      displayNumber?: string | null,
      tenantId?: string | null,
      createdAt?: string | null,
      createdBy?: string | null,
      createdByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      updatedByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      number?: number | null,
      title: string,
      type?: string | null,
      category?: string | null,
      description?: string | null,
      userId?: string | null,
      locationId?: string | null,
      assignmentGroupId?: string | null,
      notes?: string | null,
      estimatedCostValue?: number | null,
      estimatedEffort?: number | null,
      impact?: number | null,
      priority?: number | null,
      executionInterval?: string | null,
      assetManufacturerId?: string | null,
      assetModelId?: string | null,
      assetTypeId?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      manufacturer?:  {
        __typename: "Manufacturer",
        id: string,
        name: string,
        description?: string | null,
        countryId?: string | null,
        website?: string | null,
        contactPerson?: string | null,
        contactEmail?: string | null,
        contactPhone?: string | null,
        address?: string | null,
        warrantyPolicies?: string | null,
        slaDetails?: string | null,
        vendorPortalLink?: string | null,
        createdAt: string,
        createdBy: string,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        inUseStatus?: InUseStatus | null,
      } | null,
      assetType?:  {
        __typename: "AssetType",
        id: string,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt: string,
        createdBy?: string | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        name: string,
        description?: string | null,
        category?: string | null,
        criticalityLevel?: number | null,
        expectedUsefulLife?: number | null,
        defaultWarrantyPeriod?: number | null,
        defaultRiskScore?: number | null,
        manufacturerRecommendations?: string | null,
        image?: string | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        inUseStatus?: string | null,
      } | null,
      model?:  {
        __typename: "Model",
        id: string,
        tenantId: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        oemPartNumber?: string | null,
        name: string,
        manufacturerId: string,
        assetTypeId: string,
        probability?: number | null,
        severity?: number | null,
        riskScore?: number | null,
        picture?: string | null,
        specification?: string | null,
        usefulLife?: number | null,
        inUseStatus?: InUseStatus | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        manufacturer?:  {
          __typename: "Manufacturer",
          id: string,
          name: string,
          description?: string | null,
          countryId?: string | null,
          website?: string | null,
          contactPerson?: string | null,
          contactEmail?: string | null,
          contactPhone?: string | null,
          address?: string | null,
          warrantyPolicies?: string | null,
          slaDetails?: string | null,
          vendorPortalLink?: string | null,
          createdAt: string,
          createdBy: string,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          inUseStatus?: InUseStatus | null,
        } | null,
        assetType?:  {
          __typename: "AssetType",
          id: string,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          name: string,
          description?: string | null,
          category?: string | null,
          criticalityLevel?: number | null,
          expectedUsefulLife?: number | null,
          defaultWarrantyPeriod?: number | null,
          defaultRiskScore?: number | null,
          manufacturerRecommendations?: string | null,
          image?: string | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          inUseStatus?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type CreateModelMutationVariables = {
  data: CreateModelInput,
};

export type CreateModelMutation = {
  createModel?:  {
    __typename: "ModelResponse",
    data?:  {
      __typename: "Model",
      id: string,
      tenantId: string,
      createdAt: string,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      oemPartNumber?: string | null,
      name: string,
      manufacturerId: string,
      assetTypeId: string,
      probability?: number | null,
      severity?: number | null,
      riskScore?: number | null,
      picture?: string | null,
      specification?: string | null,
      usefulLife?: number | null,
      inUseStatus?: InUseStatus | null,
      thirdPartyId?: string | null,
      thirdPartySource?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      manufacturer?:  {
        __typename: "Manufacturer",
        id: string,
        name: string,
        description?: string | null,
        countryId?: string | null,
        website?: string | null,
        contactPerson?: string | null,
        contactEmail?: string | null,
        contactPhone?: string | null,
        address?: string | null,
        warrantyPolicies?: string | null,
        slaDetails?: string | null,
        vendorPortalLink?: string | null,
        createdAt: string,
        createdBy: string,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        inUseStatus?: InUseStatus | null,
      } | null,
      assetType?:  {
        __typename: "AssetType",
        id: string,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt: string,
        createdBy?: string | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        name: string,
        description?: string | null,
        category?: string | null,
        criticalityLevel?: number | null,
        expectedUsefulLife?: number | null,
        defaultWarrantyPeriod?: number | null,
        defaultRiskScore?: number | null,
        manufacturerRecommendations?: string | null,
        image?: string | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        inUseStatus?: string | null,
      } | null,
      createdByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      updatedByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type UpdateModelMutationVariables = {
  id: string,
  data: UpdateModelInput,
};

export type UpdateModelMutation = {
  updateModel?:  {
    __typename: "ModelResponse",
    data?:  {
      __typename: "Model",
      id: string,
      tenantId: string,
      createdAt: string,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      oemPartNumber?: string | null,
      name: string,
      manufacturerId: string,
      assetTypeId: string,
      probability?: number | null,
      severity?: number | null,
      riskScore?: number | null,
      picture?: string | null,
      specification?: string | null,
      usefulLife?: number | null,
      inUseStatus?: InUseStatus | null,
      thirdPartyId?: string | null,
      thirdPartySource?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      manufacturer?:  {
        __typename: "Manufacturer",
        id: string,
        name: string,
        description?: string | null,
        countryId?: string | null,
        website?: string | null,
        contactPerson?: string | null,
        contactEmail?: string | null,
        contactPhone?: string | null,
        address?: string | null,
        warrantyPolicies?: string | null,
        slaDetails?: string | null,
        vendorPortalLink?: string | null,
        createdAt: string,
        createdBy: string,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        inUseStatus?: InUseStatus | null,
      } | null,
      assetType?:  {
        __typename: "AssetType",
        id: string,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt: string,
        createdBy?: string | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        name: string,
        description?: string | null,
        category?: string | null,
        criticalityLevel?: number | null,
        expectedUsefulLife?: number | null,
        defaultWarrantyPeriod?: number | null,
        defaultRiskScore?: number | null,
        manufacturerRecommendations?: string | null,
        image?: string | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        inUseStatus?: string | null,
      } | null,
      createdByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      updatedByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type DeleteModelMutationVariables = {
  id: string,
};

export type DeleteModelMutation = {
  deleteModel?:  {
    __typename: "ModelResponse",
    data?:  {
      __typename: "Model",
      id: string,
      tenantId: string,
      createdAt: string,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      oemPartNumber?: string | null,
      name: string,
      manufacturerId: string,
      assetTypeId: string,
      probability?: number | null,
      severity?: number | null,
      riskScore?: number | null,
      picture?: string | null,
      specification?: string | null,
      usefulLife?: number | null,
      inUseStatus?: InUseStatus | null,
      thirdPartyId?: string | null,
      thirdPartySource?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      manufacturer?:  {
        __typename: "Manufacturer",
        id: string,
        name: string,
        description?: string | null,
        countryId?: string | null,
        website?: string | null,
        contactPerson?: string | null,
        contactEmail?: string | null,
        contactPhone?: string | null,
        address?: string | null,
        warrantyPolicies?: string | null,
        slaDetails?: string | null,
        vendorPortalLink?: string | null,
        createdAt: string,
        createdBy: string,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        inUseStatus?: InUseStatus | null,
      } | null,
      assetType?:  {
        __typename: "AssetType",
        id: string,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt: string,
        createdBy?: string | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        name: string,
        description?: string | null,
        category?: string | null,
        criticalityLevel?: number | null,
        expectedUsefulLife?: number | null,
        defaultWarrantyPeriod?: number | null,
        defaultRiskScore?: number | null,
        manufacturerRecommendations?: string | null,
        image?: string | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        inUseStatus?: string | null,
      } | null,
      createdByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      updatedByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type CreateManufacturerMutationVariables = {
  data: ManufacturerInput,
};

export type CreateManufacturerMutation = {
  createManufacturer?:  {
    __typename: "ManufacturerResponse",
    data?:  {
      __typename: "Manufacturer",
      id: string,
      name: string,
      description?: string | null,
      countryId?: string | null,
      website?: string | null,
      contactPerson?: string | null,
      contactEmail?: string | null,
      contactPhone?: string | null,
      address?: string | null,
      warrantyPolicies?: string | null,
      slaDetails?: string | null,
      vendorPortalLink?: string | null,
      createdAt: string,
      createdBy: string,
      createdByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      updatedByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      thirdPartyId?: string | null,
      thirdPartySource?: string | null,
      tenantId?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      inUseStatus?: InUseStatus | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type UpdateManufacturerMutationVariables = {
  id: string,
  data: ManufacturerInput,
};

export type UpdateManufacturerMutation = {
  updateManufacturer?:  {
    __typename: "ManufacturerResponse",
    data?:  {
      __typename: "Manufacturer",
      id: string,
      name: string,
      description?: string | null,
      countryId?: string | null,
      website?: string | null,
      contactPerson?: string | null,
      contactEmail?: string | null,
      contactPhone?: string | null,
      address?: string | null,
      warrantyPolicies?: string | null,
      slaDetails?: string | null,
      vendorPortalLink?: string | null,
      createdAt: string,
      createdBy: string,
      createdByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      updatedByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      thirdPartyId?: string | null,
      thirdPartySource?: string | null,
      tenantId?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      inUseStatus?: InUseStatus | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type DeleteManufacturerMutationVariables = {
  id: string,
};

export type DeleteManufacturerMutation = {
  deleteManufacturer?:  {
    __typename: "ManufacturerResponse",
    data?:  {
      __typename: "Manufacturer",
      id: string,
      name: string,
      description?: string | null,
      countryId?: string | null,
      website?: string | null,
      contactPerson?: string | null,
      contactEmail?: string | null,
      contactPhone?: string | null,
      address?: string | null,
      warrantyPolicies?: string | null,
      slaDetails?: string | null,
      vendorPortalLink?: string | null,
      createdAt: string,
      createdBy: string,
      createdByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      updatedByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      thirdPartyId?: string | null,
      thirdPartySource?: string | null,
      tenantId?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      inUseStatus?: InUseStatus | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type CreateFindingMutationVariables = {
  data: FindingInput,
};

export type CreateFindingMutation = {
  createFinding?:  {
    __typename: "FindingResponse",
    data?:  {
      __typename: "Finding",
      id: string,
      tenantId?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      createdAt?: string | null,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      number?: number | null,
      displayNumber?: string | null,
      shortDescription?: string | null,
      priority?: number | null,
      estimatedRepairCost?: number | null,
      plannedRepairDate?: string | null,
      description?: string | null,
      cause?: string | null,
      symptom?: string | null,
      picture?: string | null,
      reportedOn?: string | null,
      workOrderId?: string | null,
      type?: FindingType | null,
      reportedById?: string | null,
      status?: FindingStatus | null,
      assetId?: string | null,
      asset?:  {
        __typename: "Asset",
        id: string,
        number?: number | null,
        displayNumber?: string | null,
        userId?: string | null,
        assetTag: string,
        description: string,
        makeId: string,
        modelId: string,
        state: string,
        usefulLife?: number | null,
        acquisitionCostValue?: number | null,
        lastMaintenanceDate?: string | null,
        nextScheduledMaintenanceDate?: string | null,
        assignedToId?: string | null,
        assetTypeId: string,
        condition?: string | null,
        maintenanceCostValue?: number | null,
        currentBookValue?: number | null,
        installDate?: string | null,
        decommissionDate?: string | null,
        locationId?: string | null,
        image?: string | null,
        purchaseOrderId?: string | null,
        utilizationData?: string | null,
        reasonForDecommission?: string | null,
        serialNumber: string,
        thirdPartyId?: string | null,
        source?: string | null,
        totalCostOfOwnershipValue?: number | null,
        repairCostValue?: number | null,
        warrantyExpiration?: string | null,
        downTime?: string | null,
        tenantId: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        model?:  {
          __typename: "Model",
          id: string,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          oemPartNumber?: string | null,
          name: string,
          manufacturerId: string,
          assetTypeId: string,
          probability?: number | null,
          severity?: number | null,
          riskScore?: number | null,
          picture?: string | null,
          specification?: string | null,
          usefulLife?: number | null,
          inUseStatus?: InUseStatus | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        assetType?:  {
          __typename: "AssetType",
          id: string,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          name: string,
          description?: string | null,
          category?: string | null,
          criticalityLevel?: number | null,
          expectedUsefulLife?: number | null,
          defaultWarrantyPeriod?: number | null,
          defaultRiskScore?: number | null,
          manufacturerRecommendations?: string | null,
          image?: string | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          inUseStatus?: string | null,
        } | null,
        manufacturer?:  {
          __typename: "Manufacturer",
          id: string,
          name: string,
          description?: string | null,
          countryId?: string | null,
          website?: string | null,
          contactPerson?: string | null,
          contactEmail?: string | null,
          contactPhone?: string | null,
          address?: string | null,
          warrantyPolicies?: string | null,
          slaDetails?: string | null,
          vendorPortalLink?: string | null,
          createdAt: string,
          createdBy: string,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          inUseStatus?: InUseStatus | null,
        } | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        woCount?: number | null,
        findingsCount?: number | null,
        user?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        assetRisk?: number | null,
        location?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        isParent?: boolean | null,
        thirdPartyParentId?: string | null,
        thirdPartyHierarchyPath?: Array< string | null > | null,
      } | null,
      locationId?: string | null,
      model?:  {
        __typename: "Model",
        id: string,
        tenantId: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        oemPartNumber?: string | null,
        name: string,
        manufacturerId: string,
        assetTypeId: string,
        probability?: number | null,
        severity?: number | null,
        riskScore?: number | null,
        picture?: string | null,
        specification?: string | null,
        usefulLife?: number | null,
        inUseStatus?: InUseStatus | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        manufacturer?:  {
          __typename: "Manufacturer",
          id: string,
          name: string,
          description?: string | null,
          countryId?: string | null,
          website?: string | null,
          contactPerson?: string | null,
          contactEmail?: string | null,
          contactPhone?: string | null,
          address?: string | null,
          warrantyPolicies?: string | null,
          slaDetails?: string | null,
          vendorPortalLink?: string | null,
          createdAt: string,
          createdBy: string,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          inUseStatus?: InUseStatus | null,
        } | null,
        assetType?:  {
          __typename: "AssetType",
          id: string,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          name: string,
          description?: string | null,
          category?: string | null,
          criticalityLevel?: number | null,
          expectedUsefulLife?: number | null,
          defaultWarrantyPeriod?: number | null,
          defaultRiskScore?: number | null,
          manufacturerRecommendations?: string | null,
          image?: string | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          inUseStatus?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      isArchived?: boolean | null,
      thirdPartyId?: string | null,
      thirdPartySource?: string | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type UpdateFindingMutationVariables = {
  id: string,
  data: UpdateFindingInput,
};

export type UpdateFindingMutation = {
  updateFinding?:  {
    __typename: "FindingResponse",
    data?:  {
      __typename: "Finding",
      id: string,
      tenantId?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      createdAt?: string | null,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      number?: number | null,
      displayNumber?: string | null,
      shortDescription?: string | null,
      priority?: number | null,
      estimatedRepairCost?: number | null,
      plannedRepairDate?: string | null,
      description?: string | null,
      cause?: string | null,
      symptom?: string | null,
      picture?: string | null,
      reportedOn?: string | null,
      workOrderId?: string | null,
      type?: FindingType | null,
      reportedById?: string | null,
      status?: FindingStatus | null,
      assetId?: string | null,
      asset?:  {
        __typename: "Asset",
        id: string,
        number?: number | null,
        displayNumber?: string | null,
        userId?: string | null,
        assetTag: string,
        description: string,
        makeId: string,
        modelId: string,
        state: string,
        usefulLife?: number | null,
        acquisitionCostValue?: number | null,
        lastMaintenanceDate?: string | null,
        nextScheduledMaintenanceDate?: string | null,
        assignedToId?: string | null,
        assetTypeId: string,
        condition?: string | null,
        maintenanceCostValue?: number | null,
        currentBookValue?: number | null,
        installDate?: string | null,
        decommissionDate?: string | null,
        locationId?: string | null,
        image?: string | null,
        purchaseOrderId?: string | null,
        utilizationData?: string | null,
        reasonForDecommission?: string | null,
        serialNumber: string,
        thirdPartyId?: string | null,
        source?: string | null,
        totalCostOfOwnershipValue?: number | null,
        repairCostValue?: number | null,
        warrantyExpiration?: string | null,
        downTime?: string | null,
        tenantId: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        model?:  {
          __typename: "Model",
          id: string,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          oemPartNumber?: string | null,
          name: string,
          manufacturerId: string,
          assetTypeId: string,
          probability?: number | null,
          severity?: number | null,
          riskScore?: number | null,
          picture?: string | null,
          specification?: string | null,
          usefulLife?: number | null,
          inUseStatus?: InUseStatus | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        assetType?:  {
          __typename: "AssetType",
          id: string,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          name: string,
          description?: string | null,
          category?: string | null,
          criticalityLevel?: number | null,
          expectedUsefulLife?: number | null,
          defaultWarrantyPeriod?: number | null,
          defaultRiskScore?: number | null,
          manufacturerRecommendations?: string | null,
          image?: string | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          inUseStatus?: string | null,
        } | null,
        manufacturer?:  {
          __typename: "Manufacturer",
          id: string,
          name: string,
          description?: string | null,
          countryId?: string | null,
          website?: string | null,
          contactPerson?: string | null,
          contactEmail?: string | null,
          contactPhone?: string | null,
          address?: string | null,
          warrantyPolicies?: string | null,
          slaDetails?: string | null,
          vendorPortalLink?: string | null,
          createdAt: string,
          createdBy: string,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          inUseStatus?: InUseStatus | null,
        } | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        woCount?: number | null,
        findingsCount?: number | null,
        user?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        assetRisk?: number | null,
        location?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        isParent?: boolean | null,
        thirdPartyParentId?: string | null,
        thirdPartyHierarchyPath?: Array< string | null > | null,
      } | null,
      locationId?: string | null,
      model?:  {
        __typename: "Model",
        id: string,
        tenantId: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        oemPartNumber?: string | null,
        name: string,
        manufacturerId: string,
        assetTypeId: string,
        probability?: number | null,
        severity?: number | null,
        riskScore?: number | null,
        picture?: string | null,
        specification?: string | null,
        usefulLife?: number | null,
        inUseStatus?: InUseStatus | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        manufacturer?:  {
          __typename: "Manufacturer",
          id: string,
          name: string,
          description?: string | null,
          countryId?: string | null,
          website?: string | null,
          contactPerson?: string | null,
          contactEmail?: string | null,
          contactPhone?: string | null,
          address?: string | null,
          warrantyPolicies?: string | null,
          slaDetails?: string | null,
          vendorPortalLink?: string | null,
          createdAt: string,
          createdBy: string,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          inUseStatus?: InUseStatus | null,
        } | null,
        assetType?:  {
          __typename: "AssetType",
          id: string,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          name: string,
          description?: string | null,
          category?: string | null,
          criticalityLevel?: number | null,
          expectedUsefulLife?: number | null,
          defaultWarrantyPeriod?: number | null,
          defaultRiskScore?: number | null,
          manufacturerRecommendations?: string | null,
          image?: string | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          inUseStatus?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      isArchived?: boolean | null,
      thirdPartyId?: string | null,
      thirdPartySource?: string | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type DeleteFindingMutationVariables = {
  id: string,
};

export type DeleteFindingMutation = {
  deleteFinding?:  {
    __typename: "FindingResponse",
    data?:  {
      __typename: "Finding",
      id: string,
      tenantId?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      createdAt?: string | null,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      number?: number | null,
      displayNumber?: string | null,
      shortDescription?: string | null,
      priority?: number | null,
      estimatedRepairCost?: number | null,
      plannedRepairDate?: string | null,
      description?: string | null,
      cause?: string | null,
      symptom?: string | null,
      picture?: string | null,
      reportedOn?: string | null,
      workOrderId?: string | null,
      type?: FindingType | null,
      reportedById?: string | null,
      status?: FindingStatus | null,
      assetId?: string | null,
      asset?:  {
        __typename: "Asset",
        id: string,
        number?: number | null,
        displayNumber?: string | null,
        userId?: string | null,
        assetTag: string,
        description: string,
        makeId: string,
        modelId: string,
        state: string,
        usefulLife?: number | null,
        acquisitionCostValue?: number | null,
        lastMaintenanceDate?: string | null,
        nextScheduledMaintenanceDate?: string | null,
        assignedToId?: string | null,
        assetTypeId: string,
        condition?: string | null,
        maintenanceCostValue?: number | null,
        currentBookValue?: number | null,
        installDate?: string | null,
        decommissionDate?: string | null,
        locationId?: string | null,
        image?: string | null,
        purchaseOrderId?: string | null,
        utilizationData?: string | null,
        reasonForDecommission?: string | null,
        serialNumber: string,
        thirdPartyId?: string | null,
        source?: string | null,
        totalCostOfOwnershipValue?: number | null,
        repairCostValue?: number | null,
        warrantyExpiration?: string | null,
        downTime?: string | null,
        tenantId: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        model?:  {
          __typename: "Model",
          id: string,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          oemPartNumber?: string | null,
          name: string,
          manufacturerId: string,
          assetTypeId: string,
          probability?: number | null,
          severity?: number | null,
          riskScore?: number | null,
          picture?: string | null,
          specification?: string | null,
          usefulLife?: number | null,
          inUseStatus?: InUseStatus | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        assetType?:  {
          __typename: "AssetType",
          id: string,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          name: string,
          description?: string | null,
          category?: string | null,
          criticalityLevel?: number | null,
          expectedUsefulLife?: number | null,
          defaultWarrantyPeriod?: number | null,
          defaultRiskScore?: number | null,
          manufacturerRecommendations?: string | null,
          image?: string | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          inUseStatus?: string | null,
        } | null,
        manufacturer?:  {
          __typename: "Manufacturer",
          id: string,
          name: string,
          description?: string | null,
          countryId?: string | null,
          website?: string | null,
          contactPerson?: string | null,
          contactEmail?: string | null,
          contactPhone?: string | null,
          address?: string | null,
          warrantyPolicies?: string | null,
          slaDetails?: string | null,
          vendorPortalLink?: string | null,
          createdAt: string,
          createdBy: string,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          inUseStatus?: InUseStatus | null,
        } | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        woCount?: number | null,
        findingsCount?: number | null,
        user?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        assetRisk?: number | null,
        location?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        isParent?: boolean | null,
        thirdPartyParentId?: string | null,
        thirdPartyHierarchyPath?: Array< string | null > | null,
      } | null,
      locationId?: string | null,
      model?:  {
        __typename: "Model",
        id: string,
        tenantId: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        oemPartNumber?: string | null,
        name: string,
        manufacturerId: string,
        assetTypeId: string,
        probability?: number | null,
        severity?: number | null,
        riskScore?: number | null,
        picture?: string | null,
        specification?: string | null,
        usefulLife?: number | null,
        inUseStatus?: InUseStatus | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        manufacturer?:  {
          __typename: "Manufacturer",
          id: string,
          name: string,
          description?: string | null,
          countryId?: string | null,
          website?: string | null,
          contactPerson?: string | null,
          contactEmail?: string | null,
          contactPhone?: string | null,
          address?: string | null,
          warrantyPolicies?: string | null,
          slaDetails?: string | null,
          vendorPortalLink?: string | null,
          createdAt: string,
          createdBy: string,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          inUseStatus?: InUseStatus | null,
        } | null,
        assetType?:  {
          __typename: "AssetType",
          id: string,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          name: string,
          description?: string | null,
          category?: string | null,
          criticalityLevel?: number | null,
          expectedUsefulLife?: number | null,
          defaultWarrantyPeriod?: number | null,
          defaultRiskScore?: number | null,
          manufacturerRecommendations?: string | null,
          image?: string | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          inUseStatus?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      isArchived?: boolean | null,
      thirdPartyId?: string | null,
      thirdPartySource?: string | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type CreateUserMutationVariables = {
  data: UserInput,
};

export type CreateUserMutation = {
  createUser?:  {
    __typename: "UserResponse",
    data?:  {
      __typename: "User",
      id: string,
      tenantId?: string | null,
      createdAt?: string | null,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      groups?: string | null,
      email: string,
      name: string,
      phone?: string | null,
      role?: string | null,
      address?: string | null,
      location?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      createdByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      updatedByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type UpdateUserMutationVariables = {
  id: string,
  data: UserInput,
};

export type UpdateUserMutation = {
  updateUser?:  {
    __typename: "UserResponse",
    data?:  {
      __typename: "User",
      id: string,
      tenantId?: string | null,
      createdAt?: string | null,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      groups?: string | null,
      email: string,
      name: string,
      phone?: string | null,
      role?: string | null,
      address?: string | null,
      location?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      createdByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      updatedByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type DeleteUserMutationVariables = {
  id: string,
};

export type DeleteUserMutation = {
  deleteUser?:  {
    __typename: "UserResponse",
    data?:  {
      __typename: "User",
      id: string,
      tenantId?: string | null,
      createdAt?: string | null,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      groups?: string | null,
      email: string,
      name: string,
      phone?: string | null,
      role?: string | null,
      address?: string | null,
      location?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      createdByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      updatedByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type CreateTenantMutationVariables = {
  data: TenantInput,
};

export type CreateTenantMutation = {
  createTenant?:  {
    __typename: "TenantResponse",
    data?:  {
      __typename: "Tenant",
      id: string,
      createdAt: string,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      name: string,
      address?: string | null,
      contacts?: string | null,
      isActive?: boolean | null,
      cognitoGroupName?: string | null,
      tisId?: string | null,
      plan?: TenantPlan | null,
      tisSyncedAt?: string | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type UpdateTenantMutationVariables = {
  id: string,
  data: TenantInput,
};

export type UpdateTenantMutation = {
  updateTenant?:  {
    __typename: "TenantResponse",
    data?:  {
      __typename: "Tenant",
      id: string,
      createdAt: string,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      name: string,
      address?: string | null,
      contacts?: string | null,
      isActive?: boolean | null,
      cognitoGroupName?: string | null,
      tisId?: string | null,
      plan?: TenantPlan | null,
      tisSyncedAt?: string | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type DeleteTenantMutationVariables = {
  id: string,
};

export type DeleteTenantMutation = {
  deleteTenant?:  {
    __typename: "TenantResponse",
    data?:  {
      __typename: "Tenant",
      id: string,
      createdAt: string,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      name: string,
      address?: string | null,
      contacts?: string | null,
      isActive?: boolean | null,
      cognitoGroupName?: string | null,
      tisId?: string | null,
      plan?: TenantPlan | null,
      tisSyncedAt?: string | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type CreateLocationMutationVariables = {
  data: LocationInput,
};

export type CreateLocationMutation = {
  createLocation?:  {
    __typename: "LocationResponse",
    data?:  {
      __typename: "Location",
      id: string,
      tenantId: string,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      createdAt: string,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      name: string,
      notes?: string | null,
      lat?: number | null,
      lng?: number | null,
      level?: string | null,
      parentId?: string | null,
      rootId?: string | null,
      thirdPartyId?: string | null,
      source?: string | null,
      inUseStatus?: InUseStatus | null,
      address?: string | null,
      buildingAddress?: string | null,
      parent?:  {
        __typename: "Location",
        id: string,
        tenantId: string,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        notes?: string | null,
        lat?: number | null,
        lng?: number | null,
        level?: string | null,
        parentId?: string | null,
        rootId?: string | null,
        thirdPartyId?: string | null,
        source?: string | null,
        inUseStatus?: InUseStatus | null,
        address?: string | null,
        buildingAddress?: string | null,
        parent?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        tisSyncedAt?: string | null,
      } | null,
      tisSyncedAt?: string | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type UpdateLocationMutationVariables = {
  id: string,
  data: LocationInput,
};

export type UpdateLocationMutation = {
  updateLocation?:  {
    __typename: "LocationResponse",
    data?:  {
      __typename: "Location",
      id: string,
      tenantId: string,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      createdAt: string,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      name: string,
      notes?: string | null,
      lat?: number | null,
      lng?: number | null,
      level?: string | null,
      parentId?: string | null,
      rootId?: string | null,
      thirdPartyId?: string | null,
      source?: string | null,
      inUseStatus?: InUseStatus | null,
      address?: string | null,
      buildingAddress?: string | null,
      parent?:  {
        __typename: "Location",
        id: string,
        tenantId: string,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        notes?: string | null,
        lat?: number | null,
        lng?: number | null,
        level?: string | null,
        parentId?: string | null,
        rootId?: string | null,
        thirdPartyId?: string | null,
        source?: string | null,
        inUseStatus?: InUseStatus | null,
        address?: string | null,
        buildingAddress?: string | null,
        parent?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        tisSyncedAt?: string | null,
      } | null,
      tisSyncedAt?: string | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type DeleteLocationMutationVariables = {
  id: string,
};

export type DeleteLocationMutation = {
  deleteLocation?:  {
    __typename: "LocationResponse",
    data?:  {
      __typename: "Location",
      id: string,
      tenantId: string,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      createdAt: string,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      name: string,
      notes?: string | null,
      lat?: number | null,
      lng?: number | null,
      level?: string | null,
      parentId?: string | null,
      rootId?: string | null,
      thirdPartyId?: string | null,
      source?: string | null,
      inUseStatus?: InUseStatus | null,
      address?: string | null,
      buildingAddress?: string | null,
      parent?:  {
        __typename: "Location",
        id: string,
        tenantId: string,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        notes?: string | null,
        lat?: number | null,
        lng?: number | null,
        level?: string | null,
        parentId?: string | null,
        rootId?: string | null,
        thirdPartyId?: string | null,
        source?: string | null,
        inUseStatus?: InUseStatus | null,
        address?: string | null,
        buildingAddress?: string | null,
        parent?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        tisSyncedAt?: string | null,
      } | null,
      tisSyncedAt?: string | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type CreateExpenseMutationVariables = {
  data: ExpenseInput,
};

export type CreateExpenseMutation = {
  createExpense?:  {
    __typename: "ExpenseResponse",
    data?:  {
      __typename: "Expense",
      id: string,
      displayNumber?: string | null,
      tenantId: string,
      createdAt: string,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      title: string,
      description?: string | null,
      type?: string | null,
      status?: string | null,
      number?: number | null,
      amount?: number | null,
      purchaseOrderId?: string | null,
      workOrderId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      updatedByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      workOrder?:  {
        __typename: "WorkOrder",
        id?: string | null,
        displayNumber?: string | null,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt?: string | null,
        createdBy?: string | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        number?: number | null,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        locationId?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        dueDate?: string | null,
        startDate?: string | null,
        endDate?: string | null,
        duration?: string | null,
        plannedStartDate?: string | null,
        plannedEndDate?: string | null,
        assetId?: string | null,
        asset?:  {
          __typename: "Asset",
          id: string,
          number?: number | null,
          displayNumber?: string | null,
          userId?: string | null,
          assetTag: string,
          description: string,
          makeId: string,
          modelId: string,
          state: string,
          usefulLife?: number | null,
          acquisitionCostValue?: number | null,
          lastMaintenanceDate?: string | null,
          nextScheduledMaintenanceDate?: string | null,
          assignedToId?: string | null,
          assetTypeId: string,
          condition?: string | null,
          maintenanceCostValue?: number | null,
          currentBookValue?: number | null,
          installDate?: string | null,
          decommissionDate?: string | null,
          locationId?: string | null,
          image?: string | null,
          purchaseOrderId?: string | null,
          utilizationData?: string | null,
          reasonForDecommission?: string | null,
          serialNumber: string,
          thirdPartyId?: string | null,
          source?: string | null,
          totalCostOfOwnershipValue?: number | null,
          repairCostValue?: number | null,
          warrantyExpiration?: string | null,
          downTime?: string | null,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          model?:  {
            __typename: "Model",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            oemPartNumber?: string | null,
            name: string,
            manufacturerId: string,
            assetTypeId: string,
            probability?: number | null,
            severity?: number | null,
            riskScore?: number | null,
            picture?: string | null,
            specification?: string | null,
            usefulLife?: number | null,
            inUseStatus?: InUseStatus | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          woCount?: number | null,
          findingsCount?: number | null,
          user?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          assetRisk?: number | null,
          location?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          isParent?: boolean | null,
          thirdPartyParentId?: string | null,
          thirdPartyHierarchyPath?: Array< string | null > | null,
        } | null,
        assignmentGroupId?: string | null,
        assignedToId?: string | null,
        assignedTo?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        businessDownTime?: number | null,
        downTimeStart?: string | null,
        downTimeEnd?: string | null,
        category?: string | null,
        checklist?: string | null,
        closedNotes?: string | null,
        closedAt?: string | null,
        closedById?: string | null,
        closedBy?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        notes?: string | null,
        title?: string | null,
        description?: string | null,
        estimatedCostValue?: number | null,
        actualCostValue?: number | null,
        estimatedEffort?: number | null,
        actualEffort?: number | null,
        expectedOperationalDate?: string | null,
        impact?: number | null,
        priority?: number | null,
        dependsOnWorkOrderId?: string | null,
        dependsOnWorkOrder?:  {
          __typename: "WorkOrder",
          id?: string | null,
          displayNumber?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt?: string | null,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          number?: number | null,
          userId?: string | null,
          user?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          locationId?: string | null,
          location?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          dueDate?: string | null,
          startDate?: string | null,
          endDate?: string | null,
          duration?: string | null,
          plannedStartDate?: string | null,
          plannedEndDate?: string | null,
          assetId?: string | null,
          asset?:  {
            __typename: "Asset",
            id: string,
            number?: number | null,
            displayNumber?: string | null,
            userId?: string | null,
            assetTag: string,
            description: string,
            makeId: string,
            modelId: string,
            state: string,
            usefulLife?: number | null,
            acquisitionCostValue?: number | null,
            lastMaintenanceDate?: string | null,
            nextScheduledMaintenanceDate?: string | null,
            assignedToId?: string | null,
            assetTypeId: string,
            condition?: string | null,
            maintenanceCostValue?: number | null,
            currentBookValue?: number | null,
            installDate?: string | null,
            decommissionDate?: string | null,
            locationId?: string | null,
            image?: string | null,
            purchaseOrderId?: string | null,
            utilizationData?: string | null,
            reasonForDecommission?: string | null,
            serialNumber: string,
            thirdPartyId?: string | null,
            source?: string | null,
            totalCostOfOwnershipValue?: number | null,
            repairCostValue?: number | null,
            warrantyExpiration?: string | null,
            downTime?: string | null,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            woCount?: number | null,
            findingsCount?: number | null,
            assetRisk?: number | null,
            isParent?: boolean | null,
            thirdPartyParentId?: string | null,
            thirdPartyHierarchyPath?: Array< string | null > | null,
          } | null,
          assignmentGroupId?: string | null,
          assignedToId?: string | null,
          assignedTo?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          businessDownTime?: number | null,
          downTimeStart?: string | null,
          downTimeEnd?: string | null,
          category?: string | null,
          checklist?: string | null,
          closedNotes?: string | null,
          closedAt?: string | null,
          closedById?: string | null,
          closedBy?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          notes?: string | null,
          title?: string | null,
          description?: string | null,
          estimatedCostValue?: number | null,
          actualCostValue?: number | null,
          estimatedEffort?: number | null,
          actualEffort?: number | null,
          expectedOperationalDate?: string | null,
          impact?: number | null,
          priority?: number | null,
          dependsOnWorkOrderId?: string | null,
          dependsOnWorkOrder?:  {
            __typename: "WorkOrder",
            id?: string | null,
            displayNumber?: string | null,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            number?: number | null,
            userId?: string | null,
            locationId?: string | null,
            dueDate?: string | null,
            startDate?: string | null,
            endDate?: string | null,
            duration?: string | null,
            plannedStartDate?: string | null,
            plannedEndDate?: string | null,
            assetId?: string | null,
            assignmentGroupId?: string | null,
            assignedToId?: string | null,
            businessDownTime?: number | null,
            downTimeStart?: string | null,
            downTimeEnd?: string | null,
            category?: string | null,
            checklist?: string | null,
            closedNotes?: string | null,
            closedAt?: string | null,
            closedById?: string | null,
            notes?: string | null,
            title?: string | null,
            description?: string | null,
            estimatedCostValue?: number | null,
            actualCostValue?: number | null,
            estimatedEffort?: number | null,
            actualEffort?: number | null,
            expectedOperationalDate?: string | null,
            impact?: number | null,
            priority?: number | null,
            dependsOnWorkOrderId?: string | null,
            state?: string | null,
            type?: string | null,
            templateId?: string | null,
            isArchived?: boolean | null,
            findingId?: string | null,
            seenByAssignee?: boolean | null,
            assignmentDateTime?: string | null,
            seenDateTime?: string | null,
            startOfWorkDateTime?: string | null,
            endOfWorkDateTime?: string | null,
          } | null,
          state?: string | null,
          type?: string | null,
          templateId?: string | null,
          isArchived?: boolean | null,
          findingId?: string | null,
          seenByAssignee?: boolean | null,
          assignmentDateTime?: string | null,
          seenDateTime?: string | null,
          startOfWorkDateTime?: string | null,
          endOfWorkDateTime?: string | null,
        } | null,
        state?: string | null,
        type?: string | null,
        templateId?: string | null,
        isArchived?: boolean | null,
        findingId?: string | null,
        seenByAssignee?: boolean | null,
        assignmentDateTime?: string | null,
        seenDateTime?: string | null,
        startOfWorkDateTime?: string | null,
        endOfWorkDateTime?: string | null,
      } | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type UpdateExpenseMutationVariables = {
  id: string,
  data: ExpenseInput,
};

export type UpdateExpenseMutation = {
  updateExpense?:  {
    __typename: "ExpenseResponse",
    data?:  {
      __typename: "Expense",
      id: string,
      displayNumber?: string | null,
      tenantId: string,
      createdAt: string,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      title: string,
      description?: string | null,
      type?: string | null,
      status?: string | null,
      number?: number | null,
      amount?: number | null,
      purchaseOrderId?: string | null,
      workOrderId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      updatedByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      workOrder?:  {
        __typename: "WorkOrder",
        id?: string | null,
        displayNumber?: string | null,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt?: string | null,
        createdBy?: string | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        number?: number | null,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        locationId?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        dueDate?: string | null,
        startDate?: string | null,
        endDate?: string | null,
        duration?: string | null,
        plannedStartDate?: string | null,
        plannedEndDate?: string | null,
        assetId?: string | null,
        asset?:  {
          __typename: "Asset",
          id: string,
          number?: number | null,
          displayNumber?: string | null,
          userId?: string | null,
          assetTag: string,
          description: string,
          makeId: string,
          modelId: string,
          state: string,
          usefulLife?: number | null,
          acquisitionCostValue?: number | null,
          lastMaintenanceDate?: string | null,
          nextScheduledMaintenanceDate?: string | null,
          assignedToId?: string | null,
          assetTypeId: string,
          condition?: string | null,
          maintenanceCostValue?: number | null,
          currentBookValue?: number | null,
          installDate?: string | null,
          decommissionDate?: string | null,
          locationId?: string | null,
          image?: string | null,
          purchaseOrderId?: string | null,
          utilizationData?: string | null,
          reasonForDecommission?: string | null,
          serialNumber: string,
          thirdPartyId?: string | null,
          source?: string | null,
          totalCostOfOwnershipValue?: number | null,
          repairCostValue?: number | null,
          warrantyExpiration?: string | null,
          downTime?: string | null,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          model?:  {
            __typename: "Model",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            oemPartNumber?: string | null,
            name: string,
            manufacturerId: string,
            assetTypeId: string,
            probability?: number | null,
            severity?: number | null,
            riskScore?: number | null,
            picture?: string | null,
            specification?: string | null,
            usefulLife?: number | null,
            inUseStatus?: InUseStatus | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          woCount?: number | null,
          findingsCount?: number | null,
          user?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          assetRisk?: number | null,
          location?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          isParent?: boolean | null,
          thirdPartyParentId?: string | null,
          thirdPartyHierarchyPath?: Array< string | null > | null,
        } | null,
        assignmentGroupId?: string | null,
        assignedToId?: string | null,
        assignedTo?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        businessDownTime?: number | null,
        downTimeStart?: string | null,
        downTimeEnd?: string | null,
        category?: string | null,
        checklist?: string | null,
        closedNotes?: string | null,
        closedAt?: string | null,
        closedById?: string | null,
        closedBy?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        notes?: string | null,
        title?: string | null,
        description?: string | null,
        estimatedCostValue?: number | null,
        actualCostValue?: number | null,
        estimatedEffort?: number | null,
        actualEffort?: number | null,
        expectedOperationalDate?: string | null,
        impact?: number | null,
        priority?: number | null,
        dependsOnWorkOrderId?: string | null,
        dependsOnWorkOrder?:  {
          __typename: "WorkOrder",
          id?: string | null,
          displayNumber?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt?: string | null,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          number?: number | null,
          userId?: string | null,
          user?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          locationId?: string | null,
          location?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          dueDate?: string | null,
          startDate?: string | null,
          endDate?: string | null,
          duration?: string | null,
          plannedStartDate?: string | null,
          plannedEndDate?: string | null,
          assetId?: string | null,
          asset?:  {
            __typename: "Asset",
            id: string,
            number?: number | null,
            displayNumber?: string | null,
            userId?: string | null,
            assetTag: string,
            description: string,
            makeId: string,
            modelId: string,
            state: string,
            usefulLife?: number | null,
            acquisitionCostValue?: number | null,
            lastMaintenanceDate?: string | null,
            nextScheduledMaintenanceDate?: string | null,
            assignedToId?: string | null,
            assetTypeId: string,
            condition?: string | null,
            maintenanceCostValue?: number | null,
            currentBookValue?: number | null,
            installDate?: string | null,
            decommissionDate?: string | null,
            locationId?: string | null,
            image?: string | null,
            purchaseOrderId?: string | null,
            utilizationData?: string | null,
            reasonForDecommission?: string | null,
            serialNumber: string,
            thirdPartyId?: string | null,
            source?: string | null,
            totalCostOfOwnershipValue?: number | null,
            repairCostValue?: number | null,
            warrantyExpiration?: string | null,
            downTime?: string | null,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            woCount?: number | null,
            findingsCount?: number | null,
            assetRisk?: number | null,
            isParent?: boolean | null,
            thirdPartyParentId?: string | null,
            thirdPartyHierarchyPath?: Array< string | null > | null,
          } | null,
          assignmentGroupId?: string | null,
          assignedToId?: string | null,
          assignedTo?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          businessDownTime?: number | null,
          downTimeStart?: string | null,
          downTimeEnd?: string | null,
          category?: string | null,
          checklist?: string | null,
          closedNotes?: string | null,
          closedAt?: string | null,
          closedById?: string | null,
          closedBy?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          notes?: string | null,
          title?: string | null,
          description?: string | null,
          estimatedCostValue?: number | null,
          actualCostValue?: number | null,
          estimatedEffort?: number | null,
          actualEffort?: number | null,
          expectedOperationalDate?: string | null,
          impact?: number | null,
          priority?: number | null,
          dependsOnWorkOrderId?: string | null,
          dependsOnWorkOrder?:  {
            __typename: "WorkOrder",
            id?: string | null,
            displayNumber?: string | null,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            number?: number | null,
            userId?: string | null,
            locationId?: string | null,
            dueDate?: string | null,
            startDate?: string | null,
            endDate?: string | null,
            duration?: string | null,
            plannedStartDate?: string | null,
            plannedEndDate?: string | null,
            assetId?: string | null,
            assignmentGroupId?: string | null,
            assignedToId?: string | null,
            businessDownTime?: number | null,
            downTimeStart?: string | null,
            downTimeEnd?: string | null,
            category?: string | null,
            checklist?: string | null,
            closedNotes?: string | null,
            closedAt?: string | null,
            closedById?: string | null,
            notes?: string | null,
            title?: string | null,
            description?: string | null,
            estimatedCostValue?: number | null,
            actualCostValue?: number | null,
            estimatedEffort?: number | null,
            actualEffort?: number | null,
            expectedOperationalDate?: string | null,
            impact?: number | null,
            priority?: number | null,
            dependsOnWorkOrderId?: string | null,
            state?: string | null,
            type?: string | null,
            templateId?: string | null,
            isArchived?: boolean | null,
            findingId?: string | null,
            seenByAssignee?: boolean | null,
            assignmentDateTime?: string | null,
            seenDateTime?: string | null,
            startOfWorkDateTime?: string | null,
            endOfWorkDateTime?: string | null,
          } | null,
          state?: string | null,
          type?: string | null,
          templateId?: string | null,
          isArchived?: boolean | null,
          findingId?: string | null,
          seenByAssignee?: boolean | null,
          assignmentDateTime?: string | null,
          seenDateTime?: string | null,
          startOfWorkDateTime?: string | null,
          endOfWorkDateTime?: string | null,
        } | null,
        state?: string | null,
        type?: string | null,
        templateId?: string | null,
        isArchived?: boolean | null,
        findingId?: string | null,
        seenByAssignee?: boolean | null,
        assignmentDateTime?: string | null,
        seenDateTime?: string | null,
        startOfWorkDateTime?: string | null,
        endOfWorkDateTime?: string | null,
      } | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type DeleteExpenseMutationVariables = {
  id: string,
};

export type DeleteExpenseMutation = {
  deleteExpense?:  {
    __typename: "ExpenseResponse",
    data?:  {
      __typename: "Expense",
      id: string,
      displayNumber?: string | null,
      tenantId: string,
      createdAt: string,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      title: string,
      description?: string | null,
      type?: string | null,
      status?: string | null,
      number?: number | null,
      amount?: number | null,
      purchaseOrderId?: string | null,
      workOrderId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      updatedByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      workOrder?:  {
        __typename: "WorkOrder",
        id?: string | null,
        displayNumber?: string | null,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt?: string | null,
        createdBy?: string | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        number?: number | null,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        locationId?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        dueDate?: string | null,
        startDate?: string | null,
        endDate?: string | null,
        duration?: string | null,
        plannedStartDate?: string | null,
        plannedEndDate?: string | null,
        assetId?: string | null,
        asset?:  {
          __typename: "Asset",
          id: string,
          number?: number | null,
          displayNumber?: string | null,
          userId?: string | null,
          assetTag: string,
          description: string,
          makeId: string,
          modelId: string,
          state: string,
          usefulLife?: number | null,
          acquisitionCostValue?: number | null,
          lastMaintenanceDate?: string | null,
          nextScheduledMaintenanceDate?: string | null,
          assignedToId?: string | null,
          assetTypeId: string,
          condition?: string | null,
          maintenanceCostValue?: number | null,
          currentBookValue?: number | null,
          installDate?: string | null,
          decommissionDate?: string | null,
          locationId?: string | null,
          image?: string | null,
          purchaseOrderId?: string | null,
          utilizationData?: string | null,
          reasonForDecommission?: string | null,
          serialNumber: string,
          thirdPartyId?: string | null,
          source?: string | null,
          totalCostOfOwnershipValue?: number | null,
          repairCostValue?: number | null,
          warrantyExpiration?: string | null,
          downTime?: string | null,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          model?:  {
            __typename: "Model",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            oemPartNumber?: string | null,
            name: string,
            manufacturerId: string,
            assetTypeId: string,
            probability?: number | null,
            severity?: number | null,
            riskScore?: number | null,
            picture?: string | null,
            specification?: string | null,
            usefulLife?: number | null,
            inUseStatus?: InUseStatus | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          woCount?: number | null,
          findingsCount?: number | null,
          user?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          assetRisk?: number | null,
          location?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          isParent?: boolean | null,
          thirdPartyParentId?: string | null,
          thirdPartyHierarchyPath?: Array< string | null > | null,
        } | null,
        assignmentGroupId?: string | null,
        assignedToId?: string | null,
        assignedTo?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        businessDownTime?: number | null,
        downTimeStart?: string | null,
        downTimeEnd?: string | null,
        category?: string | null,
        checklist?: string | null,
        closedNotes?: string | null,
        closedAt?: string | null,
        closedById?: string | null,
        closedBy?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        notes?: string | null,
        title?: string | null,
        description?: string | null,
        estimatedCostValue?: number | null,
        actualCostValue?: number | null,
        estimatedEffort?: number | null,
        actualEffort?: number | null,
        expectedOperationalDate?: string | null,
        impact?: number | null,
        priority?: number | null,
        dependsOnWorkOrderId?: string | null,
        dependsOnWorkOrder?:  {
          __typename: "WorkOrder",
          id?: string | null,
          displayNumber?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt?: string | null,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          number?: number | null,
          userId?: string | null,
          user?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          locationId?: string | null,
          location?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          dueDate?: string | null,
          startDate?: string | null,
          endDate?: string | null,
          duration?: string | null,
          plannedStartDate?: string | null,
          plannedEndDate?: string | null,
          assetId?: string | null,
          asset?:  {
            __typename: "Asset",
            id: string,
            number?: number | null,
            displayNumber?: string | null,
            userId?: string | null,
            assetTag: string,
            description: string,
            makeId: string,
            modelId: string,
            state: string,
            usefulLife?: number | null,
            acquisitionCostValue?: number | null,
            lastMaintenanceDate?: string | null,
            nextScheduledMaintenanceDate?: string | null,
            assignedToId?: string | null,
            assetTypeId: string,
            condition?: string | null,
            maintenanceCostValue?: number | null,
            currentBookValue?: number | null,
            installDate?: string | null,
            decommissionDate?: string | null,
            locationId?: string | null,
            image?: string | null,
            purchaseOrderId?: string | null,
            utilizationData?: string | null,
            reasonForDecommission?: string | null,
            serialNumber: string,
            thirdPartyId?: string | null,
            source?: string | null,
            totalCostOfOwnershipValue?: number | null,
            repairCostValue?: number | null,
            warrantyExpiration?: string | null,
            downTime?: string | null,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            woCount?: number | null,
            findingsCount?: number | null,
            assetRisk?: number | null,
            isParent?: boolean | null,
            thirdPartyParentId?: string | null,
            thirdPartyHierarchyPath?: Array< string | null > | null,
          } | null,
          assignmentGroupId?: string | null,
          assignedToId?: string | null,
          assignedTo?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          businessDownTime?: number | null,
          downTimeStart?: string | null,
          downTimeEnd?: string | null,
          category?: string | null,
          checklist?: string | null,
          closedNotes?: string | null,
          closedAt?: string | null,
          closedById?: string | null,
          closedBy?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          notes?: string | null,
          title?: string | null,
          description?: string | null,
          estimatedCostValue?: number | null,
          actualCostValue?: number | null,
          estimatedEffort?: number | null,
          actualEffort?: number | null,
          expectedOperationalDate?: string | null,
          impact?: number | null,
          priority?: number | null,
          dependsOnWorkOrderId?: string | null,
          dependsOnWorkOrder?:  {
            __typename: "WorkOrder",
            id?: string | null,
            displayNumber?: string | null,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            number?: number | null,
            userId?: string | null,
            locationId?: string | null,
            dueDate?: string | null,
            startDate?: string | null,
            endDate?: string | null,
            duration?: string | null,
            plannedStartDate?: string | null,
            plannedEndDate?: string | null,
            assetId?: string | null,
            assignmentGroupId?: string | null,
            assignedToId?: string | null,
            businessDownTime?: number | null,
            downTimeStart?: string | null,
            downTimeEnd?: string | null,
            category?: string | null,
            checklist?: string | null,
            closedNotes?: string | null,
            closedAt?: string | null,
            closedById?: string | null,
            notes?: string | null,
            title?: string | null,
            description?: string | null,
            estimatedCostValue?: number | null,
            actualCostValue?: number | null,
            estimatedEffort?: number | null,
            actualEffort?: number | null,
            expectedOperationalDate?: string | null,
            impact?: number | null,
            priority?: number | null,
            dependsOnWorkOrderId?: string | null,
            state?: string | null,
            type?: string | null,
            templateId?: string | null,
            isArchived?: boolean | null,
            findingId?: string | null,
            seenByAssignee?: boolean | null,
            assignmentDateTime?: string | null,
            seenDateTime?: string | null,
            startOfWorkDateTime?: string | null,
            endOfWorkDateTime?: string | null,
          } | null,
          state?: string | null,
          type?: string | null,
          templateId?: string | null,
          isArchived?: boolean | null,
          findingId?: string | null,
          seenByAssignee?: boolean | null,
          assignmentDateTime?: string | null,
          seenDateTime?: string | null,
          startOfWorkDateTime?: string | null,
          endOfWorkDateTime?: string | null,
        } | null,
        state?: string | null,
        type?: string | null,
        templateId?: string | null,
        isArchived?: boolean | null,
        findingId?: string | null,
        seenByAssignee?: boolean | null,
        assignmentDateTime?: string | null,
        seenDateTime?: string | null,
        startOfWorkDateTime?: string | null,
        endOfWorkDateTime?: string | null,
      } | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type CreateAssetTypeMutationVariables = {
  data: AssetTypeInput,
};

export type CreateAssetTypeMutation = {
  createAssetType?:  {
    __typename: "AssetTypeResponse",
    data?:  {
      __typename: "AssetType",
      id: string,
      tenantId?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      createdAt: string,
      createdBy?: string | null,
      createdByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      updatedByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      name: string,
      description?: string | null,
      category?: string | null,
      criticalityLevel?: number | null,
      expectedUsefulLife?: number | null,
      defaultWarrantyPeriod?: number | null,
      defaultRiskScore?: number | null,
      manufacturerRecommendations?: string | null,
      image?: string | null,
      thirdPartyId?: string | null,
      thirdPartySource?: string | null,
      inUseStatus?: string | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type UpdateAssetTypeMutationVariables = {
  id: string,
  data: AssetTypeInput,
};

export type UpdateAssetTypeMutation = {
  updateAssetType?:  {
    __typename: "AssetTypeResponse",
    data?:  {
      __typename: "AssetType",
      id: string,
      tenantId?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      createdAt: string,
      createdBy?: string | null,
      createdByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      updatedByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      name: string,
      description?: string | null,
      category?: string | null,
      criticalityLevel?: number | null,
      expectedUsefulLife?: number | null,
      defaultWarrantyPeriod?: number | null,
      defaultRiskScore?: number | null,
      manufacturerRecommendations?: string | null,
      image?: string | null,
      thirdPartyId?: string | null,
      thirdPartySource?: string | null,
      inUseStatus?: string | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type DeleteAssetTypeMutationVariables = {
  id: string,
};

export type DeleteAssetTypeMutation = {
  deleteAssetType?:  {
    __typename: "AssetTypeResponse",
    data?:  {
      __typename: "AssetType",
      id: string,
      tenantId?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      createdAt: string,
      createdBy?: string | null,
      createdByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      updatedByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      name: string,
      description?: string | null,
      category?: string | null,
      criticalityLevel?: number | null,
      expectedUsefulLife?: number | null,
      defaultWarrantyPeriod?: number | null,
      defaultRiskScore?: number | null,
      manufacturerRecommendations?: string | null,
      image?: string | null,
      thirdPartyId?: string | null,
      thirdPartySource?: string | null,
      inUseStatus?: string | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type CreateAttachmentMutationVariables = {
  data: AttachmentInput,
};

export type CreateAttachmentMutation = {
  createAttachment?:  {
    __typename: "AttachmentResponse",
    data?:  {
      __typename: "Attachment",
      id: string,
      tenantId: string,
      createdAt: string,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      fileName: string,
      originalFileName: string,
      path: string,
      downloadUrl?: string | null,
      mimeType: string,
      size: number,
      description?: string | null,
      relatedTable: string,
      relatedItem: string,
      type: string,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type UpdateAttachmentMutationVariables = {
  id: string,
  data: AttachmentInput,
};

export type UpdateAttachmentMutation = {
  updateAttachment?:  {
    __typename: "AttachmentResponse",
    data?:  {
      __typename: "Attachment",
      id: string,
      tenantId: string,
      createdAt: string,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      fileName: string,
      originalFileName: string,
      path: string,
      downloadUrl?: string | null,
      mimeType: string,
      size: number,
      description?: string | null,
      relatedTable: string,
      relatedItem: string,
      type: string,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type DeleteAttachmentMutationVariables = {
  id: string,
};

export type DeleteAttachmentMutation = {
  deleteAttachment?:  {
    __typename: "AttachmentResponse",
    data?:  {
      __typename: "Attachment",
      id: string,
      tenantId: string,
      createdAt: string,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      fileName: string,
      originalFileName: string,
      path: string,
      downloadUrl?: string | null,
      mimeType: string,
      size: number,
      description?: string | null,
      relatedTable: string,
      relatedItem: string,
      type: string,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type DeleteAttachmentAndCleanRefsMutationVariables = {
  id: string,
  data?: DeleteAttachmentCleanInput | null,
};

export type DeleteAttachmentAndCleanRefsMutation = {
  deleteAttachmentAndCleanRefs?:  {
    __typename: "AttachmentResponse",
    data?:  {
      __typename: "Attachment",
      id: string,
      tenantId: string,
      createdAt: string,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      fileName: string,
      originalFileName: string,
      path: string,
      downloadUrl?: string | null,
      mimeType: string,
      size: number,
      description?: string | null,
      relatedTable: string,
      relatedItem: string,
      type: string,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type GetAttachmentUploadUrlsMutationVariables = {
  files?: Array< AttachmentUploadBaseData | null > | null,
};

export type GetAttachmentUploadUrlsMutation = {
  getAttachmentUploadUrls?:  {
    __typename: "AttachmentUploadUrlResponse",
    data?:  Array< {
      __typename: "AttachmentUploadUrl",
      uploadUrl: string,
      uploadName: string,
      originalFileName: string,
    } | null > | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type UpdateAlertMutationVariables = {
  id: string,
  data: AlertInput,
};

export type UpdateAlertMutation = {
  updateAlert?:  {
    __typename: "AlertResponse",
    data?:  {
      __typename: "Alert",
      id: string,
      number: number,
      displayNumber?: string | null,
      asset?:  {
        __typename: "Asset",
        id: string,
        number?: number | null,
        displayNumber?: string | null,
        userId?: string | null,
        assetTag: string,
        description: string,
        makeId: string,
        modelId: string,
        state: string,
        usefulLife?: number | null,
        acquisitionCostValue?: number | null,
        lastMaintenanceDate?: string | null,
        nextScheduledMaintenanceDate?: string | null,
        assignedToId?: string | null,
        assetTypeId: string,
        condition?: string | null,
        maintenanceCostValue?: number | null,
        currentBookValue?: number | null,
        installDate?: string | null,
        decommissionDate?: string | null,
        locationId?: string | null,
        image?: string | null,
        purchaseOrderId?: string | null,
        utilizationData?: string | null,
        reasonForDecommission?: string | null,
        serialNumber: string,
        thirdPartyId?: string | null,
        source?: string | null,
        totalCostOfOwnershipValue?: number | null,
        repairCostValue?: number | null,
        warrantyExpiration?: string | null,
        downTime?: string | null,
        tenantId: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        model?:  {
          __typename: "Model",
          id: string,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          oemPartNumber?: string | null,
          name: string,
          manufacturerId: string,
          assetTypeId: string,
          probability?: number | null,
          severity?: number | null,
          riskScore?: number | null,
          picture?: string | null,
          specification?: string | null,
          usefulLife?: number | null,
          inUseStatus?: InUseStatus | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        assetType?:  {
          __typename: "AssetType",
          id: string,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          name: string,
          description?: string | null,
          category?: string | null,
          criticalityLevel?: number | null,
          expectedUsefulLife?: number | null,
          defaultWarrantyPeriod?: number | null,
          defaultRiskScore?: number | null,
          manufacturerRecommendations?: string | null,
          image?: string | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          inUseStatus?: string | null,
        } | null,
        manufacturer?:  {
          __typename: "Manufacturer",
          id: string,
          name: string,
          description?: string | null,
          countryId?: string | null,
          website?: string | null,
          contactPerson?: string | null,
          contactEmail?: string | null,
          contactPhone?: string | null,
          address?: string | null,
          warrantyPolicies?: string | null,
          slaDetails?: string | null,
          vendorPortalLink?: string | null,
          createdAt: string,
          createdBy: string,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          inUseStatus?: InUseStatus | null,
        } | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        woCount?: number | null,
        findingsCount?: number | null,
        user?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        assetRisk?: number | null,
        location?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        isParent?: boolean | null,
        thirdPartyParentId?: string | null,
        thirdPartyHierarchyPath?: Array< string | null > | null,
      } | null,
      assetId?: string | null,
      daysFailed?: string | null,
      tisStatus?: string | null,
      state: AlertState,
      firstException?: string | null,
      worstException?: string | null,
      lastException?: string | null,
      impactComfort?: string | null,
      impactEnergy?: string | null,
      impactReliability?: string | null,
      testValue?: string | null,
      exceptionName?: string | null,
      suggestionDescription?: string | null,
      suggestionCauses?: string | null,
      workOrder?:  {
        __typename: "WorkOrder",
        id?: string | null,
        displayNumber?: string | null,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt?: string | null,
        createdBy?: string | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        number?: number | null,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        locationId?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        dueDate?: string | null,
        startDate?: string | null,
        endDate?: string | null,
        duration?: string | null,
        plannedStartDate?: string | null,
        plannedEndDate?: string | null,
        assetId?: string | null,
        asset?:  {
          __typename: "Asset",
          id: string,
          number?: number | null,
          displayNumber?: string | null,
          userId?: string | null,
          assetTag: string,
          description: string,
          makeId: string,
          modelId: string,
          state: string,
          usefulLife?: number | null,
          acquisitionCostValue?: number | null,
          lastMaintenanceDate?: string | null,
          nextScheduledMaintenanceDate?: string | null,
          assignedToId?: string | null,
          assetTypeId: string,
          condition?: string | null,
          maintenanceCostValue?: number | null,
          currentBookValue?: number | null,
          installDate?: string | null,
          decommissionDate?: string | null,
          locationId?: string | null,
          image?: string | null,
          purchaseOrderId?: string | null,
          utilizationData?: string | null,
          reasonForDecommission?: string | null,
          serialNumber: string,
          thirdPartyId?: string | null,
          source?: string | null,
          totalCostOfOwnershipValue?: number | null,
          repairCostValue?: number | null,
          warrantyExpiration?: string | null,
          downTime?: string | null,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          model?:  {
            __typename: "Model",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            oemPartNumber?: string | null,
            name: string,
            manufacturerId: string,
            assetTypeId: string,
            probability?: number | null,
            severity?: number | null,
            riskScore?: number | null,
            picture?: string | null,
            specification?: string | null,
            usefulLife?: number | null,
            inUseStatus?: InUseStatus | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          woCount?: number | null,
          findingsCount?: number | null,
          user?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          assetRisk?: number | null,
          location?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          isParent?: boolean | null,
          thirdPartyParentId?: string | null,
          thirdPartyHierarchyPath?: Array< string | null > | null,
        } | null,
        assignmentGroupId?: string | null,
        assignedToId?: string | null,
        assignedTo?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        businessDownTime?: number | null,
        downTimeStart?: string | null,
        downTimeEnd?: string | null,
        category?: string | null,
        checklist?: string | null,
        closedNotes?: string | null,
        closedAt?: string | null,
        closedById?: string | null,
        closedBy?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        notes?: string | null,
        title?: string | null,
        description?: string | null,
        estimatedCostValue?: number | null,
        actualCostValue?: number | null,
        estimatedEffort?: number | null,
        actualEffort?: number | null,
        expectedOperationalDate?: string | null,
        impact?: number | null,
        priority?: number | null,
        dependsOnWorkOrderId?: string | null,
        dependsOnWorkOrder?:  {
          __typename: "WorkOrder",
          id?: string | null,
          displayNumber?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt?: string | null,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          number?: number | null,
          userId?: string | null,
          user?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          locationId?: string | null,
          location?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          dueDate?: string | null,
          startDate?: string | null,
          endDate?: string | null,
          duration?: string | null,
          plannedStartDate?: string | null,
          plannedEndDate?: string | null,
          assetId?: string | null,
          asset?:  {
            __typename: "Asset",
            id: string,
            number?: number | null,
            displayNumber?: string | null,
            userId?: string | null,
            assetTag: string,
            description: string,
            makeId: string,
            modelId: string,
            state: string,
            usefulLife?: number | null,
            acquisitionCostValue?: number | null,
            lastMaintenanceDate?: string | null,
            nextScheduledMaintenanceDate?: string | null,
            assignedToId?: string | null,
            assetTypeId: string,
            condition?: string | null,
            maintenanceCostValue?: number | null,
            currentBookValue?: number | null,
            installDate?: string | null,
            decommissionDate?: string | null,
            locationId?: string | null,
            image?: string | null,
            purchaseOrderId?: string | null,
            utilizationData?: string | null,
            reasonForDecommission?: string | null,
            serialNumber: string,
            thirdPartyId?: string | null,
            source?: string | null,
            totalCostOfOwnershipValue?: number | null,
            repairCostValue?: number | null,
            warrantyExpiration?: string | null,
            downTime?: string | null,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            woCount?: number | null,
            findingsCount?: number | null,
            assetRisk?: number | null,
            isParent?: boolean | null,
            thirdPartyParentId?: string | null,
            thirdPartyHierarchyPath?: Array< string | null > | null,
          } | null,
          assignmentGroupId?: string | null,
          assignedToId?: string | null,
          assignedTo?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          businessDownTime?: number | null,
          downTimeStart?: string | null,
          downTimeEnd?: string | null,
          category?: string | null,
          checklist?: string | null,
          closedNotes?: string | null,
          closedAt?: string | null,
          closedById?: string | null,
          closedBy?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          notes?: string | null,
          title?: string | null,
          description?: string | null,
          estimatedCostValue?: number | null,
          actualCostValue?: number | null,
          estimatedEffort?: number | null,
          actualEffort?: number | null,
          expectedOperationalDate?: string | null,
          impact?: number | null,
          priority?: number | null,
          dependsOnWorkOrderId?: string | null,
          dependsOnWorkOrder?:  {
            __typename: "WorkOrder",
            id?: string | null,
            displayNumber?: string | null,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            number?: number | null,
            userId?: string | null,
            locationId?: string | null,
            dueDate?: string | null,
            startDate?: string | null,
            endDate?: string | null,
            duration?: string | null,
            plannedStartDate?: string | null,
            plannedEndDate?: string | null,
            assetId?: string | null,
            assignmentGroupId?: string | null,
            assignedToId?: string | null,
            businessDownTime?: number | null,
            downTimeStart?: string | null,
            downTimeEnd?: string | null,
            category?: string | null,
            checklist?: string | null,
            closedNotes?: string | null,
            closedAt?: string | null,
            closedById?: string | null,
            notes?: string | null,
            title?: string | null,
            description?: string | null,
            estimatedCostValue?: number | null,
            actualCostValue?: number | null,
            estimatedEffort?: number | null,
            actualEffort?: number | null,
            expectedOperationalDate?: string | null,
            impact?: number | null,
            priority?: number | null,
            dependsOnWorkOrderId?: string | null,
            state?: string | null,
            type?: string | null,
            templateId?: string | null,
            isArchived?: boolean | null,
            findingId?: string | null,
            seenByAssignee?: boolean | null,
            assignmentDateTime?: string | null,
            seenDateTime?: string | null,
            startOfWorkDateTime?: string | null,
            endOfWorkDateTime?: string | null,
          } | null,
          state?: string | null,
          type?: string | null,
          templateId?: string | null,
          isArchived?: boolean | null,
          findingId?: string | null,
          seenByAssignee?: boolean | null,
          assignmentDateTime?: string | null,
          seenDateTime?: string | null,
          startOfWorkDateTime?: string | null,
          endOfWorkDateTime?: string | null,
        } | null,
        state?: string | null,
        type?: string | null,
        templateId?: string | null,
        isArchived?: boolean | null,
        findingId?: string | null,
        seenByAssignee?: boolean | null,
        assignmentDateTime?: string | null,
        seenDateTime?: string | null,
        startOfWorkDateTime?: string | null,
        endOfWorkDateTime?: string | null,
      } | null,
      workOrderId?: string | null,
      finding?:  {
        __typename: "Finding",
        id: string,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        number?: number | null,
        displayNumber?: string | null,
        shortDescription?: string | null,
        priority?: number | null,
        estimatedRepairCost?: number | null,
        plannedRepairDate?: string | null,
        description?: string | null,
        cause?: string | null,
        symptom?: string | null,
        picture?: string | null,
        reportedOn?: string | null,
        workOrderId?: string | null,
        type?: FindingType | null,
        reportedById?: string | null,
        status?: FindingStatus | null,
        assetId?: string | null,
        asset?:  {
          __typename: "Asset",
          id: string,
          number?: number | null,
          displayNumber?: string | null,
          userId?: string | null,
          assetTag: string,
          description: string,
          makeId: string,
          modelId: string,
          state: string,
          usefulLife?: number | null,
          acquisitionCostValue?: number | null,
          lastMaintenanceDate?: string | null,
          nextScheduledMaintenanceDate?: string | null,
          assignedToId?: string | null,
          assetTypeId: string,
          condition?: string | null,
          maintenanceCostValue?: number | null,
          currentBookValue?: number | null,
          installDate?: string | null,
          decommissionDate?: string | null,
          locationId?: string | null,
          image?: string | null,
          purchaseOrderId?: string | null,
          utilizationData?: string | null,
          reasonForDecommission?: string | null,
          serialNumber: string,
          thirdPartyId?: string | null,
          source?: string | null,
          totalCostOfOwnershipValue?: number | null,
          repairCostValue?: number | null,
          warrantyExpiration?: string | null,
          downTime?: string | null,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          model?:  {
            __typename: "Model",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            oemPartNumber?: string | null,
            name: string,
            manufacturerId: string,
            assetTypeId: string,
            probability?: number | null,
            severity?: number | null,
            riskScore?: number | null,
            picture?: string | null,
            specification?: string | null,
            usefulLife?: number | null,
            inUseStatus?: InUseStatus | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          woCount?: number | null,
          findingsCount?: number | null,
          user?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          assetRisk?: number | null,
          location?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          isParent?: boolean | null,
          thirdPartyParentId?: string | null,
          thirdPartyHierarchyPath?: Array< string | null > | null,
        } | null,
        locationId?: string | null,
        model?:  {
          __typename: "Model",
          id: string,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          oemPartNumber?: string | null,
          name: string,
          manufacturerId: string,
          assetTypeId: string,
          probability?: number | null,
          severity?: number | null,
          riskScore?: number | null,
          picture?: string | null,
          specification?: string | null,
          usefulLife?: number | null,
          inUseStatus?: InUseStatus | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        isArchived?: boolean | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
      } | null,
      findingId?: string | null,
      thirdPartyId?: string | null,
      thirdPartySource?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      tenantId: string,
      createdAt?: string | null,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type CreateAlertMutationVariables = {
  id: string,
  data: AlertInput,
};

export type CreateAlertMutation = {
  createAlert?:  {
    __typename: "AlertResponse",
    data?:  {
      __typename: "Alert",
      id: string,
      number: number,
      displayNumber?: string | null,
      asset?:  {
        __typename: "Asset",
        id: string,
        number?: number | null,
        displayNumber?: string | null,
        userId?: string | null,
        assetTag: string,
        description: string,
        makeId: string,
        modelId: string,
        state: string,
        usefulLife?: number | null,
        acquisitionCostValue?: number | null,
        lastMaintenanceDate?: string | null,
        nextScheduledMaintenanceDate?: string | null,
        assignedToId?: string | null,
        assetTypeId: string,
        condition?: string | null,
        maintenanceCostValue?: number | null,
        currentBookValue?: number | null,
        installDate?: string | null,
        decommissionDate?: string | null,
        locationId?: string | null,
        image?: string | null,
        purchaseOrderId?: string | null,
        utilizationData?: string | null,
        reasonForDecommission?: string | null,
        serialNumber: string,
        thirdPartyId?: string | null,
        source?: string | null,
        totalCostOfOwnershipValue?: number | null,
        repairCostValue?: number | null,
        warrantyExpiration?: string | null,
        downTime?: string | null,
        tenantId: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        model?:  {
          __typename: "Model",
          id: string,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          oemPartNumber?: string | null,
          name: string,
          manufacturerId: string,
          assetTypeId: string,
          probability?: number | null,
          severity?: number | null,
          riskScore?: number | null,
          picture?: string | null,
          specification?: string | null,
          usefulLife?: number | null,
          inUseStatus?: InUseStatus | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        assetType?:  {
          __typename: "AssetType",
          id: string,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          name: string,
          description?: string | null,
          category?: string | null,
          criticalityLevel?: number | null,
          expectedUsefulLife?: number | null,
          defaultWarrantyPeriod?: number | null,
          defaultRiskScore?: number | null,
          manufacturerRecommendations?: string | null,
          image?: string | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          inUseStatus?: string | null,
        } | null,
        manufacturer?:  {
          __typename: "Manufacturer",
          id: string,
          name: string,
          description?: string | null,
          countryId?: string | null,
          website?: string | null,
          contactPerson?: string | null,
          contactEmail?: string | null,
          contactPhone?: string | null,
          address?: string | null,
          warrantyPolicies?: string | null,
          slaDetails?: string | null,
          vendorPortalLink?: string | null,
          createdAt: string,
          createdBy: string,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          inUseStatus?: InUseStatus | null,
        } | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        woCount?: number | null,
        findingsCount?: number | null,
        user?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        assetRisk?: number | null,
        location?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        isParent?: boolean | null,
        thirdPartyParentId?: string | null,
        thirdPartyHierarchyPath?: Array< string | null > | null,
      } | null,
      assetId?: string | null,
      daysFailed?: string | null,
      tisStatus?: string | null,
      state: AlertState,
      firstException?: string | null,
      worstException?: string | null,
      lastException?: string | null,
      impactComfort?: string | null,
      impactEnergy?: string | null,
      impactReliability?: string | null,
      testValue?: string | null,
      exceptionName?: string | null,
      suggestionDescription?: string | null,
      suggestionCauses?: string | null,
      workOrder?:  {
        __typename: "WorkOrder",
        id?: string | null,
        displayNumber?: string | null,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt?: string | null,
        createdBy?: string | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        number?: number | null,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        locationId?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        dueDate?: string | null,
        startDate?: string | null,
        endDate?: string | null,
        duration?: string | null,
        plannedStartDate?: string | null,
        plannedEndDate?: string | null,
        assetId?: string | null,
        asset?:  {
          __typename: "Asset",
          id: string,
          number?: number | null,
          displayNumber?: string | null,
          userId?: string | null,
          assetTag: string,
          description: string,
          makeId: string,
          modelId: string,
          state: string,
          usefulLife?: number | null,
          acquisitionCostValue?: number | null,
          lastMaintenanceDate?: string | null,
          nextScheduledMaintenanceDate?: string | null,
          assignedToId?: string | null,
          assetTypeId: string,
          condition?: string | null,
          maintenanceCostValue?: number | null,
          currentBookValue?: number | null,
          installDate?: string | null,
          decommissionDate?: string | null,
          locationId?: string | null,
          image?: string | null,
          purchaseOrderId?: string | null,
          utilizationData?: string | null,
          reasonForDecommission?: string | null,
          serialNumber: string,
          thirdPartyId?: string | null,
          source?: string | null,
          totalCostOfOwnershipValue?: number | null,
          repairCostValue?: number | null,
          warrantyExpiration?: string | null,
          downTime?: string | null,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          model?:  {
            __typename: "Model",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            oemPartNumber?: string | null,
            name: string,
            manufacturerId: string,
            assetTypeId: string,
            probability?: number | null,
            severity?: number | null,
            riskScore?: number | null,
            picture?: string | null,
            specification?: string | null,
            usefulLife?: number | null,
            inUseStatus?: InUseStatus | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          woCount?: number | null,
          findingsCount?: number | null,
          user?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          assetRisk?: number | null,
          location?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          isParent?: boolean | null,
          thirdPartyParentId?: string | null,
          thirdPartyHierarchyPath?: Array< string | null > | null,
        } | null,
        assignmentGroupId?: string | null,
        assignedToId?: string | null,
        assignedTo?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        businessDownTime?: number | null,
        downTimeStart?: string | null,
        downTimeEnd?: string | null,
        category?: string | null,
        checklist?: string | null,
        closedNotes?: string | null,
        closedAt?: string | null,
        closedById?: string | null,
        closedBy?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        notes?: string | null,
        title?: string | null,
        description?: string | null,
        estimatedCostValue?: number | null,
        actualCostValue?: number | null,
        estimatedEffort?: number | null,
        actualEffort?: number | null,
        expectedOperationalDate?: string | null,
        impact?: number | null,
        priority?: number | null,
        dependsOnWorkOrderId?: string | null,
        dependsOnWorkOrder?:  {
          __typename: "WorkOrder",
          id?: string | null,
          displayNumber?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt?: string | null,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          number?: number | null,
          userId?: string | null,
          user?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          locationId?: string | null,
          location?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          dueDate?: string | null,
          startDate?: string | null,
          endDate?: string | null,
          duration?: string | null,
          plannedStartDate?: string | null,
          plannedEndDate?: string | null,
          assetId?: string | null,
          asset?:  {
            __typename: "Asset",
            id: string,
            number?: number | null,
            displayNumber?: string | null,
            userId?: string | null,
            assetTag: string,
            description: string,
            makeId: string,
            modelId: string,
            state: string,
            usefulLife?: number | null,
            acquisitionCostValue?: number | null,
            lastMaintenanceDate?: string | null,
            nextScheduledMaintenanceDate?: string | null,
            assignedToId?: string | null,
            assetTypeId: string,
            condition?: string | null,
            maintenanceCostValue?: number | null,
            currentBookValue?: number | null,
            installDate?: string | null,
            decommissionDate?: string | null,
            locationId?: string | null,
            image?: string | null,
            purchaseOrderId?: string | null,
            utilizationData?: string | null,
            reasonForDecommission?: string | null,
            serialNumber: string,
            thirdPartyId?: string | null,
            source?: string | null,
            totalCostOfOwnershipValue?: number | null,
            repairCostValue?: number | null,
            warrantyExpiration?: string | null,
            downTime?: string | null,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            woCount?: number | null,
            findingsCount?: number | null,
            assetRisk?: number | null,
            isParent?: boolean | null,
            thirdPartyParentId?: string | null,
            thirdPartyHierarchyPath?: Array< string | null > | null,
          } | null,
          assignmentGroupId?: string | null,
          assignedToId?: string | null,
          assignedTo?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          businessDownTime?: number | null,
          downTimeStart?: string | null,
          downTimeEnd?: string | null,
          category?: string | null,
          checklist?: string | null,
          closedNotes?: string | null,
          closedAt?: string | null,
          closedById?: string | null,
          closedBy?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          notes?: string | null,
          title?: string | null,
          description?: string | null,
          estimatedCostValue?: number | null,
          actualCostValue?: number | null,
          estimatedEffort?: number | null,
          actualEffort?: number | null,
          expectedOperationalDate?: string | null,
          impact?: number | null,
          priority?: number | null,
          dependsOnWorkOrderId?: string | null,
          dependsOnWorkOrder?:  {
            __typename: "WorkOrder",
            id?: string | null,
            displayNumber?: string | null,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            number?: number | null,
            userId?: string | null,
            locationId?: string | null,
            dueDate?: string | null,
            startDate?: string | null,
            endDate?: string | null,
            duration?: string | null,
            plannedStartDate?: string | null,
            plannedEndDate?: string | null,
            assetId?: string | null,
            assignmentGroupId?: string | null,
            assignedToId?: string | null,
            businessDownTime?: number | null,
            downTimeStart?: string | null,
            downTimeEnd?: string | null,
            category?: string | null,
            checklist?: string | null,
            closedNotes?: string | null,
            closedAt?: string | null,
            closedById?: string | null,
            notes?: string | null,
            title?: string | null,
            description?: string | null,
            estimatedCostValue?: number | null,
            actualCostValue?: number | null,
            estimatedEffort?: number | null,
            actualEffort?: number | null,
            expectedOperationalDate?: string | null,
            impact?: number | null,
            priority?: number | null,
            dependsOnWorkOrderId?: string | null,
            state?: string | null,
            type?: string | null,
            templateId?: string | null,
            isArchived?: boolean | null,
            findingId?: string | null,
            seenByAssignee?: boolean | null,
            assignmentDateTime?: string | null,
            seenDateTime?: string | null,
            startOfWorkDateTime?: string | null,
            endOfWorkDateTime?: string | null,
          } | null,
          state?: string | null,
          type?: string | null,
          templateId?: string | null,
          isArchived?: boolean | null,
          findingId?: string | null,
          seenByAssignee?: boolean | null,
          assignmentDateTime?: string | null,
          seenDateTime?: string | null,
          startOfWorkDateTime?: string | null,
          endOfWorkDateTime?: string | null,
        } | null,
        state?: string | null,
        type?: string | null,
        templateId?: string | null,
        isArchived?: boolean | null,
        findingId?: string | null,
        seenByAssignee?: boolean | null,
        assignmentDateTime?: string | null,
        seenDateTime?: string | null,
        startOfWorkDateTime?: string | null,
        endOfWorkDateTime?: string | null,
      } | null,
      workOrderId?: string | null,
      finding?:  {
        __typename: "Finding",
        id: string,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        number?: number | null,
        displayNumber?: string | null,
        shortDescription?: string | null,
        priority?: number | null,
        estimatedRepairCost?: number | null,
        plannedRepairDate?: string | null,
        description?: string | null,
        cause?: string | null,
        symptom?: string | null,
        picture?: string | null,
        reportedOn?: string | null,
        workOrderId?: string | null,
        type?: FindingType | null,
        reportedById?: string | null,
        status?: FindingStatus | null,
        assetId?: string | null,
        asset?:  {
          __typename: "Asset",
          id: string,
          number?: number | null,
          displayNumber?: string | null,
          userId?: string | null,
          assetTag: string,
          description: string,
          makeId: string,
          modelId: string,
          state: string,
          usefulLife?: number | null,
          acquisitionCostValue?: number | null,
          lastMaintenanceDate?: string | null,
          nextScheduledMaintenanceDate?: string | null,
          assignedToId?: string | null,
          assetTypeId: string,
          condition?: string | null,
          maintenanceCostValue?: number | null,
          currentBookValue?: number | null,
          installDate?: string | null,
          decommissionDate?: string | null,
          locationId?: string | null,
          image?: string | null,
          purchaseOrderId?: string | null,
          utilizationData?: string | null,
          reasonForDecommission?: string | null,
          serialNumber: string,
          thirdPartyId?: string | null,
          source?: string | null,
          totalCostOfOwnershipValue?: number | null,
          repairCostValue?: number | null,
          warrantyExpiration?: string | null,
          downTime?: string | null,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          model?:  {
            __typename: "Model",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            oemPartNumber?: string | null,
            name: string,
            manufacturerId: string,
            assetTypeId: string,
            probability?: number | null,
            severity?: number | null,
            riskScore?: number | null,
            picture?: string | null,
            specification?: string | null,
            usefulLife?: number | null,
            inUseStatus?: InUseStatus | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          woCount?: number | null,
          findingsCount?: number | null,
          user?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          assetRisk?: number | null,
          location?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          isParent?: boolean | null,
          thirdPartyParentId?: string | null,
          thirdPartyHierarchyPath?: Array< string | null > | null,
        } | null,
        locationId?: string | null,
        model?:  {
          __typename: "Model",
          id: string,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          oemPartNumber?: string | null,
          name: string,
          manufacturerId: string,
          assetTypeId: string,
          probability?: number | null,
          severity?: number | null,
          riskScore?: number | null,
          picture?: string | null,
          specification?: string | null,
          usefulLife?: number | null,
          inUseStatus?: InUseStatus | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        isArchived?: boolean | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
      } | null,
      findingId?: string | null,
      thirdPartyId?: string | null,
      thirdPartySource?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      tenantId: string,
      createdAt?: string | null,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type DeleteAlertMutationVariables = {
  id: string,
  data: AlertInput,
};

export type DeleteAlertMutation = {
  deleteAlert?:  {
    __typename: "AlertResponse",
    data?:  {
      __typename: "Alert",
      id: string,
      number: number,
      displayNumber?: string | null,
      asset?:  {
        __typename: "Asset",
        id: string,
        number?: number | null,
        displayNumber?: string | null,
        userId?: string | null,
        assetTag: string,
        description: string,
        makeId: string,
        modelId: string,
        state: string,
        usefulLife?: number | null,
        acquisitionCostValue?: number | null,
        lastMaintenanceDate?: string | null,
        nextScheduledMaintenanceDate?: string | null,
        assignedToId?: string | null,
        assetTypeId: string,
        condition?: string | null,
        maintenanceCostValue?: number | null,
        currentBookValue?: number | null,
        installDate?: string | null,
        decommissionDate?: string | null,
        locationId?: string | null,
        image?: string | null,
        purchaseOrderId?: string | null,
        utilizationData?: string | null,
        reasonForDecommission?: string | null,
        serialNumber: string,
        thirdPartyId?: string | null,
        source?: string | null,
        totalCostOfOwnershipValue?: number | null,
        repairCostValue?: number | null,
        warrantyExpiration?: string | null,
        downTime?: string | null,
        tenantId: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        model?:  {
          __typename: "Model",
          id: string,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          oemPartNumber?: string | null,
          name: string,
          manufacturerId: string,
          assetTypeId: string,
          probability?: number | null,
          severity?: number | null,
          riskScore?: number | null,
          picture?: string | null,
          specification?: string | null,
          usefulLife?: number | null,
          inUseStatus?: InUseStatus | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        assetType?:  {
          __typename: "AssetType",
          id: string,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          name: string,
          description?: string | null,
          category?: string | null,
          criticalityLevel?: number | null,
          expectedUsefulLife?: number | null,
          defaultWarrantyPeriod?: number | null,
          defaultRiskScore?: number | null,
          manufacturerRecommendations?: string | null,
          image?: string | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          inUseStatus?: string | null,
        } | null,
        manufacturer?:  {
          __typename: "Manufacturer",
          id: string,
          name: string,
          description?: string | null,
          countryId?: string | null,
          website?: string | null,
          contactPerson?: string | null,
          contactEmail?: string | null,
          contactPhone?: string | null,
          address?: string | null,
          warrantyPolicies?: string | null,
          slaDetails?: string | null,
          vendorPortalLink?: string | null,
          createdAt: string,
          createdBy: string,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          inUseStatus?: InUseStatus | null,
        } | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        woCount?: number | null,
        findingsCount?: number | null,
        user?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        assetRisk?: number | null,
        location?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        isParent?: boolean | null,
        thirdPartyParentId?: string | null,
        thirdPartyHierarchyPath?: Array< string | null > | null,
      } | null,
      assetId?: string | null,
      daysFailed?: string | null,
      tisStatus?: string | null,
      state: AlertState,
      firstException?: string | null,
      worstException?: string | null,
      lastException?: string | null,
      impactComfort?: string | null,
      impactEnergy?: string | null,
      impactReliability?: string | null,
      testValue?: string | null,
      exceptionName?: string | null,
      suggestionDescription?: string | null,
      suggestionCauses?: string | null,
      workOrder?:  {
        __typename: "WorkOrder",
        id?: string | null,
        displayNumber?: string | null,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt?: string | null,
        createdBy?: string | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        number?: number | null,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        locationId?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        dueDate?: string | null,
        startDate?: string | null,
        endDate?: string | null,
        duration?: string | null,
        plannedStartDate?: string | null,
        plannedEndDate?: string | null,
        assetId?: string | null,
        asset?:  {
          __typename: "Asset",
          id: string,
          number?: number | null,
          displayNumber?: string | null,
          userId?: string | null,
          assetTag: string,
          description: string,
          makeId: string,
          modelId: string,
          state: string,
          usefulLife?: number | null,
          acquisitionCostValue?: number | null,
          lastMaintenanceDate?: string | null,
          nextScheduledMaintenanceDate?: string | null,
          assignedToId?: string | null,
          assetTypeId: string,
          condition?: string | null,
          maintenanceCostValue?: number | null,
          currentBookValue?: number | null,
          installDate?: string | null,
          decommissionDate?: string | null,
          locationId?: string | null,
          image?: string | null,
          purchaseOrderId?: string | null,
          utilizationData?: string | null,
          reasonForDecommission?: string | null,
          serialNumber: string,
          thirdPartyId?: string | null,
          source?: string | null,
          totalCostOfOwnershipValue?: number | null,
          repairCostValue?: number | null,
          warrantyExpiration?: string | null,
          downTime?: string | null,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          model?:  {
            __typename: "Model",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            oemPartNumber?: string | null,
            name: string,
            manufacturerId: string,
            assetTypeId: string,
            probability?: number | null,
            severity?: number | null,
            riskScore?: number | null,
            picture?: string | null,
            specification?: string | null,
            usefulLife?: number | null,
            inUseStatus?: InUseStatus | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          woCount?: number | null,
          findingsCount?: number | null,
          user?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          assetRisk?: number | null,
          location?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          isParent?: boolean | null,
          thirdPartyParentId?: string | null,
          thirdPartyHierarchyPath?: Array< string | null > | null,
        } | null,
        assignmentGroupId?: string | null,
        assignedToId?: string | null,
        assignedTo?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        businessDownTime?: number | null,
        downTimeStart?: string | null,
        downTimeEnd?: string | null,
        category?: string | null,
        checklist?: string | null,
        closedNotes?: string | null,
        closedAt?: string | null,
        closedById?: string | null,
        closedBy?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        notes?: string | null,
        title?: string | null,
        description?: string | null,
        estimatedCostValue?: number | null,
        actualCostValue?: number | null,
        estimatedEffort?: number | null,
        actualEffort?: number | null,
        expectedOperationalDate?: string | null,
        impact?: number | null,
        priority?: number | null,
        dependsOnWorkOrderId?: string | null,
        dependsOnWorkOrder?:  {
          __typename: "WorkOrder",
          id?: string | null,
          displayNumber?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt?: string | null,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          number?: number | null,
          userId?: string | null,
          user?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          locationId?: string | null,
          location?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          dueDate?: string | null,
          startDate?: string | null,
          endDate?: string | null,
          duration?: string | null,
          plannedStartDate?: string | null,
          plannedEndDate?: string | null,
          assetId?: string | null,
          asset?:  {
            __typename: "Asset",
            id: string,
            number?: number | null,
            displayNumber?: string | null,
            userId?: string | null,
            assetTag: string,
            description: string,
            makeId: string,
            modelId: string,
            state: string,
            usefulLife?: number | null,
            acquisitionCostValue?: number | null,
            lastMaintenanceDate?: string | null,
            nextScheduledMaintenanceDate?: string | null,
            assignedToId?: string | null,
            assetTypeId: string,
            condition?: string | null,
            maintenanceCostValue?: number | null,
            currentBookValue?: number | null,
            installDate?: string | null,
            decommissionDate?: string | null,
            locationId?: string | null,
            image?: string | null,
            purchaseOrderId?: string | null,
            utilizationData?: string | null,
            reasonForDecommission?: string | null,
            serialNumber: string,
            thirdPartyId?: string | null,
            source?: string | null,
            totalCostOfOwnershipValue?: number | null,
            repairCostValue?: number | null,
            warrantyExpiration?: string | null,
            downTime?: string | null,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            woCount?: number | null,
            findingsCount?: number | null,
            assetRisk?: number | null,
            isParent?: boolean | null,
            thirdPartyParentId?: string | null,
            thirdPartyHierarchyPath?: Array< string | null > | null,
          } | null,
          assignmentGroupId?: string | null,
          assignedToId?: string | null,
          assignedTo?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          businessDownTime?: number | null,
          downTimeStart?: string | null,
          downTimeEnd?: string | null,
          category?: string | null,
          checklist?: string | null,
          closedNotes?: string | null,
          closedAt?: string | null,
          closedById?: string | null,
          closedBy?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          notes?: string | null,
          title?: string | null,
          description?: string | null,
          estimatedCostValue?: number | null,
          actualCostValue?: number | null,
          estimatedEffort?: number | null,
          actualEffort?: number | null,
          expectedOperationalDate?: string | null,
          impact?: number | null,
          priority?: number | null,
          dependsOnWorkOrderId?: string | null,
          dependsOnWorkOrder?:  {
            __typename: "WorkOrder",
            id?: string | null,
            displayNumber?: string | null,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            number?: number | null,
            userId?: string | null,
            locationId?: string | null,
            dueDate?: string | null,
            startDate?: string | null,
            endDate?: string | null,
            duration?: string | null,
            plannedStartDate?: string | null,
            plannedEndDate?: string | null,
            assetId?: string | null,
            assignmentGroupId?: string | null,
            assignedToId?: string | null,
            businessDownTime?: number | null,
            downTimeStart?: string | null,
            downTimeEnd?: string | null,
            category?: string | null,
            checklist?: string | null,
            closedNotes?: string | null,
            closedAt?: string | null,
            closedById?: string | null,
            notes?: string | null,
            title?: string | null,
            description?: string | null,
            estimatedCostValue?: number | null,
            actualCostValue?: number | null,
            estimatedEffort?: number | null,
            actualEffort?: number | null,
            expectedOperationalDate?: string | null,
            impact?: number | null,
            priority?: number | null,
            dependsOnWorkOrderId?: string | null,
            state?: string | null,
            type?: string | null,
            templateId?: string | null,
            isArchived?: boolean | null,
            findingId?: string | null,
            seenByAssignee?: boolean | null,
            assignmentDateTime?: string | null,
            seenDateTime?: string | null,
            startOfWorkDateTime?: string | null,
            endOfWorkDateTime?: string | null,
          } | null,
          state?: string | null,
          type?: string | null,
          templateId?: string | null,
          isArchived?: boolean | null,
          findingId?: string | null,
          seenByAssignee?: boolean | null,
          assignmentDateTime?: string | null,
          seenDateTime?: string | null,
          startOfWorkDateTime?: string | null,
          endOfWorkDateTime?: string | null,
        } | null,
        state?: string | null,
        type?: string | null,
        templateId?: string | null,
        isArchived?: boolean | null,
        findingId?: string | null,
        seenByAssignee?: boolean | null,
        assignmentDateTime?: string | null,
        seenDateTime?: string | null,
        startOfWorkDateTime?: string | null,
        endOfWorkDateTime?: string | null,
      } | null,
      workOrderId?: string | null,
      finding?:  {
        __typename: "Finding",
        id: string,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        number?: number | null,
        displayNumber?: string | null,
        shortDescription?: string | null,
        priority?: number | null,
        estimatedRepairCost?: number | null,
        plannedRepairDate?: string | null,
        description?: string | null,
        cause?: string | null,
        symptom?: string | null,
        picture?: string | null,
        reportedOn?: string | null,
        workOrderId?: string | null,
        type?: FindingType | null,
        reportedById?: string | null,
        status?: FindingStatus | null,
        assetId?: string | null,
        asset?:  {
          __typename: "Asset",
          id: string,
          number?: number | null,
          displayNumber?: string | null,
          userId?: string | null,
          assetTag: string,
          description: string,
          makeId: string,
          modelId: string,
          state: string,
          usefulLife?: number | null,
          acquisitionCostValue?: number | null,
          lastMaintenanceDate?: string | null,
          nextScheduledMaintenanceDate?: string | null,
          assignedToId?: string | null,
          assetTypeId: string,
          condition?: string | null,
          maintenanceCostValue?: number | null,
          currentBookValue?: number | null,
          installDate?: string | null,
          decommissionDate?: string | null,
          locationId?: string | null,
          image?: string | null,
          purchaseOrderId?: string | null,
          utilizationData?: string | null,
          reasonForDecommission?: string | null,
          serialNumber: string,
          thirdPartyId?: string | null,
          source?: string | null,
          totalCostOfOwnershipValue?: number | null,
          repairCostValue?: number | null,
          warrantyExpiration?: string | null,
          downTime?: string | null,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          model?:  {
            __typename: "Model",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            oemPartNumber?: string | null,
            name: string,
            manufacturerId: string,
            assetTypeId: string,
            probability?: number | null,
            severity?: number | null,
            riskScore?: number | null,
            picture?: string | null,
            specification?: string | null,
            usefulLife?: number | null,
            inUseStatus?: InUseStatus | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          woCount?: number | null,
          findingsCount?: number | null,
          user?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          assetRisk?: number | null,
          location?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          isParent?: boolean | null,
          thirdPartyParentId?: string | null,
          thirdPartyHierarchyPath?: Array< string | null > | null,
        } | null,
        locationId?: string | null,
        model?:  {
          __typename: "Model",
          id: string,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          oemPartNumber?: string | null,
          name: string,
          manufacturerId: string,
          assetTypeId: string,
          probability?: number | null,
          severity?: number | null,
          riskScore?: number | null,
          picture?: string | null,
          specification?: string | null,
          usefulLife?: number | null,
          inUseStatus?: InUseStatus | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        isArchived?: boolean | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
      } | null,
      findingId?: string | null,
      thirdPartyId?: string | null,
      thirdPartySource?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      tenantId: string,
      createdAt?: string | null,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type BulkUpdateAlertMutationVariables = {
  data?: BulkUpdateData | null,
};

export type BulkUpdateAlertMutation = {
  bulkUpdateAlert?:  {
    __typename: "BulkUpdateResponse",
    updatedCount?: number | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type GetDashboardStatsQueryVariables = {
  stats?: DashboardStatsInput | null,
  tenantIDs?: Array< string | null > | null,
  userId?: string | null,
};

export type GetDashboardStatsQuery = {
  getDashboardStats?:  {
    __typename: "DashboardStatsResponse",
    status?: number | null,
    data?:  {
      __typename: "DashboardStats",
      totalAssets?: number | null,
      assetsPerLocation?:  Array< {
        __typename: "DashboardStatsPoint",
        label?: string | null,
        itemCount?: number | null,
        value?: number | null,
        percentage?: number | null,
        filterByValue?: string | null,
      } | null > | null,
      assetsPerCondition?:  Array< {
        __typename: "DashboardStatsPoint",
        label?: string | null,
        itemCount?: number | null,
        value?: number | null,
        percentage?: number | null,
        filterByValue?: string | null,
      } | null > | null,
      assetsPerType?:  Array< {
        __typename: "DashboardStatsPoint",
        label?: string | null,
        itemCount?: number | null,
        value?: number | null,
        percentage?: number | null,
        filterByValue?: string | null,
      } | null > | null,
      assetsPerExpenses?:  Array< {
        __typename: "DashboardStatsPoint",
        label?: string | null,
        itemCount?: number | null,
        value?: number | null,
        percentage?: number | null,
        filterByValue?: string | null,
      } | null > | null,
      totalFindings?: number | null,
      findingsPerType?:  Array< {
        __typename: "DashboardStatsPoint",
        label?: string | null,
        itemCount?: number | null,
        value?: number | null,
        percentage?: number | null,
        filterByValue?: string | null,
      } | null > | null,
      findingsPerPriority?:  Array< {
        __typename: "DashboardStatsPoint",
        label?: string | null,
        itemCount?: number | null,
        value?: number | null,
        percentage?: number | null,
        filterByValue?: string | null,
      } | null > | null,
      findingsPerAssetModel?:  Array< {
        __typename: "DashboardStatsPoint",
        label?: string | null,
        itemCount?: number | null,
        value?: number | null,
        percentage?: number | null,
        filterByValue?: string | null,
      } | null > | null,
      all?:  {
        __typename: "WorkOrderStats",
        totalWorkOrders?: number | null,
        workOrdersPerCategory?:  Array< {
          __typename: "DashboardStatsPoint",
          label?: string | null,
          itemCount?: number | null,
          value?: number | null,
          percentage?: number | null,
          filterByValue?: string | null,
        } | null > | null,
        workOrdersPerPriority?:  Array< {
          __typename: "DashboardStatsPoint",
          label?: string | null,
          itemCount?: number | null,
          value?: number | null,
          percentage?: number | null,
          filterByValue?: string | null,
        } | null > | null,
        workOrdersPerState?:  Array< {
          __typename: "DashboardStatsPoint",
          label?: string | null,
          itemCount?: number | null,
          value?: number | null,
          percentage?: number | null,
          filterByValue?: string | null,
        } | null > | null,
        workOrdersPerDueData?:  Array< {
          __typename: "DashboardStatsPoint",
          label?: string | null,
          itemCount?: number | null,
          value?: number | null,
          percentage?: number | null,
          filterByValue?: string | null,
        } | null > | null,
        workOrdersPerDueDate?:  Array< {
          __typename: "DashboardStatsPoint",
          label?: string | null,
          itemCount?: number | null,
          value?: number | null,
          percentage?: number | null,
          filterByValue?: string | null,
        } | null > | null,
        workOrdersSLAData?:  Array< {
          __typename: "WorkOrdersSLAData",
          key?: string | null,
          warningValue?: number | null,
          thresholdValue?: number | null,
          statsPoints?:  Array< {
            __typename: "DashboardStatsPoint",
            label?: string | null,
            itemCount?: number | null,
            value?: number | null,
            percentage?: number | null,
            filterByValue?: string | null,
          } | null > | null,
        } | null > | null,
      } | null,
      user?:  {
        __typename: "WorkOrderStats",
        totalWorkOrders?: number | null,
        workOrdersPerCategory?:  Array< {
          __typename: "DashboardStatsPoint",
          label?: string | null,
          itemCount?: number | null,
          value?: number | null,
          percentage?: number | null,
          filterByValue?: string | null,
        } | null > | null,
        workOrdersPerPriority?:  Array< {
          __typename: "DashboardStatsPoint",
          label?: string | null,
          itemCount?: number | null,
          value?: number | null,
          percentage?: number | null,
          filterByValue?: string | null,
        } | null > | null,
        workOrdersPerState?:  Array< {
          __typename: "DashboardStatsPoint",
          label?: string | null,
          itemCount?: number | null,
          value?: number | null,
          percentage?: number | null,
          filterByValue?: string | null,
        } | null > | null,
        workOrdersPerDueData?:  Array< {
          __typename: "DashboardStatsPoint",
          label?: string | null,
          itemCount?: number | null,
          value?: number | null,
          percentage?: number | null,
          filterByValue?: string | null,
        } | null > | null,
        workOrdersPerDueDate?:  Array< {
          __typename: "DashboardStatsPoint",
          label?: string | null,
          itemCount?: number | null,
          value?: number | null,
          percentage?: number | null,
          filterByValue?: string | null,
        } | null > | null,
        workOrdersSLAData?:  Array< {
          __typename: "WorkOrdersSLAData",
          key?: string | null,
          warningValue?: number | null,
          thresholdValue?: number | null,
          statsPoints?:  Array< {
            __typename: "DashboardStatsPoint",
            label?: string | null,
            itemCount?: number | null,
            value?: number | null,
            percentage?: number | null,
            filterByValue?: string | null,
          } | null > | null,
        } | null > | null,
      } | null,
    } | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type GetCurrentUserQueryVariables = {
};

export type GetCurrentUserQuery = {
  getCurrentUser?:  {
    __typename: "CurrentUserResponse",
    data?:  {
      __typename: "CurrentUserData",
      user:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      },
      tenants:  Array< {
        __typename: "UserTenantData",
        tenant:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        },
        role: string,
      } >,
      tenantIDs: Array< string >,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type GetAssetQueryVariables = {
  id: string,
};

export type GetAssetQuery = {
  getAsset?:  {
    __typename: "AssetResponse",
    data?:  {
      __typename: "Asset",
      id: string,
      number?: number | null,
      displayNumber?: string | null,
      userId?: string | null,
      assetTag: string,
      description: string,
      makeId: string,
      modelId: string,
      state: string,
      usefulLife?: number | null,
      acquisitionCostValue?: number | null,
      lastMaintenanceDate?: string | null,
      nextScheduledMaintenanceDate?: string | null,
      assignedToId?: string | null,
      assetTypeId: string,
      condition?: string | null,
      maintenanceCostValue?: number | null,
      currentBookValue?: number | null,
      installDate?: string | null,
      decommissionDate?: string | null,
      locationId?: string | null,
      image?: string | null,
      purchaseOrderId?: string | null,
      utilizationData?: string | null,
      reasonForDecommission?: string | null,
      serialNumber: string,
      thirdPartyId?: string | null,
      source?: string | null,
      totalCostOfOwnershipValue?: number | null,
      repairCostValue?: number | null,
      warrantyExpiration?: string | null,
      downTime?: string | null,
      tenantId: string,
      createdAt: string,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      model?:  {
        __typename: "Model",
        id: string,
        tenantId: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        oemPartNumber?: string | null,
        name: string,
        manufacturerId: string,
        assetTypeId: string,
        probability?: number | null,
        severity?: number | null,
        riskScore?: number | null,
        picture?: string | null,
        specification?: string | null,
        usefulLife?: number | null,
        inUseStatus?: InUseStatus | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        manufacturer?:  {
          __typename: "Manufacturer",
          id: string,
          name: string,
          description?: string | null,
          countryId?: string | null,
          website?: string | null,
          contactPerson?: string | null,
          contactEmail?: string | null,
          contactPhone?: string | null,
          address?: string | null,
          warrantyPolicies?: string | null,
          slaDetails?: string | null,
          vendorPortalLink?: string | null,
          createdAt: string,
          createdBy: string,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          inUseStatus?: InUseStatus | null,
        } | null,
        assetType?:  {
          __typename: "AssetType",
          id: string,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          name: string,
          description?: string | null,
          category?: string | null,
          criticalityLevel?: number | null,
          expectedUsefulLife?: number | null,
          defaultWarrantyPeriod?: number | null,
          defaultRiskScore?: number | null,
          manufacturerRecommendations?: string | null,
          image?: string | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          inUseStatus?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      assetType?:  {
        __typename: "AssetType",
        id: string,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt: string,
        createdBy?: string | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        name: string,
        description?: string | null,
        category?: string | null,
        criticalityLevel?: number | null,
        expectedUsefulLife?: number | null,
        defaultWarrantyPeriod?: number | null,
        defaultRiskScore?: number | null,
        manufacturerRecommendations?: string | null,
        image?: string | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        inUseStatus?: string | null,
      } | null,
      manufacturer?:  {
        __typename: "Manufacturer",
        id: string,
        name: string,
        description?: string | null,
        countryId?: string | null,
        website?: string | null,
        contactPerson?: string | null,
        contactEmail?: string | null,
        contactPhone?: string | null,
        address?: string | null,
        warrantyPolicies?: string | null,
        slaDetails?: string | null,
        vendorPortalLink?: string | null,
        createdAt: string,
        createdBy: string,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        inUseStatus?: InUseStatus | null,
      } | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      woCount?: number | null,
      findingsCount?: number | null,
      user?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      assetRisk?: number | null,
      location?:  {
        __typename: "Location",
        id: string,
        tenantId: string,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        notes?: string | null,
        lat?: number | null,
        lng?: number | null,
        level?: string | null,
        parentId?: string | null,
        rootId?: string | null,
        thirdPartyId?: string | null,
        source?: string | null,
        inUseStatus?: InUseStatus | null,
        address?: string | null,
        buildingAddress?: string | null,
        parent?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        tisSyncedAt?: string | null,
      } | null,
      isParent?: boolean | null,
      thirdPartyParentId?: string | null,
      thirdPartyHierarchyPath?: Array< string | null > | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type GetAssetListQueryVariables = {
  params?: QueryListParams | null,
};

export type GetAssetListQuery = {
  getAssetList?:  {
    __typename: "AssetListResponse",
    data?:  Array< {
      __typename: "Asset",
      id: string,
      number?: number | null,
      displayNumber?: string | null,
      userId?: string | null,
      assetTag: string,
      description: string,
      makeId: string,
      modelId: string,
      state: string,
      usefulLife?: number | null,
      acquisitionCostValue?: number | null,
      lastMaintenanceDate?: string | null,
      nextScheduledMaintenanceDate?: string | null,
      assignedToId?: string | null,
      assetTypeId: string,
      condition?: string | null,
      maintenanceCostValue?: number | null,
      currentBookValue?: number | null,
      installDate?: string | null,
      decommissionDate?: string | null,
      locationId?: string | null,
      image?: string | null,
      purchaseOrderId?: string | null,
      utilizationData?: string | null,
      reasonForDecommission?: string | null,
      serialNumber: string,
      thirdPartyId?: string | null,
      source?: string | null,
      totalCostOfOwnershipValue?: number | null,
      repairCostValue?: number | null,
      warrantyExpiration?: string | null,
      downTime?: string | null,
      tenantId: string,
      createdAt: string,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      model?:  {
        __typename: "Model",
        id: string,
        tenantId: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        oemPartNumber?: string | null,
        name: string,
        manufacturerId: string,
        assetTypeId: string,
        probability?: number | null,
        severity?: number | null,
        riskScore?: number | null,
        picture?: string | null,
        specification?: string | null,
        usefulLife?: number | null,
        inUseStatus?: InUseStatus | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        manufacturer?:  {
          __typename: "Manufacturer",
          id: string,
          name: string,
          description?: string | null,
          countryId?: string | null,
          website?: string | null,
          contactPerson?: string | null,
          contactEmail?: string | null,
          contactPhone?: string | null,
          address?: string | null,
          warrantyPolicies?: string | null,
          slaDetails?: string | null,
          vendorPortalLink?: string | null,
          createdAt: string,
          createdBy: string,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          inUseStatus?: InUseStatus | null,
        } | null,
        assetType?:  {
          __typename: "AssetType",
          id: string,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          name: string,
          description?: string | null,
          category?: string | null,
          criticalityLevel?: number | null,
          expectedUsefulLife?: number | null,
          defaultWarrantyPeriod?: number | null,
          defaultRiskScore?: number | null,
          manufacturerRecommendations?: string | null,
          image?: string | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          inUseStatus?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      assetType?:  {
        __typename: "AssetType",
        id: string,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt: string,
        createdBy?: string | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        name: string,
        description?: string | null,
        category?: string | null,
        criticalityLevel?: number | null,
        expectedUsefulLife?: number | null,
        defaultWarrantyPeriod?: number | null,
        defaultRiskScore?: number | null,
        manufacturerRecommendations?: string | null,
        image?: string | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        inUseStatus?: string | null,
      } | null,
      manufacturer?:  {
        __typename: "Manufacturer",
        id: string,
        name: string,
        description?: string | null,
        countryId?: string | null,
        website?: string | null,
        contactPerson?: string | null,
        contactEmail?: string | null,
        contactPhone?: string | null,
        address?: string | null,
        warrantyPolicies?: string | null,
        slaDetails?: string | null,
        vendorPortalLink?: string | null,
        createdAt: string,
        createdBy: string,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        inUseStatus?: InUseStatus | null,
      } | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      woCount?: number | null,
      findingsCount?: number | null,
      user?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      assetRisk?: number | null,
      location?:  {
        __typename: "Location",
        id: string,
        tenantId: string,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        notes?: string | null,
        lat?: number | null,
        lng?: number | null,
        level?: string | null,
        parentId?: string | null,
        rootId?: string | null,
        thirdPartyId?: string | null,
        source?: string | null,
        inUseStatus?: InUseStatus | null,
        address?: string | null,
        buildingAddress?: string | null,
        parent?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        tisSyncedAt?: string | null,
      } | null,
      isParent?: boolean | null,
      thirdPartyParentId?: string | null,
      thirdPartyHierarchyPath?: Array< string | null > | null,
    } | null > | null,
    totalCount?: number | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type GetAssetPropsCountsQueryVariables = {
};

export type GetAssetPropsCountsQuery = {
  getAssetPropsCounts?:  {
    __typename: "AssetPropsCountsResponse",
    data?:  {
      __typename: "AssetPropsCounts",
      assets?: number | null,
      types?: number | null,
      manufacturers?: number | null,
      models?: number | null,
      locations?: number | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type GetAssetRelatedCountsQueryVariables = {
  assetId: string,
};

export type GetAssetRelatedCountsQuery = {
  getAssetRelatedCounts?:  {
    __typename: "AssetRelatedCountsResponse",
    data?:  {
      __typename: "AssetRelatedCounts",
      workOrders?: number | null,
      findings?: number | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type GetWorkOrderQueryVariables = {
  id: string,
};

export type GetWorkOrderQuery = {
  getWorkOrder?:  {
    __typename: "WorkOrderResponse",
    data?:  {
      __typename: "WorkOrder",
      id?: string | null,
      displayNumber?: string | null,
      tenantId?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      createdAt?: string | null,
      createdBy?: string | null,
      createdByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      updatedByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      number?: number | null,
      userId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      locationId?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        tenantId: string,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        notes?: string | null,
        lat?: number | null,
        lng?: number | null,
        level?: string | null,
        parentId?: string | null,
        rootId?: string | null,
        thirdPartyId?: string | null,
        source?: string | null,
        inUseStatus?: InUseStatus | null,
        address?: string | null,
        buildingAddress?: string | null,
        parent?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        tisSyncedAt?: string | null,
      } | null,
      dueDate?: string | null,
      startDate?: string | null,
      endDate?: string | null,
      duration?: string | null,
      plannedStartDate?: string | null,
      plannedEndDate?: string | null,
      assetId?: string | null,
      asset?:  {
        __typename: "Asset",
        id: string,
        number?: number | null,
        displayNumber?: string | null,
        userId?: string | null,
        assetTag: string,
        description: string,
        makeId: string,
        modelId: string,
        state: string,
        usefulLife?: number | null,
        acquisitionCostValue?: number | null,
        lastMaintenanceDate?: string | null,
        nextScheduledMaintenanceDate?: string | null,
        assignedToId?: string | null,
        assetTypeId: string,
        condition?: string | null,
        maintenanceCostValue?: number | null,
        currentBookValue?: number | null,
        installDate?: string | null,
        decommissionDate?: string | null,
        locationId?: string | null,
        image?: string | null,
        purchaseOrderId?: string | null,
        utilizationData?: string | null,
        reasonForDecommission?: string | null,
        serialNumber: string,
        thirdPartyId?: string | null,
        source?: string | null,
        totalCostOfOwnershipValue?: number | null,
        repairCostValue?: number | null,
        warrantyExpiration?: string | null,
        downTime?: string | null,
        tenantId: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        model?:  {
          __typename: "Model",
          id: string,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          oemPartNumber?: string | null,
          name: string,
          manufacturerId: string,
          assetTypeId: string,
          probability?: number | null,
          severity?: number | null,
          riskScore?: number | null,
          picture?: string | null,
          specification?: string | null,
          usefulLife?: number | null,
          inUseStatus?: InUseStatus | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        assetType?:  {
          __typename: "AssetType",
          id: string,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          name: string,
          description?: string | null,
          category?: string | null,
          criticalityLevel?: number | null,
          expectedUsefulLife?: number | null,
          defaultWarrantyPeriod?: number | null,
          defaultRiskScore?: number | null,
          manufacturerRecommendations?: string | null,
          image?: string | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          inUseStatus?: string | null,
        } | null,
        manufacturer?:  {
          __typename: "Manufacturer",
          id: string,
          name: string,
          description?: string | null,
          countryId?: string | null,
          website?: string | null,
          contactPerson?: string | null,
          contactEmail?: string | null,
          contactPhone?: string | null,
          address?: string | null,
          warrantyPolicies?: string | null,
          slaDetails?: string | null,
          vendorPortalLink?: string | null,
          createdAt: string,
          createdBy: string,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          inUseStatus?: InUseStatus | null,
        } | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        woCount?: number | null,
        findingsCount?: number | null,
        user?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        assetRisk?: number | null,
        location?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        isParent?: boolean | null,
        thirdPartyParentId?: string | null,
        thirdPartyHierarchyPath?: Array< string | null > | null,
      } | null,
      assignmentGroupId?: string | null,
      assignedToId?: string | null,
      assignedTo?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      businessDownTime?: number | null,
      downTimeStart?: string | null,
      downTimeEnd?: string | null,
      category?: string | null,
      checklist?: string | null,
      closedNotes?: string | null,
      closedAt?: string | null,
      closedById?: string | null,
      closedBy?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      notes?: string | null,
      title?: string | null,
      description?: string | null,
      estimatedCostValue?: number | null,
      actualCostValue?: number | null,
      estimatedEffort?: number | null,
      actualEffort?: number | null,
      expectedOperationalDate?: string | null,
      impact?: number | null,
      priority?: number | null,
      dependsOnWorkOrderId?: string | null,
      dependsOnWorkOrder?:  {
        __typename: "WorkOrder",
        id?: string | null,
        displayNumber?: string | null,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt?: string | null,
        createdBy?: string | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        number?: number | null,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        locationId?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        dueDate?: string | null,
        startDate?: string | null,
        endDate?: string | null,
        duration?: string | null,
        plannedStartDate?: string | null,
        plannedEndDate?: string | null,
        assetId?: string | null,
        asset?:  {
          __typename: "Asset",
          id: string,
          number?: number | null,
          displayNumber?: string | null,
          userId?: string | null,
          assetTag: string,
          description: string,
          makeId: string,
          modelId: string,
          state: string,
          usefulLife?: number | null,
          acquisitionCostValue?: number | null,
          lastMaintenanceDate?: string | null,
          nextScheduledMaintenanceDate?: string | null,
          assignedToId?: string | null,
          assetTypeId: string,
          condition?: string | null,
          maintenanceCostValue?: number | null,
          currentBookValue?: number | null,
          installDate?: string | null,
          decommissionDate?: string | null,
          locationId?: string | null,
          image?: string | null,
          purchaseOrderId?: string | null,
          utilizationData?: string | null,
          reasonForDecommission?: string | null,
          serialNumber: string,
          thirdPartyId?: string | null,
          source?: string | null,
          totalCostOfOwnershipValue?: number | null,
          repairCostValue?: number | null,
          warrantyExpiration?: string | null,
          downTime?: string | null,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          model?:  {
            __typename: "Model",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            oemPartNumber?: string | null,
            name: string,
            manufacturerId: string,
            assetTypeId: string,
            probability?: number | null,
            severity?: number | null,
            riskScore?: number | null,
            picture?: string | null,
            specification?: string | null,
            usefulLife?: number | null,
            inUseStatus?: InUseStatus | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          woCount?: number | null,
          findingsCount?: number | null,
          user?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          assetRisk?: number | null,
          location?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          isParent?: boolean | null,
          thirdPartyParentId?: string | null,
          thirdPartyHierarchyPath?: Array< string | null > | null,
        } | null,
        assignmentGroupId?: string | null,
        assignedToId?: string | null,
        assignedTo?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        businessDownTime?: number | null,
        downTimeStart?: string | null,
        downTimeEnd?: string | null,
        category?: string | null,
        checklist?: string | null,
        closedNotes?: string | null,
        closedAt?: string | null,
        closedById?: string | null,
        closedBy?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        notes?: string | null,
        title?: string | null,
        description?: string | null,
        estimatedCostValue?: number | null,
        actualCostValue?: number | null,
        estimatedEffort?: number | null,
        actualEffort?: number | null,
        expectedOperationalDate?: string | null,
        impact?: number | null,
        priority?: number | null,
        dependsOnWorkOrderId?: string | null,
        dependsOnWorkOrder?:  {
          __typename: "WorkOrder",
          id?: string | null,
          displayNumber?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt?: string | null,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          number?: number | null,
          userId?: string | null,
          user?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          locationId?: string | null,
          location?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          dueDate?: string | null,
          startDate?: string | null,
          endDate?: string | null,
          duration?: string | null,
          plannedStartDate?: string | null,
          plannedEndDate?: string | null,
          assetId?: string | null,
          asset?:  {
            __typename: "Asset",
            id: string,
            number?: number | null,
            displayNumber?: string | null,
            userId?: string | null,
            assetTag: string,
            description: string,
            makeId: string,
            modelId: string,
            state: string,
            usefulLife?: number | null,
            acquisitionCostValue?: number | null,
            lastMaintenanceDate?: string | null,
            nextScheduledMaintenanceDate?: string | null,
            assignedToId?: string | null,
            assetTypeId: string,
            condition?: string | null,
            maintenanceCostValue?: number | null,
            currentBookValue?: number | null,
            installDate?: string | null,
            decommissionDate?: string | null,
            locationId?: string | null,
            image?: string | null,
            purchaseOrderId?: string | null,
            utilizationData?: string | null,
            reasonForDecommission?: string | null,
            serialNumber: string,
            thirdPartyId?: string | null,
            source?: string | null,
            totalCostOfOwnershipValue?: number | null,
            repairCostValue?: number | null,
            warrantyExpiration?: string | null,
            downTime?: string | null,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            woCount?: number | null,
            findingsCount?: number | null,
            assetRisk?: number | null,
            isParent?: boolean | null,
            thirdPartyParentId?: string | null,
            thirdPartyHierarchyPath?: Array< string | null > | null,
          } | null,
          assignmentGroupId?: string | null,
          assignedToId?: string | null,
          assignedTo?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          businessDownTime?: number | null,
          downTimeStart?: string | null,
          downTimeEnd?: string | null,
          category?: string | null,
          checklist?: string | null,
          closedNotes?: string | null,
          closedAt?: string | null,
          closedById?: string | null,
          closedBy?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          notes?: string | null,
          title?: string | null,
          description?: string | null,
          estimatedCostValue?: number | null,
          actualCostValue?: number | null,
          estimatedEffort?: number | null,
          actualEffort?: number | null,
          expectedOperationalDate?: string | null,
          impact?: number | null,
          priority?: number | null,
          dependsOnWorkOrderId?: string | null,
          dependsOnWorkOrder?:  {
            __typename: "WorkOrder",
            id?: string | null,
            displayNumber?: string | null,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            number?: number | null,
            userId?: string | null,
            locationId?: string | null,
            dueDate?: string | null,
            startDate?: string | null,
            endDate?: string | null,
            duration?: string | null,
            plannedStartDate?: string | null,
            plannedEndDate?: string | null,
            assetId?: string | null,
            assignmentGroupId?: string | null,
            assignedToId?: string | null,
            businessDownTime?: number | null,
            downTimeStart?: string | null,
            downTimeEnd?: string | null,
            category?: string | null,
            checklist?: string | null,
            closedNotes?: string | null,
            closedAt?: string | null,
            closedById?: string | null,
            notes?: string | null,
            title?: string | null,
            description?: string | null,
            estimatedCostValue?: number | null,
            actualCostValue?: number | null,
            estimatedEffort?: number | null,
            actualEffort?: number | null,
            expectedOperationalDate?: string | null,
            impact?: number | null,
            priority?: number | null,
            dependsOnWorkOrderId?: string | null,
            state?: string | null,
            type?: string | null,
            templateId?: string | null,
            isArchived?: boolean | null,
            findingId?: string | null,
            seenByAssignee?: boolean | null,
            assignmentDateTime?: string | null,
            seenDateTime?: string | null,
            startOfWorkDateTime?: string | null,
            endOfWorkDateTime?: string | null,
          } | null,
          state?: string | null,
          type?: string | null,
          templateId?: string | null,
          isArchived?: boolean | null,
          findingId?: string | null,
          seenByAssignee?: boolean | null,
          assignmentDateTime?: string | null,
          seenDateTime?: string | null,
          startOfWorkDateTime?: string | null,
          endOfWorkDateTime?: string | null,
        } | null,
        state?: string | null,
        type?: string | null,
        templateId?: string | null,
        isArchived?: boolean | null,
        findingId?: string | null,
        seenByAssignee?: boolean | null,
        assignmentDateTime?: string | null,
        seenDateTime?: string | null,
        startOfWorkDateTime?: string | null,
        endOfWorkDateTime?: string | null,
      } | null,
      state?: string | null,
      type?: string | null,
      templateId?: string | null,
      isArchived?: boolean | null,
      findingId?: string | null,
      seenByAssignee?: boolean | null,
      assignmentDateTime?: string | null,
      seenDateTime?: string | null,
      startOfWorkDateTime?: string | null,
      endOfWorkDateTime?: string | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type GetWorkOrderListQueryVariables = {
  params?: QueryListParams | null,
};

export type GetWorkOrderListQuery = {
  getWorkOrderList?:  {
    __typename: "WorkOrderListResponse",
    data?:  Array< {
      __typename: "WorkOrder",
      id?: string | null,
      displayNumber?: string | null,
      tenantId?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      createdAt?: string | null,
      createdBy?: string | null,
      createdByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      updatedByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      number?: number | null,
      userId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      locationId?: string | null,
      location?:  {
        __typename: "Location",
        id: string,
        tenantId: string,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        notes?: string | null,
        lat?: number | null,
        lng?: number | null,
        level?: string | null,
        parentId?: string | null,
        rootId?: string | null,
        thirdPartyId?: string | null,
        source?: string | null,
        inUseStatus?: InUseStatus | null,
        address?: string | null,
        buildingAddress?: string | null,
        parent?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        tisSyncedAt?: string | null,
      } | null,
      dueDate?: string | null,
      startDate?: string | null,
      endDate?: string | null,
      duration?: string | null,
      plannedStartDate?: string | null,
      plannedEndDate?: string | null,
      assetId?: string | null,
      asset?:  {
        __typename: "Asset",
        id: string,
        number?: number | null,
        displayNumber?: string | null,
        userId?: string | null,
        assetTag: string,
        description: string,
        makeId: string,
        modelId: string,
        state: string,
        usefulLife?: number | null,
        acquisitionCostValue?: number | null,
        lastMaintenanceDate?: string | null,
        nextScheduledMaintenanceDate?: string | null,
        assignedToId?: string | null,
        assetTypeId: string,
        condition?: string | null,
        maintenanceCostValue?: number | null,
        currentBookValue?: number | null,
        installDate?: string | null,
        decommissionDate?: string | null,
        locationId?: string | null,
        image?: string | null,
        purchaseOrderId?: string | null,
        utilizationData?: string | null,
        reasonForDecommission?: string | null,
        serialNumber: string,
        thirdPartyId?: string | null,
        source?: string | null,
        totalCostOfOwnershipValue?: number | null,
        repairCostValue?: number | null,
        warrantyExpiration?: string | null,
        downTime?: string | null,
        tenantId: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        model?:  {
          __typename: "Model",
          id: string,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          oemPartNumber?: string | null,
          name: string,
          manufacturerId: string,
          assetTypeId: string,
          probability?: number | null,
          severity?: number | null,
          riskScore?: number | null,
          picture?: string | null,
          specification?: string | null,
          usefulLife?: number | null,
          inUseStatus?: InUseStatus | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        assetType?:  {
          __typename: "AssetType",
          id: string,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          name: string,
          description?: string | null,
          category?: string | null,
          criticalityLevel?: number | null,
          expectedUsefulLife?: number | null,
          defaultWarrantyPeriod?: number | null,
          defaultRiskScore?: number | null,
          manufacturerRecommendations?: string | null,
          image?: string | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          inUseStatus?: string | null,
        } | null,
        manufacturer?:  {
          __typename: "Manufacturer",
          id: string,
          name: string,
          description?: string | null,
          countryId?: string | null,
          website?: string | null,
          contactPerson?: string | null,
          contactEmail?: string | null,
          contactPhone?: string | null,
          address?: string | null,
          warrantyPolicies?: string | null,
          slaDetails?: string | null,
          vendorPortalLink?: string | null,
          createdAt: string,
          createdBy: string,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          inUseStatus?: InUseStatus | null,
        } | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        woCount?: number | null,
        findingsCount?: number | null,
        user?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        assetRisk?: number | null,
        location?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        isParent?: boolean | null,
        thirdPartyParentId?: string | null,
        thirdPartyHierarchyPath?: Array< string | null > | null,
      } | null,
      assignmentGroupId?: string | null,
      assignedToId?: string | null,
      assignedTo?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      businessDownTime?: number | null,
      downTimeStart?: string | null,
      downTimeEnd?: string | null,
      category?: string | null,
      checklist?: string | null,
      closedNotes?: string | null,
      closedAt?: string | null,
      closedById?: string | null,
      closedBy?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      notes?: string | null,
      title?: string | null,
      description?: string | null,
      estimatedCostValue?: number | null,
      actualCostValue?: number | null,
      estimatedEffort?: number | null,
      actualEffort?: number | null,
      expectedOperationalDate?: string | null,
      impact?: number | null,
      priority?: number | null,
      dependsOnWorkOrderId?: string | null,
      dependsOnWorkOrder?:  {
        __typename: "WorkOrder",
        id?: string | null,
        displayNumber?: string | null,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt?: string | null,
        createdBy?: string | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        number?: number | null,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        locationId?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        dueDate?: string | null,
        startDate?: string | null,
        endDate?: string | null,
        duration?: string | null,
        plannedStartDate?: string | null,
        plannedEndDate?: string | null,
        assetId?: string | null,
        asset?:  {
          __typename: "Asset",
          id: string,
          number?: number | null,
          displayNumber?: string | null,
          userId?: string | null,
          assetTag: string,
          description: string,
          makeId: string,
          modelId: string,
          state: string,
          usefulLife?: number | null,
          acquisitionCostValue?: number | null,
          lastMaintenanceDate?: string | null,
          nextScheduledMaintenanceDate?: string | null,
          assignedToId?: string | null,
          assetTypeId: string,
          condition?: string | null,
          maintenanceCostValue?: number | null,
          currentBookValue?: number | null,
          installDate?: string | null,
          decommissionDate?: string | null,
          locationId?: string | null,
          image?: string | null,
          purchaseOrderId?: string | null,
          utilizationData?: string | null,
          reasonForDecommission?: string | null,
          serialNumber: string,
          thirdPartyId?: string | null,
          source?: string | null,
          totalCostOfOwnershipValue?: number | null,
          repairCostValue?: number | null,
          warrantyExpiration?: string | null,
          downTime?: string | null,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          model?:  {
            __typename: "Model",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            oemPartNumber?: string | null,
            name: string,
            manufacturerId: string,
            assetTypeId: string,
            probability?: number | null,
            severity?: number | null,
            riskScore?: number | null,
            picture?: string | null,
            specification?: string | null,
            usefulLife?: number | null,
            inUseStatus?: InUseStatus | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          woCount?: number | null,
          findingsCount?: number | null,
          user?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          assetRisk?: number | null,
          location?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          isParent?: boolean | null,
          thirdPartyParentId?: string | null,
          thirdPartyHierarchyPath?: Array< string | null > | null,
        } | null,
        assignmentGroupId?: string | null,
        assignedToId?: string | null,
        assignedTo?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        businessDownTime?: number | null,
        downTimeStart?: string | null,
        downTimeEnd?: string | null,
        category?: string | null,
        checklist?: string | null,
        closedNotes?: string | null,
        closedAt?: string | null,
        closedById?: string | null,
        closedBy?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        notes?: string | null,
        title?: string | null,
        description?: string | null,
        estimatedCostValue?: number | null,
        actualCostValue?: number | null,
        estimatedEffort?: number | null,
        actualEffort?: number | null,
        expectedOperationalDate?: string | null,
        impact?: number | null,
        priority?: number | null,
        dependsOnWorkOrderId?: string | null,
        dependsOnWorkOrder?:  {
          __typename: "WorkOrder",
          id?: string | null,
          displayNumber?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt?: string | null,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          number?: number | null,
          userId?: string | null,
          user?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          locationId?: string | null,
          location?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          dueDate?: string | null,
          startDate?: string | null,
          endDate?: string | null,
          duration?: string | null,
          plannedStartDate?: string | null,
          plannedEndDate?: string | null,
          assetId?: string | null,
          asset?:  {
            __typename: "Asset",
            id: string,
            number?: number | null,
            displayNumber?: string | null,
            userId?: string | null,
            assetTag: string,
            description: string,
            makeId: string,
            modelId: string,
            state: string,
            usefulLife?: number | null,
            acquisitionCostValue?: number | null,
            lastMaintenanceDate?: string | null,
            nextScheduledMaintenanceDate?: string | null,
            assignedToId?: string | null,
            assetTypeId: string,
            condition?: string | null,
            maintenanceCostValue?: number | null,
            currentBookValue?: number | null,
            installDate?: string | null,
            decommissionDate?: string | null,
            locationId?: string | null,
            image?: string | null,
            purchaseOrderId?: string | null,
            utilizationData?: string | null,
            reasonForDecommission?: string | null,
            serialNumber: string,
            thirdPartyId?: string | null,
            source?: string | null,
            totalCostOfOwnershipValue?: number | null,
            repairCostValue?: number | null,
            warrantyExpiration?: string | null,
            downTime?: string | null,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            woCount?: number | null,
            findingsCount?: number | null,
            assetRisk?: number | null,
            isParent?: boolean | null,
            thirdPartyParentId?: string | null,
            thirdPartyHierarchyPath?: Array< string | null > | null,
          } | null,
          assignmentGroupId?: string | null,
          assignedToId?: string | null,
          assignedTo?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          businessDownTime?: number | null,
          downTimeStart?: string | null,
          downTimeEnd?: string | null,
          category?: string | null,
          checklist?: string | null,
          closedNotes?: string | null,
          closedAt?: string | null,
          closedById?: string | null,
          closedBy?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          notes?: string | null,
          title?: string | null,
          description?: string | null,
          estimatedCostValue?: number | null,
          actualCostValue?: number | null,
          estimatedEffort?: number | null,
          actualEffort?: number | null,
          expectedOperationalDate?: string | null,
          impact?: number | null,
          priority?: number | null,
          dependsOnWorkOrderId?: string | null,
          dependsOnWorkOrder?:  {
            __typename: "WorkOrder",
            id?: string | null,
            displayNumber?: string | null,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            number?: number | null,
            userId?: string | null,
            locationId?: string | null,
            dueDate?: string | null,
            startDate?: string | null,
            endDate?: string | null,
            duration?: string | null,
            plannedStartDate?: string | null,
            plannedEndDate?: string | null,
            assetId?: string | null,
            assignmentGroupId?: string | null,
            assignedToId?: string | null,
            businessDownTime?: number | null,
            downTimeStart?: string | null,
            downTimeEnd?: string | null,
            category?: string | null,
            checklist?: string | null,
            closedNotes?: string | null,
            closedAt?: string | null,
            closedById?: string | null,
            notes?: string | null,
            title?: string | null,
            description?: string | null,
            estimatedCostValue?: number | null,
            actualCostValue?: number | null,
            estimatedEffort?: number | null,
            actualEffort?: number | null,
            expectedOperationalDate?: string | null,
            impact?: number | null,
            priority?: number | null,
            dependsOnWorkOrderId?: string | null,
            state?: string | null,
            type?: string | null,
            templateId?: string | null,
            isArchived?: boolean | null,
            findingId?: string | null,
            seenByAssignee?: boolean | null,
            assignmentDateTime?: string | null,
            seenDateTime?: string | null,
            startOfWorkDateTime?: string | null,
            endOfWorkDateTime?: string | null,
          } | null,
          state?: string | null,
          type?: string | null,
          templateId?: string | null,
          isArchived?: boolean | null,
          findingId?: string | null,
          seenByAssignee?: boolean | null,
          assignmentDateTime?: string | null,
          seenDateTime?: string | null,
          startOfWorkDateTime?: string | null,
          endOfWorkDateTime?: string | null,
        } | null,
        state?: string | null,
        type?: string | null,
        templateId?: string | null,
        isArchived?: boolean | null,
        findingId?: string | null,
        seenByAssignee?: boolean | null,
        assignmentDateTime?: string | null,
        seenDateTime?: string | null,
        startOfWorkDateTime?: string | null,
        endOfWorkDateTime?: string | null,
      } | null,
      state?: string | null,
      type?: string | null,
      templateId?: string | null,
      isArchived?: boolean | null,
      findingId?: string | null,
      seenByAssignee?: boolean | null,
      assignmentDateTime?: string | null,
      seenDateTime?: string | null,
      startOfWorkDateTime?: string | null,
      endOfWorkDateTime?: string | null,
    } | null > | null,
    totalCount?: number | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type GetWorkOrderPropsCountsQueryVariables = {
  userId?: string | null,
};

export type GetWorkOrderPropsCountsQuery = {
  getWorkOrderPropsCounts?:  {
    __typename: "WorkOrderPropsCountsResponse",
    data?:  {
      __typename: "WorkOrderPropsCounts",
      workOrders?: number | null,
      templates?: number | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type GetWorkOrderRelatedCountsQueryVariables = {
  workOrderId: string,
};

export type GetWorkOrderRelatedCountsQuery = {
  getWorkOrderRelatedCounts?:  {
    __typename: "WorkOrderRelatedCountsResponse",
    data?:  {
      __typename: "WorkOrderRelatedCounts",
      expenses?: number | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type GetWorkOrderTemplateQueryVariables = {
  id: string,
};

export type GetWorkOrderTemplateQuery = {
  getWorkOrderTemplate?:  {
    __typename: "WorkOrderTemplateResponse",
    data?:  {
      __typename: "WorkOrderTemplate",
      id?: string | null,
      displayNumber?: string | null,
      tenantId?: string | null,
      createdAt?: string | null,
      createdBy?: string | null,
      createdByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      updatedByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      number?: number | null,
      title: string,
      type?: string | null,
      category?: string | null,
      description?: string | null,
      userId?: string | null,
      locationId?: string | null,
      assignmentGroupId?: string | null,
      notes?: string | null,
      estimatedCostValue?: number | null,
      estimatedEffort?: number | null,
      impact?: number | null,
      priority?: number | null,
      executionInterval?: string | null,
      assetManufacturerId?: string | null,
      assetModelId?: string | null,
      assetTypeId?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      manufacturer?:  {
        __typename: "Manufacturer",
        id: string,
        name: string,
        description?: string | null,
        countryId?: string | null,
        website?: string | null,
        contactPerson?: string | null,
        contactEmail?: string | null,
        contactPhone?: string | null,
        address?: string | null,
        warrantyPolicies?: string | null,
        slaDetails?: string | null,
        vendorPortalLink?: string | null,
        createdAt: string,
        createdBy: string,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        inUseStatus?: InUseStatus | null,
      } | null,
      assetType?:  {
        __typename: "AssetType",
        id: string,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt: string,
        createdBy?: string | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        name: string,
        description?: string | null,
        category?: string | null,
        criticalityLevel?: number | null,
        expectedUsefulLife?: number | null,
        defaultWarrantyPeriod?: number | null,
        defaultRiskScore?: number | null,
        manufacturerRecommendations?: string | null,
        image?: string | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        inUseStatus?: string | null,
      } | null,
      model?:  {
        __typename: "Model",
        id: string,
        tenantId: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        oemPartNumber?: string | null,
        name: string,
        manufacturerId: string,
        assetTypeId: string,
        probability?: number | null,
        severity?: number | null,
        riskScore?: number | null,
        picture?: string | null,
        specification?: string | null,
        usefulLife?: number | null,
        inUseStatus?: InUseStatus | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        manufacturer?:  {
          __typename: "Manufacturer",
          id: string,
          name: string,
          description?: string | null,
          countryId?: string | null,
          website?: string | null,
          contactPerson?: string | null,
          contactEmail?: string | null,
          contactPhone?: string | null,
          address?: string | null,
          warrantyPolicies?: string | null,
          slaDetails?: string | null,
          vendorPortalLink?: string | null,
          createdAt: string,
          createdBy: string,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          inUseStatus?: InUseStatus | null,
        } | null,
        assetType?:  {
          __typename: "AssetType",
          id: string,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          name: string,
          description?: string | null,
          category?: string | null,
          criticalityLevel?: number | null,
          expectedUsefulLife?: number | null,
          defaultWarrantyPeriod?: number | null,
          defaultRiskScore?: number | null,
          manufacturerRecommendations?: string | null,
          image?: string | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          inUseStatus?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type GetWorkOrderTemplateListQueryVariables = {
  params?: QueryListParams | null,
};

export type GetWorkOrderTemplateListQuery = {
  getWorkOrderTemplateList?:  {
    __typename: "WorkOrderTemplateListResponse",
    data?:  Array< {
      __typename: "WorkOrderTemplate",
      id?: string | null,
      displayNumber?: string | null,
      tenantId?: string | null,
      createdAt?: string | null,
      createdBy?: string | null,
      createdByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      updatedByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      number?: number | null,
      title: string,
      type?: string | null,
      category?: string | null,
      description?: string | null,
      userId?: string | null,
      locationId?: string | null,
      assignmentGroupId?: string | null,
      notes?: string | null,
      estimatedCostValue?: number | null,
      estimatedEffort?: number | null,
      impact?: number | null,
      priority?: number | null,
      executionInterval?: string | null,
      assetManufacturerId?: string | null,
      assetModelId?: string | null,
      assetTypeId?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      manufacturer?:  {
        __typename: "Manufacturer",
        id: string,
        name: string,
        description?: string | null,
        countryId?: string | null,
        website?: string | null,
        contactPerson?: string | null,
        contactEmail?: string | null,
        contactPhone?: string | null,
        address?: string | null,
        warrantyPolicies?: string | null,
        slaDetails?: string | null,
        vendorPortalLink?: string | null,
        createdAt: string,
        createdBy: string,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        inUseStatus?: InUseStatus | null,
      } | null,
      assetType?:  {
        __typename: "AssetType",
        id: string,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt: string,
        createdBy?: string | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        name: string,
        description?: string | null,
        category?: string | null,
        criticalityLevel?: number | null,
        expectedUsefulLife?: number | null,
        defaultWarrantyPeriod?: number | null,
        defaultRiskScore?: number | null,
        manufacturerRecommendations?: string | null,
        image?: string | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        inUseStatus?: string | null,
      } | null,
      model?:  {
        __typename: "Model",
        id: string,
        tenantId: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        oemPartNumber?: string | null,
        name: string,
        manufacturerId: string,
        assetTypeId: string,
        probability?: number | null,
        severity?: number | null,
        riskScore?: number | null,
        picture?: string | null,
        specification?: string | null,
        usefulLife?: number | null,
        inUseStatus?: InUseStatus | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        manufacturer?:  {
          __typename: "Manufacturer",
          id: string,
          name: string,
          description?: string | null,
          countryId?: string | null,
          website?: string | null,
          contactPerson?: string | null,
          contactEmail?: string | null,
          contactPhone?: string | null,
          address?: string | null,
          warrantyPolicies?: string | null,
          slaDetails?: string | null,
          vendorPortalLink?: string | null,
          createdAt: string,
          createdBy: string,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          inUseStatus?: InUseStatus | null,
        } | null,
        assetType?:  {
          __typename: "AssetType",
          id: string,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          name: string,
          description?: string | null,
          category?: string | null,
          criticalityLevel?: number | null,
          expectedUsefulLife?: number | null,
          defaultWarrantyPeriod?: number | null,
          defaultRiskScore?: number | null,
          manufacturerRecommendations?: string | null,
          image?: string | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          inUseStatus?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
    } | null > | null,
    totalCount?: number | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type GetManufacturerQueryVariables = {
  id: string,
};

export type GetManufacturerQuery = {
  getManufacturer?:  {
    __typename: "ManufacturerResponse",
    data?:  {
      __typename: "Manufacturer",
      id: string,
      name: string,
      description?: string | null,
      countryId?: string | null,
      website?: string | null,
      contactPerson?: string | null,
      contactEmail?: string | null,
      contactPhone?: string | null,
      address?: string | null,
      warrantyPolicies?: string | null,
      slaDetails?: string | null,
      vendorPortalLink?: string | null,
      createdAt: string,
      createdBy: string,
      createdByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      updatedByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      thirdPartyId?: string | null,
      thirdPartySource?: string | null,
      tenantId?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      inUseStatus?: InUseStatus | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type GetManufacturerListQueryVariables = {
  params?: QueryListParams | null,
};

export type GetManufacturerListQuery = {
  getManufacturerList?:  {
    __typename: "ManufacturerListResponse",
    data?:  Array< {
      __typename: "Manufacturer",
      id: string,
      name: string,
      description?: string | null,
      countryId?: string | null,
      website?: string | null,
      contactPerson?: string | null,
      contactEmail?: string | null,
      contactPhone?: string | null,
      address?: string | null,
      warrantyPolicies?: string | null,
      slaDetails?: string | null,
      vendorPortalLink?: string | null,
      createdAt: string,
      createdBy: string,
      createdByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      updatedByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      thirdPartyId?: string | null,
      thirdPartySource?: string | null,
      tenantId?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      inUseStatus?: InUseStatus | null,
    } | null > | null,
    totalCount?: number | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type GetModelQueryVariables = {
  id: string,
};

export type GetModelQuery = {
  getModel?:  {
    __typename: "ModelResponse",
    data?:  {
      __typename: "Model",
      id: string,
      tenantId: string,
      createdAt: string,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      oemPartNumber?: string | null,
      name: string,
      manufacturerId: string,
      assetTypeId: string,
      probability?: number | null,
      severity?: number | null,
      riskScore?: number | null,
      picture?: string | null,
      specification?: string | null,
      usefulLife?: number | null,
      inUseStatus?: InUseStatus | null,
      thirdPartyId?: string | null,
      thirdPartySource?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      manufacturer?:  {
        __typename: "Manufacturer",
        id: string,
        name: string,
        description?: string | null,
        countryId?: string | null,
        website?: string | null,
        contactPerson?: string | null,
        contactEmail?: string | null,
        contactPhone?: string | null,
        address?: string | null,
        warrantyPolicies?: string | null,
        slaDetails?: string | null,
        vendorPortalLink?: string | null,
        createdAt: string,
        createdBy: string,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        inUseStatus?: InUseStatus | null,
      } | null,
      assetType?:  {
        __typename: "AssetType",
        id: string,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt: string,
        createdBy?: string | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        name: string,
        description?: string | null,
        category?: string | null,
        criticalityLevel?: number | null,
        expectedUsefulLife?: number | null,
        defaultWarrantyPeriod?: number | null,
        defaultRiskScore?: number | null,
        manufacturerRecommendations?: string | null,
        image?: string | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        inUseStatus?: string | null,
      } | null,
      createdByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      updatedByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type GetModelListQueryVariables = {
  params?: QueryListParams | null,
};

export type GetModelListQuery = {
  getModelList?:  {
    __typename: "ModelListResponse",
    data?:  Array< {
      __typename: "Model",
      id: string,
      tenantId: string,
      createdAt: string,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      oemPartNumber?: string | null,
      name: string,
      manufacturerId: string,
      assetTypeId: string,
      probability?: number | null,
      severity?: number | null,
      riskScore?: number | null,
      picture?: string | null,
      specification?: string | null,
      usefulLife?: number | null,
      inUseStatus?: InUseStatus | null,
      thirdPartyId?: string | null,
      thirdPartySource?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      manufacturer?:  {
        __typename: "Manufacturer",
        id: string,
        name: string,
        description?: string | null,
        countryId?: string | null,
        website?: string | null,
        contactPerson?: string | null,
        contactEmail?: string | null,
        contactPhone?: string | null,
        address?: string | null,
        warrantyPolicies?: string | null,
        slaDetails?: string | null,
        vendorPortalLink?: string | null,
        createdAt: string,
        createdBy: string,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        inUseStatus?: InUseStatus | null,
      } | null,
      assetType?:  {
        __typename: "AssetType",
        id: string,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt: string,
        createdBy?: string | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        name: string,
        description?: string | null,
        category?: string | null,
        criticalityLevel?: number | null,
        expectedUsefulLife?: number | null,
        defaultWarrantyPeriod?: number | null,
        defaultRiskScore?: number | null,
        manufacturerRecommendations?: string | null,
        image?: string | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        inUseStatus?: string | null,
      } | null,
      createdByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      updatedByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
    } | null > | null,
    totalCount?: number | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type GetUserQueryVariables = {
  id: string,
};

export type GetUserQuery = {
  getUser?:  {
    __typename: "UserResponse",
    data?:  {
      __typename: "User",
      id: string,
      tenantId?: string | null,
      createdAt?: string | null,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      groups?: string | null,
      email: string,
      name: string,
      phone?: string | null,
      role?: string | null,
      address?: string | null,
      location?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      createdByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      updatedByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type GetUserListQueryVariables = {
  params?: UserQueryListParams | null,
};

export type GetUserListQuery = {
  getUserList?:  {
    __typename: "UserListResponse",
    data?:  Array< {
      __typename: "User",
      id: string,
      tenantId?: string | null,
      createdAt?: string | null,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      groups?: string | null,
      email: string,
      name: string,
      phone?: string | null,
      role?: string | null,
      address?: string | null,
      location?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      createdByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      updatedByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
    } | null > | null,
    totalCount?: number | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type GetTenantQueryVariables = {
  id: string,
};

export type GetTenantQuery = {
  getTenant?:  {
    __typename: "TenantResponse",
    data?:  {
      __typename: "Tenant",
      id: string,
      createdAt: string,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      name: string,
      address?: string | null,
      contacts?: string | null,
      isActive?: boolean | null,
      cognitoGroupName?: string | null,
      tisId?: string | null,
      plan?: TenantPlan | null,
      tisSyncedAt?: string | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type GetTenantListQueryVariables = {
  params?: QueryListParams | null,
};

export type GetTenantListQuery = {
  getTenantList?:  {
    __typename: "TenantListResponse",
    data?:  Array< {
      __typename: "Tenant",
      id: string,
      createdAt: string,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      name: string,
      address?: string | null,
      contacts?: string | null,
      isActive?: boolean | null,
      cognitoGroupName?: string | null,
      tisId?: string | null,
      plan?: TenantPlan | null,
      tisSyncedAt?: string | null,
    } | null > | null,
    totalCount?: number | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type GetLocationQueryVariables = {
  id: string,
};

export type GetLocationQuery = {
  getLocation?:  {
    __typename: "LocationResponse",
    data?:  {
      __typename: "Location",
      id: string,
      tenantId: string,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      createdAt: string,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      name: string,
      notes?: string | null,
      lat?: number | null,
      lng?: number | null,
      level?: string | null,
      parentId?: string | null,
      rootId?: string | null,
      thirdPartyId?: string | null,
      source?: string | null,
      inUseStatus?: InUseStatus | null,
      address?: string | null,
      buildingAddress?: string | null,
      parent?:  {
        __typename: "Location",
        id: string,
        tenantId: string,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        notes?: string | null,
        lat?: number | null,
        lng?: number | null,
        level?: string | null,
        parentId?: string | null,
        rootId?: string | null,
        thirdPartyId?: string | null,
        source?: string | null,
        inUseStatus?: InUseStatus | null,
        address?: string | null,
        buildingAddress?: string | null,
        parent?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        tisSyncedAt?: string | null,
      } | null,
      tisSyncedAt?: string | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type GetLocationListQueryVariables = {
  params?: QueryListParams | null,
};

export type GetLocationListQuery = {
  getLocationList?:  {
    __typename: "LocationListResponse",
    data?:  Array< {
      __typename: "Location",
      id: string,
      tenantId: string,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      createdAt: string,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      name: string,
      notes?: string | null,
      lat?: number | null,
      lng?: number | null,
      level?: string | null,
      parentId?: string | null,
      rootId?: string | null,
      thirdPartyId?: string | null,
      source?: string | null,
      inUseStatus?: InUseStatus | null,
      address?: string | null,
      buildingAddress?: string | null,
      parent?:  {
        __typename: "Location",
        id: string,
        tenantId: string,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        notes?: string | null,
        lat?: number | null,
        lng?: number | null,
        level?: string | null,
        parentId?: string | null,
        rootId?: string | null,
        thirdPartyId?: string | null,
        source?: string | null,
        inUseStatus?: InUseStatus | null,
        address?: string | null,
        buildingAddress?: string | null,
        parent?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        tisSyncedAt?: string | null,
      } | null,
      tisSyncedAt?: string | null,
    } | null > | null,
    totalCount?: number | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type GetBuildingListQueryVariables = {
  params?: QueryListParams | null,
};

export type GetBuildingListQuery = {
  getBuildingList?:  {
    __typename: "LocationListResponse",
    data?:  Array< {
      __typename: "Location",
      id: string,
      tenantId: string,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      createdAt: string,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      name: string,
      notes?: string | null,
      lat?: number | null,
      lng?: number | null,
      level?: string | null,
      parentId?: string | null,
      rootId?: string | null,
      thirdPartyId?: string | null,
      source?: string | null,
      inUseStatus?: InUseStatus | null,
      address?: string | null,
      buildingAddress?: string | null,
      parent?:  {
        __typename: "Location",
        id: string,
        tenantId: string,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        notes?: string | null,
        lat?: number | null,
        lng?: number | null,
        level?: string | null,
        parentId?: string | null,
        rootId?: string | null,
        thirdPartyId?: string | null,
        source?: string | null,
        inUseStatus?: InUseStatus | null,
        address?: string | null,
        buildingAddress?: string | null,
        parent?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        tisSyncedAt?: string | null,
      } | null,
      tisSyncedAt?: string | null,
    } | null > | null,
    totalCount?: number | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type GetExpenseQueryVariables = {
  id: string,
};

export type GetExpenseQuery = {
  getExpense?:  {
    __typename: "ExpenseResponse",
    data?:  {
      __typename: "Expense",
      id: string,
      displayNumber?: string | null,
      tenantId: string,
      createdAt: string,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      title: string,
      description?: string | null,
      type?: string | null,
      status?: string | null,
      number?: number | null,
      amount?: number | null,
      purchaseOrderId?: string | null,
      workOrderId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      updatedByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      workOrder?:  {
        __typename: "WorkOrder",
        id?: string | null,
        displayNumber?: string | null,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt?: string | null,
        createdBy?: string | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        number?: number | null,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        locationId?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        dueDate?: string | null,
        startDate?: string | null,
        endDate?: string | null,
        duration?: string | null,
        plannedStartDate?: string | null,
        plannedEndDate?: string | null,
        assetId?: string | null,
        asset?:  {
          __typename: "Asset",
          id: string,
          number?: number | null,
          displayNumber?: string | null,
          userId?: string | null,
          assetTag: string,
          description: string,
          makeId: string,
          modelId: string,
          state: string,
          usefulLife?: number | null,
          acquisitionCostValue?: number | null,
          lastMaintenanceDate?: string | null,
          nextScheduledMaintenanceDate?: string | null,
          assignedToId?: string | null,
          assetTypeId: string,
          condition?: string | null,
          maintenanceCostValue?: number | null,
          currentBookValue?: number | null,
          installDate?: string | null,
          decommissionDate?: string | null,
          locationId?: string | null,
          image?: string | null,
          purchaseOrderId?: string | null,
          utilizationData?: string | null,
          reasonForDecommission?: string | null,
          serialNumber: string,
          thirdPartyId?: string | null,
          source?: string | null,
          totalCostOfOwnershipValue?: number | null,
          repairCostValue?: number | null,
          warrantyExpiration?: string | null,
          downTime?: string | null,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          model?:  {
            __typename: "Model",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            oemPartNumber?: string | null,
            name: string,
            manufacturerId: string,
            assetTypeId: string,
            probability?: number | null,
            severity?: number | null,
            riskScore?: number | null,
            picture?: string | null,
            specification?: string | null,
            usefulLife?: number | null,
            inUseStatus?: InUseStatus | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          woCount?: number | null,
          findingsCount?: number | null,
          user?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          assetRisk?: number | null,
          location?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          isParent?: boolean | null,
          thirdPartyParentId?: string | null,
          thirdPartyHierarchyPath?: Array< string | null > | null,
        } | null,
        assignmentGroupId?: string | null,
        assignedToId?: string | null,
        assignedTo?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        businessDownTime?: number | null,
        downTimeStart?: string | null,
        downTimeEnd?: string | null,
        category?: string | null,
        checklist?: string | null,
        closedNotes?: string | null,
        closedAt?: string | null,
        closedById?: string | null,
        closedBy?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        notes?: string | null,
        title?: string | null,
        description?: string | null,
        estimatedCostValue?: number | null,
        actualCostValue?: number | null,
        estimatedEffort?: number | null,
        actualEffort?: number | null,
        expectedOperationalDate?: string | null,
        impact?: number | null,
        priority?: number | null,
        dependsOnWorkOrderId?: string | null,
        dependsOnWorkOrder?:  {
          __typename: "WorkOrder",
          id?: string | null,
          displayNumber?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt?: string | null,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          number?: number | null,
          userId?: string | null,
          user?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          locationId?: string | null,
          location?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          dueDate?: string | null,
          startDate?: string | null,
          endDate?: string | null,
          duration?: string | null,
          plannedStartDate?: string | null,
          plannedEndDate?: string | null,
          assetId?: string | null,
          asset?:  {
            __typename: "Asset",
            id: string,
            number?: number | null,
            displayNumber?: string | null,
            userId?: string | null,
            assetTag: string,
            description: string,
            makeId: string,
            modelId: string,
            state: string,
            usefulLife?: number | null,
            acquisitionCostValue?: number | null,
            lastMaintenanceDate?: string | null,
            nextScheduledMaintenanceDate?: string | null,
            assignedToId?: string | null,
            assetTypeId: string,
            condition?: string | null,
            maintenanceCostValue?: number | null,
            currentBookValue?: number | null,
            installDate?: string | null,
            decommissionDate?: string | null,
            locationId?: string | null,
            image?: string | null,
            purchaseOrderId?: string | null,
            utilizationData?: string | null,
            reasonForDecommission?: string | null,
            serialNumber: string,
            thirdPartyId?: string | null,
            source?: string | null,
            totalCostOfOwnershipValue?: number | null,
            repairCostValue?: number | null,
            warrantyExpiration?: string | null,
            downTime?: string | null,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            woCount?: number | null,
            findingsCount?: number | null,
            assetRisk?: number | null,
            isParent?: boolean | null,
            thirdPartyParentId?: string | null,
            thirdPartyHierarchyPath?: Array< string | null > | null,
          } | null,
          assignmentGroupId?: string | null,
          assignedToId?: string | null,
          assignedTo?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          businessDownTime?: number | null,
          downTimeStart?: string | null,
          downTimeEnd?: string | null,
          category?: string | null,
          checklist?: string | null,
          closedNotes?: string | null,
          closedAt?: string | null,
          closedById?: string | null,
          closedBy?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          notes?: string | null,
          title?: string | null,
          description?: string | null,
          estimatedCostValue?: number | null,
          actualCostValue?: number | null,
          estimatedEffort?: number | null,
          actualEffort?: number | null,
          expectedOperationalDate?: string | null,
          impact?: number | null,
          priority?: number | null,
          dependsOnWorkOrderId?: string | null,
          dependsOnWorkOrder?:  {
            __typename: "WorkOrder",
            id?: string | null,
            displayNumber?: string | null,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            number?: number | null,
            userId?: string | null,
            locationId?: string | null,
            dueDate?: string | null,
            startDate?: string | null,
            endDate?: string | null,
            duration?: string | null,
            plannedStartDate?: string | null,
            plannedEndDate?: string | null,
            assetId?: string | null,
            assignmentGroupId?: string | null,
            assignedToId?: string | null,
            businessDownTime?: number | null,
            downTimeStart?: string | null,
            downTimeEnd?: string | null,
            category?: string | null,
            checklist?: string | null,
            closedNotes?: string | null,
            closedAt?: string | null,
            closedById?: string | null,
            notes?: string | null,
            title?: string | null,
            description?: string | null,
            estimatedCostValue?: number | null,
            actualCostValue?: number | null,
            estimatedEffort?: number | null,
            actualEffort?: number | null,
            expectedOperationalDate?: string | null,
            impact?: number | null,
            priority?: number | null,
            dependsOnWorkOrderId?: string | null,
            state?: string | null,
            type?: string | null,
            templateId?: string | null,
            isArchived?: boolean | null,
            findingId?: string | null,
            seenByAssignee?: boolean | null,
            assignmentDateTime?: string | null,
            seenDateTime?: string | null,
            startOfWorkDateTime?: string | null,
            endOfWorkDateTime?: string | null,
          } | null,
          state?: string | null,
          type?: string | null,
          templateId?: string | null,
          isArchived?: boolean | null,
          findingId?: string | null,
          seenByAssignee?: boolean | null,
          assignmentDateTime?: string | null,
          seenDateTime?: string | null,
          startOfWorkDateTime?: string | null,
          endOfWorkDateTime?: string | null,
        } | null,
        state?: string | null,
        type?: string | null,
        templateId?: string | null,
        isArchived?: boolean | null,
        findingId?: string | null,
        seenByAssignee?: boolean | null,
        assignmentDateTime?: string | null,
        seenDateTime?: string | null,
        startOfWorkDateTime?: string | null,
        endOfWorkDateTime?: string | null,
      } | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type GetExpenseListQueryVariables = {
  params?: QueryListParams | null,
};

export type GetExpenseListQuery = {
  getExpenseList?:  {
    __typename: "ExpenseListResponse",
    data?:  Array< {
      __typename: "Expense",
      id: string,
      displayNumber?: string | null,
      tenantId: string,
      createdAt: string,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      title: string,
      description?: string | null,
      type?: string | null,
      status?: string | null,
      number?: number | null,
      amount?: number | null,
      purchaseOrderId?: string | null,
      workOrderId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      updatedByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      workOrder?:  {
        __typename: "WorkOrder",
        id?: string | null,
        displayNumber?: string | null,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt?: string | null,
        createdBy?: string | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        number?: number | null,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        locationId?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        dueDate?: string | null,
        startDate?: string | null,
        endDate?: string | null,
        duration?: string | null,
        plannedStartDate?: string | null,
        plannedEndDate?: string | null,
        assetId?: string | null,
        asset?:  {
          __typename: "Asset",
          id: string,
          number?: number | null,
          displayNumber?: string | null,
          userId?: string | null,
          assetTag: string,
          description: string,
          makeId: string,
          modelId: string,
          state: string,
          usefulLife?: number | null,
          acquisitionCostValue?: number | null,
          lastMaintenanceDate?: string | null,
          nextScheduledMaintenanceDate?: string | null,
          assignedToId?: string | null,
          assetTypeId: string,
          condition?: string | null,
          maintenanceCostValue?: number | null,
          currentBookValue?: number | null,
          installDate?: string | null,
          decommissionDate?: string | null,
          locationId?: string | null,
          image?: string | null,
          purchaseOrderId?: string | null,
          utilizationData?: string | null,
          reasonForDecommission?: string | null,
          serialNumber: string,
          thirdPartyId?: string | null,
          source?: string | null,
          totalCostOfOwnershipValue?: number | null,
          repairCostValue?: number | null,
          warrantyExpiration?: string | null,
          downTime?: string | null,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          model?:  {
            __typename: "Model",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            oemPartNumber?: string | null,
            name: string,
            manufacturerId: string,
            assetTypeId: string,
            probability?: number | null,
            severity?: number | null,
            riskScore?: number | null,
            picture?: string | null,
            specification?: string | null,
            usefulLife?: number | null,
            inUseStatus?: InUseStatus | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          woCount?: number | null,
          findingsCount?: number | null,
          user?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          assetRisk?: number | null,
          location?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          isParent?: boolean | null,
          thirdPartyParentId?: string | null,
          thirdPartyHierarchyPath?: Array< string | null > | null,
        } | null,
        assignmentGroupId?: string | null,
        assignedToId?: string | null,
        assignedTo?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        businessDownTime?: number | null,
        downTimeStart?: string | null,
        downTimeEnd?: string | null,
        category?: string | null,
        checklist?: string | null,
        closedNotes?: string | null,
        closedAt?: string | null,
        closedById?: string | null,
        closedBy?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        notes?: string | null,
        title?: string | null,
        description?: string | null,
        estimatedCostValue?: number | null,
        actualCostValue?: number | null,
        estimatedEffort?: number | null,
        actualEffort?: number | null,
        expectedOperationalDate?: string | null,
        impact?: number | null,
        priority?: number | null,
        dependsOnWorkOrderId?: string | null,
        dependsOnWorkOrder?:  {
          __typename: "WorkOrder",
          id?: string | null,
          displayNumber?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt?: string | null,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          number?: number | null,
          userId?: string | null,
          user?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          locationId?: string | null,
          location?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          dueDate?: string | null,
          startDate?: string | null,
          endDate?: string | null,
          duration?: string | null,
          plannedStartDate?: string | null,
          plannedEndDate?: string | null,
          assetId?: string | null,
          asset?:  {
            __typename: "Asset",
            id: string,
            number?: number | null,
            displayNumber?: string | null,
            userId?: string | null,
            assetTag: string,
            description: string,
            makeId: string,
            modelId: string,
            state: string,
            usefulLife?: number | null,
            acquisitionCostValue?: number | null,
            lastMaintenanceDate?: string | null,
            nextScheduledMaintenanceDate?: string | null,
            assignedToId?: string | null,
            assetTypeId: string,
            condition?: string | null,
            maintenanceCostValue?: number | null,
            currentBookValue?: number | null,
            installDate?: string | null,
            decommissionDate?: string | null,
            locationId?: string | null,
            image?: string | null,
            purchaseOrderId?: string | null,
            utilizationData?: string | null,
            reasonForDecommission?: string | null,
            serialNumber: string,
            thirdPartyId?: string | null,
            source?: string | null,
            totalCostOfOwnershipValue?: number | null,
            repairCostValue?: number | null,
            warrantyExpiration?: string | null,
            downTime?: string | null,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            woCount?: number | null,
            findingsCount?: number | null,
            assetRisk?: number | null,
            isParent?: boolean | null,
            thirdPartyParentId?: string | null,
            thirdPartyHierarchyPath?: Array< string | null > | null,
          } | null,
          assignmentGroupId?: string | null,
          assignedToId?: string | null,
          assignedTo?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          businessDownTime?: number | null,
          downTimeStart?: string | null,
          downTimeEnd?: string | null,
          category?: string | null,
          checklist?: string | null,
          closedNotes?: string | null,
          closedAt?: string | null,
          closedById?: string | null,
          closedBy?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          notes?: string | null,
          title?: string | null,
          description?: string | null,
          estimatedCostValue?: number | null,
          actualCostValue?: number | null,
          estimatedEffort?: number | null,
          actualEffort?: number | null,
          expectedOperationalDate?: string | null,
          impact?: number | null,
          priority?: number | null,
          dependsOnWorkOrderId?: string | null,
          dependsOnWorkOrder?:  {
            __typename: "WorkOrder",
            id?: string | null,
            displayNumber?: string | null,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            number?: number | null,
            userId?: string | null,
            locationId?: string | null,
            dueDate?: string | null,
            startDate?: string | null,
            endDate?: string | null,
            duration?: string | null,
            plannedStartDate?: string | null,
            plannedEndDate?: string | null,
            assetId?: string | null,
            assignmentGroupId?: string | null,
            assignedToId?: string | null,
            businessDownTime?: number | null,
            downTimeStart?: string | null,
            downTimeEnd?: string | null,
            category?: string | null,
            checklist?: string | null,
            closedNotes?: string | null,
            closedAt?: string | null,
            closedById?: string | null,
            notes?: string | null,
            title?: string | null,
            description?: string | null,
            estimatedCostValue?: number | null,
            actualCostValue?: number | null,
            estimatedEffort?: number | null,
            actualEffort?: number | null,
            expectedOperationalDate?: string | null,
            impact?: number | null,
            priority?: number | null,
            dependsOnWorkOrderId?: string | null,
            state?: string | null,
            type?: string | null,
            templateId?: string | null,
            isArchived?: boolean | null,
            findingId?: string | null,
            seenByAssignee?: boolean | null,
            assignmentDateTime?: string | null,
            seenDateTime?: string | null,
            startOfWorkDateTime?: string | null,
            endOfWorkDateTime?: string | null,
          } | null,
          state?: string | null,
          type?: string | null,
          templateId?: string | null,
          isArchived?: boolean | null,
          findingId?: string | null,
          seenByAssignee?: boolean | null,
          assignmentDateTime?: string | null,
          seenDateTime?: string | null,
          startOfWorkDateTime?: string | null,
          endOfWorkDateTime?: string | null,
        } | null,
        state?: string | null,
        type?: string | null,
        templateId?: string | null,
        isArchived?: boolean | null,
        findingId?: string | null,
        seenByAssignee?: boolean | null,
        assignmentDateTime?: string | null,
        seenDateTime?: string | null,
        startOfWorkDateTime?: string | null,
        endOfWorkDateTime?: string | null,
      } | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
    } | null > | null,
    totalCount?: number | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type GetAssetTypeQueryVariables = {
  id: string,
};

export type GetAssetTypeQuery = {
  getAssetType?:  {
    __typename: "AssetTypeResponse",
    data?:  {
      __typename: "AssetType",
      id: string,
      tenantId?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      createdAt: string,
      createdBy?: string | null,
      createdByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      updatedByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      name: string,
      description?: string | null,
      category?: string | null,
      criticalityLevel?: number | null,
      expectedUsefulLife?: number | null,
      defaultWarrantyPeriod?: number | null,
      defaultRiskScore?: number | null,
      manufacturerRecommendations?: string | null,
      image?: string | null,
      thirdPartyId?: string | null,
      thirdPartySource?: string | null,
      inUseStatus?: string | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type GetAssetTypeListQueryVariables = {
  params?: QueryListParams | null,
};

export type GetAssetTypeListQuery = {
  getAssetTypeList?:  {
    __typename: "AssetTypeListResponse",
    data?:  Array< {
      __typename: "AssetType",
      id: string,
      tenantId?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      createdAt: string,
      createdBy?: string | null,
      createdByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      updatedByUser?:  {
        __typename: "User",
        id: string,
        tenantId?: string | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        groups?: string | null,
        email: string,
        name: string,
        phone?: string | null,
        role?: string | null,
        address?: string | null,
        location?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      name: string,
      description?: string | null,
      category?: string | null,
      criticalityLevel?: number | null,
      expectedUsefulLife?: number | null,
      defaultWarrantyPeriod?: number | null,
      defaultRiskScore?: number | null,
      manufacturerRecommendations?: string | null,
      image?: string | null,
      thirdPartyId?: string | null,
      thirdPartySource?: string | null,
      inUseStatus?: string | null,
    } | null > | null,
    totalCount?: number | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type GetFindingQueryVariables = {
  id: string,
};

export type GetFindingQuery = {
  getFinding?:  {
    __typename: "FindingResponse",
    data?:  {
      __typename: "Finding",
      id: string,
      tenantId?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      createdAt?: string | null,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      number?: number | null,
      displayNumber?: string | null,
      shortDescription?: string | null,
      priority?: number | null,
      estimatedRepairCost?: number | null,
      plannedRepairDate?: string | null,
      description?: string | null,
      cause?: string | null,
      symptom?: string | null,
      picture?: string | null,
      reportedOn?: string | null,
      workOrderId?: string | null,
      type?: FindingType | null,
      reportedById?: string | null,
      status?: FindingStatus | null,
      assetId?: string | null,
      asset?:  {
        __typename: "Asset",
        id: string,
        number?: number | null,
        displayNumber?: string | null,
        userId?: string | null,
        assetTag: string,
        description: string,
        makeId: string,
        modelId: string,
        state: string,
        usefulLife?: number | null,
        acquisitionCostValue?: number | null,
        lastMaintenanceDate?: string | null,
        nextScheduledMaintenanceDate?: string | null,
        assignedToId?: string | null,
        assetTypeId: string,
        condition?: string | null,
        maintenanceCostValue?: number | null,
        currentBookValue?: number | null,
        installDate?: string | null,
        decommissionDate?: string | null,
        locationId?: string | null,
        image?: string | null,
        purchaseOrderId?: string | null,
        utilizationData?: string | null,
        reasonForDecommission?: string | null,
        serialNumber: string,
        thirdPartyId?: string | null,
        source?: string | null,
        totalCostOfOwnershipValue?: number | null,
        repairCostValue?: number | null,
        warrantyExpiration?: string | null,
        downTime?: string | null,
        tenantId: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        model?:  {
          __typename: "Model",
          id: string,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          oemPartNumber?: string | null,
          name: string,
          manufacturerId: string,
          assetTypeId: string,
          probability?: number | null,
          severity?: number | null,
          riskScore?: number | null,
          picture?: string | null,
          specification?: string | null,
          usefulLife?: number | null,
          inUseStatus?: InUseStatus | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        assetType?:  {
          __typename: "AssetType",
          id: string,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          name: string,
          description?: string | null,
          category?: string | null,
          criticalityLevel?: number | null,
          expectedUsefulLife?: number | null,
          defaultWarrantyPeriod?: number | null,
          defaultRiskScore?: number | null,
          manufacturerRecommendations?: string | null,
          image?: string | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          inUseStatus?: string | null,
        } | null,
        manufacturer?:  {
          __typename: "Manufacturer",
          id: string,
          name: string,
          description?: string | null,
          countryId?: string | null,
          website?: string | null,
          contactPerson?: string | null,
          contactEmail?: string | null,
          contactPhone?: string | null,
          address?: string | null,
          warrantyPolicies?: string | null,
          slaDetails?: string | null,
          vendorPortalLink?: string | null,
          createdAt: string,
          createdBy: string,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          inUseStatus?: InUseStatus | null,
        } | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        woCount?: number | null,
        findingsCount?: number | null,
        user?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        assetRisk?: number | null,
        location?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        isParent?: boolean | null,
        thirdPartyParentId?: string | null,
        thirdPartyHierarchyPath?: Array< string | null > | null,
      } | null,
      locationId?: string | null,
      model?:  {
        __typename: "Model",
        id: string,
        tenantId: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        oemPartNumber?: string | null,
        name: string,
        manufacturerId: string,
        assetTypeId: string,
        probability?: number | null,
        severity?: number | null,
        riskScore?: number | null,
        picture?: string | null,
        specification?: string | null,
        usefulLife?: number | null,
        inUseStatus?: InUseStatus | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        manufacturer?:  {
          __typename: "Manufacturer",
          id: string,
          name: string,
          description?: string | null,
          countryId?: string | null,
          website?: string | null,
          contactPerson?: string | null,
          contactEmail?: string | null,
          contactPhone?: string | null,
          address?: string | null,
          warrantyPolicies?: string | null,
          slaDetails?: string | null,
          vendorPortalLink?: string | null,
          createdAt: string,
          createdBy: string,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          inUseStatus?: InUseStatus | null,
        } | null,
        assetType?:  {
          __typename: "AssetType",
          id: string,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          name: string,
          description?: string | null,
          category?: string | null,
          criticalityLevel?: number | null,
          expectedUsefulLife?: number | null,
          defaultWarrantyPeriod?: number | null,
          defaultRiskScore?: number | null,
          manufacturerRecommendations?: string | null,
          image?: string | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          inUseStatus?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      isArchived?: boolean | null,
      thirdPartyId?: string | null,
      thirdPartySource?: string | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type GetFindingListQueryVariables = {
  params?: QueryListParams | null,
};

export type GetFindingListQuery = {
  getFindingList?:  {
    __typename: "FindingListResponse",
    data?:  Array< {
      __typename: "Finding",
      id: string,
      tenantId?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      createdAt?: string | null,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      number?: number | null,
      displayNumber?: string | null,
      shortDescription?: string | null,
      priority?: number | null,
      estimatedRepairCost?: number | null,
      plannedRepairDate?: string | null,
      description?: string | null,
      cause?: string | null,
      symptom?: string | null,
      picture?: string | null,
      reportedOn?: string | null,
      workOrderId?: string | null,
      type?: FindingType | null,
      reportedById?: string | null,
      status?: FindingStatus | null,
      assetId?: string | null,
      asset?:  {
        __typename: "Asset",
        id: string,
        number?: number | null,
        displayNumber?: string | null,
        userId?: string | null,
        assetTag: string,
        description: string,
        makeId: string,
        modelId: string,
        state: string,
        usefulLife?: number | null,
        acquisitionCostValue?: number | null,
        lastMaintenanceDate?: string | null,
        nextScheduledMaintenanceDate?: string | null,
        assignedToId?: string | null,
        assetTypeId: string,
        condition?: string | null,
        maintenanceCostValue?: number | null,
        currentBookValue?: number | null,
        installDate?: string | null,
        decommissionDate?: string | null,
        locationId?: string | null,
        image?: string | null,
        purchaseOrderId?: string | null,
        utilizationData?: string | null,
        reasonForDecommission?: string | null,
        serialNumber: string,
        thirdPartyId?: string | null,
        source?: string | null,
        totalCostOfOwnershipValue?: number | null,
        repairCostValue?: number | null,
        warrantyExpiration?: string | null,
        downTime?: string | null,
        tenantId: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        model?:  {
          __typename: "Model",
          id: string,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          oemPartNumber?: string | null,
          name: string,
          manufacturerId: string,
          assetTypeId: string,
          probability?: number | null,
          severity?: number | null,
          riskScore?: number | null,
          picture?: string | null,
          specification?: string | null,
          usefulLife?: number | null,
          inUseStatus?: InUseStatus | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        assetType?:  {
          __typename: "AssetType",
          id: string,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          name: string,
          description?: string | null,
          category?: string | null,
          criticalityLevel?: number | null,
          expectedUsefulLife?: number | null,
          defaultWarrantyPeriod?: number | null,
          defaultRiskScore?: number | null,
          manufacturerRecommendations?: string | null,
          image?: string | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          inUseStatus?: string | null,
        } | null,
        manufacturer?:  {
          __typename: "Manufacturer",
          id: string,
          name: string,
          description?: string | null,
          countryId?: string | null,
          website?: string | null,
          contactPerson?: string | null,
          contactEmail?: string | null,
          contactPhone?: string | null,
          address?: string | null,
          warrantyPolicies?: string | null,
          slaDetails?: string | null,
          vendorPortalLink?: string | null,
          createdAt: string,
          createdBy: string,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          inUseStatus?: InUseStatus | null,
        } | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        woCount?: number | null,
        findingsCount?: number | null,
        user?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        assetRisk?: number | null,
        location?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        isParent?: boolean | null,
        thirdPartyParentId?: string | null,
        thirdPartyHierarchyPath?: Array< string | null > | null,
      } | null,
      locationId?: string | null,
      model?:  {
        __typename: "Model",
        id: string,
        tenantId: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        oemPartNumber?: string | null,
        name: string,
        manufacturerId: string,
        assetTypeId: string,
        probability?: number | null,
        severity?: number | null,
        riskScore?: number | null,
        picture?: string | null,
        specification?: string | null,
        usefulLife?: number | null,
        inUseStatus?: InUseStatus | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        manufacturer?:  {
          __typename: "Manufacturer",
          id: string,
          name: string,
          description?: string | null,
          countryId?: string | null,
          website?: string | null,
          contactPerson?: string | null,
          contactEmail?: string | null,
          contactPhone?: string | null,
          address?: string | null,
          warrantyPolicies?: string | null,
          slaDetails?: string | null,
          vendorPortalLink?: string | null,
          createdAt: string,
          createdBy: string,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          inUseStatus?: InUseStatus | null,
        } | null,
        assetType?:  {
          __typename: "AssetType",
          id: string,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          name: string,
          description?: string | null,
          category?: string | null,
          criticalityLevel?: number | null,
          expectedUsefulLife?: number | null,
          defaultWarrantyPeriod?: number | null,
          defaultRiskScore?: number | null,
          manufacturerRecommendations?: string | null,
          image?: string | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          inUseStatus?: string | null,
        } | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
      } | null,
      isArchived?: boolean | null,
      thirdPartyId?: string | null,
      thirdPartySource?: string | null,
    } | null > | null,
    totalCount?: number | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type GetAttachmentQueryVariables = {
  id: string,
};

export type GetAttachmentQuery = {
  getAttachment?:  {
    __typename: "AttachmentResponse",
    data?:  {
      __typename: "Attachment",
      id: string,
      tenantId: string,
      createdAt: string,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      fileName: string,
      originalFileName: string,
      path: string,
      downloadUrl?: string | null,
      mimeType: string,
      size: number,
      description?: string | null,
      relatedTable: string,
      relatedItem: string,
      type: string,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type GetAttachmentListQueryVariables = {
  params?: QueryListParams | null,
};

export type GetAttachmentListQuery = {
  getAttachmentList?:  {
    __typename: "AttachmentListResponse",
    data?:  Array< {
      __typename: "Attachment",
      id: string,
      tenantId: string,
      createdAt: string,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
      fileName: string,
      originalFileName: string,
      path: string,
      downloadUrl?: string | null,
      mimeType: string,
      size: number,
      description?: string | null,
      relatedTable: string,
      relatedItem: string,
      type: string,
    } | null > | null,
    totalCount?: number | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type GetAlertQueryVariables = {
  id: string,
};

export type GetAlertQuery = {
  getAlert?:  {
    __typename: "AlertResponse",
    data?:  {
      __typename: "Alert",
      id: string,
      number: number,
      displayNumber?: string | null,
      asset?:  {
        __typename: "Asset",
        id: string,
        number?: number | null,
        displayNumber?: string | null,
        userId?: string | null,
        assetTag: string,
        description: string,
        makeId: string,
        modelId: string,
        state: string,
        usefulLife?: number | null,
        acquisitionCostValue?: number | null,
        lastMaintenanceDate?: string | null,
        nextScheduledMaintenanceDate?: string | null,
        assignedToId?: string | null,
        assetTypeId: string,
        condition?: string | null,
        maintenanceCostValue?: number | null,
        currentBookValue?: number | null,
        installDate?: string | null,
        decommissionDate?: string | null,
        locationId?: string | null,
        image?: string | null,
        purchaseOrderId?: string | null,
        utilizationData?: string | null,
        reasonForDecommission?: string | null,
        serialNumber: string,
        thirdPartyId?: string | null,
        source?: string | null,
        totalCostOfOwnershipValue?: number | null,
        repairCostValue?: number | null,
        warrantyExpiration?: string | null,
        downTime?: string | null,
        tenantId: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        model?:  {
          __typename: "Model",
          id: string,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          oemPartNumber?: string | null,
          name: string,
          manufacturerId: string,
          assetTypeId: string,
          probability?: number | null,
          severity?: number | null,
          riskScore?: number | null,
          picture?: string | null,
          specification?: string | null,
          usefulLife?: number | null,
          inUseStatus?: InUseStatus | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        assetType?:  {
          __typename: "AssetType",
          id: string,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          name: string,
          description?: string | null,
          category?: string | null,
          criticalityLevel?: number | null,
          expectedUsefulLife?: number | null,
          defaultWarrantyPeriod?: number | null,
          defaultRiskScore?: number | null,
          manufacturerRecommendations?: string | null,
          image?: string | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          inUseStatus?: string | null,
        } | null,
        manufacturer?:  {
          __typename: "Manufacturer",
          id: string,
          name: string,
          description?: string | null,
          countryId?: string | null,
          website?: string | null,
          contactPerson?: string | null,
          contactEmail?: string | null,
          contactPhone?: string | null,
          address?: string | null,
          warrantyPolicies?: string | null,
          slaDetails?: string | null,
          vendorPortalLink?: string | null,
          createdAt: string,
          createdBy: string,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          inUseStatus?: InUseStatus | null,
        } | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        woCount?: number | null,
        findingsCount?: number | null,
        user?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        assetRisk?: number | null,
        location?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        isParent?: boolean | null,
        thirdPartyParentId?: string | null,
        thirdPartyHierarchyPath?: Array< string | null > | null,
      } | null,
      assetId?: string | null,
      daysFailed?: string | null,
      tisStatus?: string | null,
      state: AlertState,
      firstException?: string | null,
      worstException?: string | null,
      lastException?: string | null,
      impactComfort?: string | null,
      impactEnergy?: string | null,
      impactReliability?: string | null,
      testValue?: string | null,
      exceptionName?: string | null,
      suggestionDescription?: string | null,
      suggestionCauses?: string | null,
      workOrder?:  {
        __typename: "WorkOrder",
        id?: string | null,
        displayNumber?: string | null,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt?: string | null,
        createdBy?: string | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        number?: number | null,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        locationId?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        dueDate?: string | null,
        startDate?: string | null,
        endDate?: string | null,
        duration?: string | null,
        plannedStartDate?: string | null,
        plannedEndDate?: string | null,
        assetId?: string | null,
        asset?:  {
          __typename: "Asset",
          id: string,
          number?: number | null,
          displayNumber?: string | null,
          userId?: string | null,
          assetTag: string,
          description: string,
          makeId: string,
          modelId: string,
          state: string,
          usefulLife?: number | null,
          acquisitionCostValue?: number | null,
          lastMaintenanceDate?: string | null,
          nextScheduledMaintenanceDate?: string | null,
          assignedToId?: string | null,
          assetTypeId: string,
          condition?: string | null,
          maintenanceCostValue?: number | null,
          currentBookValue?: number | null,
          installDate?: string | null,
          decommissionDate?: string | null,
          locationId?: string | null,
          image?: string | null,
          purchaseOrderId?: string | null,
          utilizationData?: string | null,
          reasonForDecommission?: string | null,
          serialNumber: string,
          thirdPartyId?: string | null,
          source?: string | null,
          totalCostOfOwnershipValue?: number | null,
          repairCostValue?: number | null,
          warrantyExpiration?: string | null,
          downTime?: string | null,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          model?:  {
            __typename: "Model",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            oemPartNumber?: string | null,
            name: string,
            manufacturerId: string,
            assetTypeId: string,
            probability?: number | null,
            severity?: number | null,
            riskScore?: number | null,
            picture?: string | null,
            specification?: string | null,
            usefulLife?: number | null,
            inUseStatus?: InUseStatus | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          woCount?: number | null,
          findingsCount?: number | null,
          user?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          assetRisk?: number | null,
          location?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          isParent?: boolean | null,
          thirdPartyParentId?: string | null,
          thirdPartyHierarchyPath?: Array< string | null > | null,
        } | null,
        assignmentGroupId?: string | null,
        assignedToId?: string | null,
        assignedTo?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        businessDownTime?: number | null,
        downTimeStart?: string | null,
        downTimeEnd?: string | null,
        category?: string | null,
        checklist?: string | null,
        closedNotes?: string | null,
        closedAt?: string | null,
        closedById?: string | null,
        closedBy?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        notes?: string | null,
        title?: string | null,
        description?: string | null,
        estimatedCostValue?: number | null,
        actualCostValue?: number | null,
        estimatedEffort?: number | null,
        actualEffort?: number | null,
        expectedOperationalDate?: string | null,
        impact?: number | null,
        priority?: number | null,
        dependsOnWorkOrderId?: string | null,
        dependsOnWorkOrder?:  {
          __typename: "WorkOrder",
          id?: string | null,
          displayNumber?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt?: string | null,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          number?: number | null,
          userId?: string | null,
          user?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          locationId?: string | null,
          location?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          dueDate?: string | null,
          startDate?: string | null,
          endDate?: string | null,
          duration?: string | null,
          plannedStartDate?: string | null,
          plannedEndDate?: string | null,
          assetId?: string | null,
          asset?:  {
            __typename: "Asset",
            id: string,
            number?: number | null,
            displayNumber?: string | null,
            userId?: string | null,
            assetTag: string,
            description: string,
            makeId: string,
            modelId: string,
            state: string,
            usefulLife?: number | null,
            acquisitionCostValue?: number | null,
            lastMaintenanceDate?: string | null,
            nextScheduledMaintenanceDate?: string | null,
            assignedToId?: string | null,
            assetTypeId: string,
            condition?: string | null,
            maintenanceCostValue?: number | null,
            currentBookValue?: number | null,
            installDate?: string | null,
            decommissionDate?: string | null,
            locationId?: string | null,
            image?: string | null,
            purchaseOrderId?: string | null,
            utilizationData?: string | null,
            reasonForDecommission?: string | null,
            serialNumber: string,
            thirdPartyId?: string | null,
            source?: string | null,
            totalCostOfOwnershipValue?: number | null,
            repairCostValue?: number | null,
            warrantyExpiration?: string | null,
            downTime?: string | null,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            woCount?: number | null,
            findingsCount?: number | null,
            assetRisk?: number | null,
            isParent?: boolean | null,
            thirdPartyParentId?: string | null,
            thirdPartyHierarchyPath?: Array< string | null > | null,
          } | null,
          assignmentGroupId?: string | null,
          assignedToId?: string | null,
          assignedTo?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          businessDownTime?: number | null,
          downTimeStart?: string | null,
          downTimeEnd?: string | null,
          category?: string | null,
          checklist?: string | null,
          closedNotes?: string | null,
          closedAt?: string | null,
          closedById?: string | null,
          closedBy?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          notes?: string | null,
          title?: string | null,
          description?: string | null,
          estimatedCostValue?: number | null,
          actualCostValue?: number | null,
          estimatedEffort?: number | null,
          actualEffort?: number | null,
          expectedOperationalDate?: string | null,
          impact?: number | null,
          priority?: number | null,
          dependsOnWorkOrderId?: string | null,
          dependsOnWorkOrder?:  {
            __typename: "WorkOrder",
            id?: string | null,
            displayNumber?: string | null,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            number?: number | null,
            userId?: string | null,
            locationId?: string | null,
            dueDate?: string | null,
            startDate?: string | null,
            endDate?: string | null,
            duration?: string | null,
            plannedStartDate?: string | null,
            plannedEndDate?: string | null,
            assetId?: string | null,
            assignmentGroupId?: string | null,
            assignedToId?: string | null,
            businessDownTime?: number | null,
            downTimeStart?: string | null,
            downTimeEnd?: string | null,
            category?: string | null,
            checklist?: string | null,
            closedNotes?: string | null,
            closedAt?: string | null,
            closedById?: string | null,
            notes?: string | null,
            title?: string | null,
            description?: string | null,
            estimatedCostValue?: number | null,
            actualCostValue?: number | null,
            estimatedEffort?: number | null,
            actualEffort?: number | null,
            expectedOperationalDate?: string | null,
            impact?: number | null,
            priority?: number | null,
            dependsOnWorkOrderId?: string | null,
            state?: string | null,
            type?: string | null,
            templateId?: string | null,
            isArchived?: boolean | null,
            findingId?: string | null,
            seenByAssignee?: boolean | null,
            assignmentDateTime?: string | null,
            seenDateTime?: string | null,
            startOfWorkDateTime?: string | null,
            endOfWorkDateTime?: string | null,
          } | null,
          state?: string | null,
          type?: string | null,
          templateId?: string | null,
          isArchived?: boolean | null,
          findingId?: string | null,
          seenByAssignee?: boolean | null,
          assignmentDateTime?: string | null,
          seenDateTime?: string | null,
          startOfWorkDateTime?: string | null,
          endOfWorkDateTime?: string | null,
        } | null,
        state?: string | null,
        type?: string | null,
        templateId?: string | null,
        isArchived?: boolean | null,
        findingId?: string | null,
        seenByAssignee?: boolean | null,
        assignmentDateTime?: string | null,
        seenDateTime?: string | null,
        startOfWorkDateTime?: string | null,
        endOfWorkDateTime?: string | null,
      } | null,
      workOrderId?: string | null,
      finding?:  {
        __typename: "Finding",
        id: string,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        number?: number | null,
        displayNumber?: string | null,
        shortDescription?: string | null,
        priority?: number | null,
        estimatedRepairCost?: number | null,
        plannedRepairDate?: string | null,
        description?: string | null,
        cause?: string | null,
        symptom?: string | null,
        picture?: string | null,
        reportedOn?: string | null,
        workOrderId?: string | null,
        type?: FindingType | null,
        reportedById?: string | null,
        status?: FindingStatus | null,
        assetId?: string | null,
        asset?:  {
          __typename: "Asset",
          id: string,
          number?: number | null,
          displayNumber?: string | null,
          userId?: string | null,
          assetTag: string,
          description: string,
          makeId: string,
          modelId: string,
          state: string,
          usefulLife?: number | null,
          acquisitionCostValue?: number | null,
          lastMaintenanceDate?: string | null,
          nextScheduledMaintenanceDate?: string | null,
          assignedToId?: string | null,
          assetTypeId: string,
          condition?: string | null,
          maintenanceCostValue?: number | null,
          currentBookValue?: number | null,
          installDate?: string | null,
          decommissionDate?: string | null,
          locationId?: string | null,
          image?: string | null,
          purchaseOrderId?: string | null,
          utilizationData?: string | null,
          reasonForDecommission?: string | null,
          serialNumber: string,
          thirdPartyId?: string | null,
          source?: string | null,
          totalCostOfOwnershipValue?: number | null,
          repairCostValue?: number | null,
          warrantyExpiration?: string | null,
          downTime?: string | null,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          model?:  {
            __typename: "Model",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            oemPartNumber?: string | null,
            name: string,
            manufacturerId: string,
            assetTypeId: string,
            probability?: number | null,
            severity?: number | null,
            riskScore?: number | null,
            picture?: string | null,
            specification?: string | null,
            usefulLife?: number | null,
            inUseStatus?: InUseStatus | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          woCount?: number | null,
          findingsCount?: number | null,
          user?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          assetRisk?: number | null,
          location?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          isParent?: boolean | null,
          thirdPartyParentId?: string | null,
          thirdPartyHierarchyPath?: Array< string | null > | null,
        } | null,
        locationId?: string | null,
        model?:  {
          __typename: "Model",
          id: string,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          oemPartNumber?: string | null,
          name: string,
          manufacturerId: string,
          assetTypeId: string,
          probability?: number | null,
          severity?: number | null,
          riskScore?: number | null,
          picture?: string | null,
          specification?: string | null,
          usefulLife?: number | null,
          inUseStatus?: InUseStatus | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        isArchived?: boolean | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
      } | null,
      findingId?: string | null,
      thirdPartyId?: string | null,
      thirdPartySource?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      tenantId: string,
      createdAt?: string | null,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
    } | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};

export type GetAlertListQueryVariables = {
  params?: QueryListParams | null,
};

export type GetAlertListQuery = {
  getAlertList?:  {
    __typename: "AlertListResponse",
    data?:  Array< {
      __typename: "Alert",
      id: string,
      number: number,
      displayNumber?: string | null,
      asset?:  {
        __typename: "Asset",
        id: string,
        number?: number | null,
        displayNumber?: string | null,
        userId?: string | null,
        assetTag: string,
        description: string,
        makeId: string,
        modelId: string,
        state: string,
        usefulLife?: number | null,
        acquisitionCostValue?: number | null,
        lastMaintenanceDate?: string | null,
        nextScheduledMaintenanceDate?: string | null,
        assignedToId?: string | null,
        assetTypeId: string,
        condition?: string | null,
        maintenanceCostValue?: number | null,
        currentBookValue?: number | null,
        installDate?: string | null,
        decommissionDate?: string | null,
        locationId?: string | null,
        image?: string | null,
        purchaseOrderId?: string | null,
        utilizationData?: string | null,
        reasonForDecommission?: string | null,
        serialNumber: string,
        thirdPartyId?: string | null,
        source?: string | null,
        totalCostOfOwnershipValue?: number | null,
        repairCostValue?: number | null,
        warrantyExpiration?: string | null,
        downTime?: string | null,
        tenantId: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        model?:  {
          __typename: "Model",
          id: string,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          oemPartNumber?: string | null,
          name: string,
          manufacturerId: string,
          assetTypeId: string,
          probability?: number | null,
          severity?: number | null,
          riskScore?: number | null,
          picture?: string | null,
          specification?: string | null,
          usefulLife?: number | null,
          inUseStatus?: InUseStatus | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        assetType?:  {
          __typename: "AssetType",
          id: string,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          name: string,
          description?: string | null,
          category?: string | null,
          criticalityLevel?: number | null,
          expectedUsefulLife?: number | null,
          defaultWarrantyPeriod?: number | null,
          defaultRiskScore?: number | null,
          manufacturerRecommendations?: string | null,
          image?: string | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          inUseStatus?: string | null,
        } | null,
        manufacturer?:  {
          __typename: "Manufacturer",
          id: string,
          name: string,
          description?: string | null,
          countryId?: string | null,
          website?: string | null,
          contactPerson?: string | null,
          contactEmail?: string | null,
          contactPhone?: string | null,
          address?: string | null,
          warrantyPolicies?: string | null,
          slaDetails?: string | null,
          vendorPortalLink?: string | null,
          createdAt: string,
          createdBy: string,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          inUseStatus?: InUseStatus | null,
        } | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        woCount?: number | null,
        findingsCount?: number | null,
        user?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        assetRisk?: number | null,
        location?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        isParent?: boolean | null,
        thirdPartyParentId?: string | null,
        thirdPartyHierarchyPath?: Array< string | null > | null,
      } | null,
      assetId?: string | null,
      daysFailed?: string | null,
      tisStatus?: string | null,
      state: AlertState,
      firstException?: string | null,
      worstException?: string | null,
      lastException?: string | null,
      impactComfort?: string | null,
      impactEnergy?: string | null,
      impactReliability?: string | null,
      testValue?: string | null,
      exceptionName?: string | null,
      suggestionDescription?: string | null,
      suggestionCauses?: string | null,
      workOrder?:  {
        __typename: "WorkOrder",
        id?: string | null,
        displayNumber?: string | null,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt?: string | null,
        createdBy?: string | null,
        createdByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        updatedByUser?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        number?: number | null,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        locationId?: string | null,
        location?:  {
          __typename: "Location",
          id: string,
          tenantId: string,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          notes?: string | null,
          lat?: number | null,
          lng?: number | null,
          level?: string | null,
          parentId?: string | null,
          rootId?: string | null,
          thirdPartyId?: string | null,
          source?: string | null,
          inUseStatus?: InUseStatus | null,
          address?: string | null,
          buildingAddress?: string | null,
          parent?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          tisSyncedAt?: string | null,
        } | null,
        dueDate?: string | null,
        startDate?: string | null,
        endDate?: string | null,
        duration?: string | null,
        plannedStartDate?: string | null,
        plannedEndDate?: string | null,
        assetId?: string | null,
        asset?:  {
          __typename: "Asset",
          id: string,
          number?: number | null,
          displayNumber?: string | null,
          userId?: string | null,
          assetTag: string,
          description: string,
          makeId: string,
          modelId: string,
          state: string,
          usefulLife?: number | null,
          acquisitionCostValue?: number | null,
          lastMaintenanceDate?: string | null,
          nextScheduledMaintenanceDate?: string | null,
          assignedToId?: string | null,
          assetTypeId: string,
          condition?: string | null,
          maintenanceCostValue?: number | null,
          currentBookValue?: number | null,
          installDate?: string | null,
          decommissionDate?: string | null,
          locationId?: string | null,
          image?: string | null,
          purchaseOrderId?: string | null,
          utilizationData?: string | null,
          reasonForDecommission?: string | null,
          serialNumber: string,
          thirdPartyId?: string | null,
          source?: string | null,
          totalCostOfOwnershipValue?: number | null,
          repairCostValue?: number | null,
          warrantyExpiration?: string | null,
          downTime?: string | null,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          model?:  {
            __typename: "Model",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            oemPartNumber?: string | null,
            name: string,
            manufacturerId: string,
            assetTypeId: string,
            probability?: number | null,
            severity?: number | null,
            riskScore?: number | null,
            picture?: string | null,
            specification?: string | null,
            usefulLife?: number | null,
            inUseStatus?: InUseStatus | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          woCount?: number | null,
          findingsCount?: number | null,
          user?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          assetRisk?: number | null,
          location?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          isParent?: boolean | null,
          thirdPartyParentId?: string | null,
          thirdPartyHierarchyPath?: Array< string | null > | null,
        } | null,
        assignmentGroupId?: string | null,
        assignedToId?: string | null,
        assignedTo?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        businessDownTime?: number | null,
        downTimeStart?: string | null,
        downTimeEnd?: string | null,
        category?: string | null,
        checklist?: string | null,
        closedNotes?: string | null,
        closedAt?: string | null,
        closedById?: string | null,
        closedBy?:  {
          __typename: "User",
          id: string,
          tenantId?: string | null,
          createdAt?: string | null,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          groups?: string | null,
          email: string,
          name: string,
          phone?: string | null,
          role?: string | null,
          address?: string | null,
          location?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        notes?: string | null,
        title?: string | null,
        description?: string | null,
        estimatedCostValue?: number | null,
        actualCostValue?: number | null,
        estimatedEffort?: number | null,
        actualEffort?: number | null,
        expectedOperationalDate?: string | null,
        impact?: number | null,
        priority?: number | null,
        dependsOnWorkOrderId?: string | null,
        dependsOnWorkOrder?:  {
          __typename: "WorkOrder",
          id?: string | null,
          displayNumber?: string | null,
          tenantId?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          createdAt?: string | null,
          createdBy?: string | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          number?: number | null,
          userId?: string | null,
          user?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          locationId?: string | null,
          location?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          dueDate?: string | null,
          startDate?: string | null,
          endDate?: string | null,
          duration?: string | null,
          plannedStartDate?: string | null,
          plannedEndDate?: string | null,
          assetId?: string | null,
          asset?:  {
            __typename: "Asset",
            id: string,
            number?: number | null,
            displayNumber?: string | null,
            userId?: string | null,
            assetTag: string,
            description: string,
            makeId: string,
            modelId: string,
            state: string,
            usefulLife?: number | null,
            acquisitionCostValue?: number | null,
            lastMaintenanceDate?: string | null,
            nextScheduledMaintenanceDate?: string | null,
            assignedToId?: string | null,
            assetTypeId: string,
            condition?: string | null,
            maintenanceCostValue?: number | null,
            currentBookValue?: number | null,
            installDate?: string | null,
            decommissionDate?: string | null,
            locationId?: string | null,
            image?: string | null,
            purchaseOrderId?: string | null,
            utilizationData?: string | null,
            reasonForDecommission?: string | null,
            serialNumber: string,
            thirdPartyId?: string | null,
            source?: string | null,
            totalCostOfOwnershipValue?: number | null,
            repairCostValue?: number | null,
            warrantyExpiration?: string | null,
            downTime?: string | null,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            woCount?: number | null,
            findingsCount?: number | null,
            assetRisk?: number | null,
            isParent?: boolean | null,
            thirdPartyParentId?: string | null,
            thirdPartyHierarchyPath?: Array< string | null > | null,
          } | null,
          assignmentGroupId?: string | null,
          assignedToId?: string | null,
          assignedTo?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          businessDownTime?: number | null,
          downTimeStart?: string | null,
          downTimeEnd?: string | null,
          category?: string | null,
          checklist?: string | null,
          closedNotes?: string | null,
          closedAt?: string | null,
          closedById?: string | null,
          closedBy?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          notes?: string | null,
          title?: string | null,
          description?: string | null,
          estimatedCostValue?: number | null,
          actualCostValue?: number | null,
          estimatedEffort?: number | null,
          actualEffort?: number | null,
          expectedOperationalDate?: string | null,
          impact?: number | null,
          priority?: number | null,
          dependsOnWorkOrderId?: string | null,
          dependsOnWorkOrder?:  {
            __typename: "WorkOrder",
            id?: string | null,
            displayNumber?: string | null,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            number?: number | null,
            userId?: string | null,
            locationId?: string | null,
            dueDate?: string | null,
            startDate?: string | null,
            endDate?: string | null,
            duration?: string | null,
            plannedStartDate?: string | null,
            plannedEndDate?: string | null,
            assetId?: string | null,
            assignmentGroupId?: string | null,
            assignedToId?: string | null,
            businessDownTime?: number | null,
            downTimeStart?: string | null,
            downTimeEnd?: string | null,
            category?: string | null,
            checklist?: string | null,
            closedNotes?: string | null,
            closedAt?: string | null,
            closedById?: string | null,
            notes?: string | null,
            title?: string | null,
            description?: string | null,
            estimatedCostValue?: number | null,
            actualCostValue?: number | null,
            estimatedEffort?: number | null,
            actualEffort?: number | null,
            expectedOperationalDate?: string | null,
            impact?: number | null,
            priority?: number | null,
            dependsOnWorkOrderId?: string | null,
            state?: string | null,
            type?: string | null,
            templateId?: string | null,
            isArchived?: boolean | null,
            findingId?: string | null,
            seenByAssignee?: boolean | null,
            assignmentDateTime?: string | null,
            seenDateTime?: string | null,
            startOfWorkDateTime?: string | null,
            endOfWorkDateTime?: string | null,
          } | null,
          state?: string | null,
          type?: string | null,
          templateId?: string | null,
          isArchived?: boolean | null,
          findingId?: string | null,
          seenByAssignee?: boolean | null,
          assignmentDateTime?: string | null,
          seenDateTime?: string | null,
          startOfWorkDateTime?: string | null,
          endOfWorkDateTime?: string | null,
        } | null,
        state?: string | null,
        type?: string | null,
        templateId?: string | null,
        isArchived?: boolean | null,
        findingId?: string | null,
        seenByAssignee?: boolean | null,
        assignmentDateTime?: string | null,
        seenDateTime?: string | null,
        startOfWorkDateTime?: string | null,
        endOfWorkDateTime?: string | null,
      } | null,
      workOrderId?: string | null,
      finding?:  {
        __typename: "Finding",
        id: string,
        tenantId?: string | null,
        tenant?:  {
          __typename: "Tenant",
          id: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          name: string,
          address?: string | null,
          contacts?: string | null,
          isActive?: boolean | null,
          cognitoGroupName?: string | null,
          tisId?: string | null,
          plan?: TenantPlan | null,
          tisSyncedAt?: string | null,
        } | null,
        createdAt?: string | null,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        number?: number | null,
        displayNumber?: string | null,
        shortDescription?: string | null,
        priority?: number | null,
        estimatedRepairCost?: number | null,
        plannedRepairDate?: string | null,
        description?: string | null,
        cause?: string | null,
        symptom?: string | null,
        picture?: string | null,
        reportedOn?: string | null,
        workOrderId?: string | null,
        type?: FindingType | null,
        reportedById?: string | null,
        status?: FindingStatus | null,
        assetId?: string | null,
        asset?:  {
          __typename: "Asset",
          id: string,
          number?: number | null,
          displayNumber?: string | null,
          userId?: string | null,
          assetTag: string,
          description: string,
          makeId: string,
          modelId: string,
          state: string,
          usefulLife?: number | null,
          acquisitionCostValue?: number | null,
          lastMaintenanceDate?: string | null,
          nextScheduledMaintenanceDate?: string | null,
          assignedToId?: string | null,
          assetTypeId: string,
          condition?: string | null,
          maintenanceCostValue?: number | null,
          currentBookValue?: number | null,
          installDate?: string | null,
          decommissionDate?: string | null,
          locationId?: string | null,
          image?: string | null,
          purchaseOrderId?: string | null,
          utilizationData?: string | null,
          reasonForDecommission?: string | null,
          serialNumber: string,
          thirdPartyId?: string | null,
          source?: string | null,
          totalCostOfOwnershipValue?: number | null,
          repairCostValue?: number | null,
          warrantyExpiration?: string | null,
          downTime?: string | null,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          model?:  {
            __typename: "Model",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            oemPartNumber?: string | null,
            name: string,
            manufacturerId: string,
            assetTypeId: string,
            probability?: number | null,
            severity?: number | null,
            riskScore?: number | null,
            picture?: string | null,
            specification?: string | null,
            usefulLife?: number | null,
            inUseStatus?: InUseStatus | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          woCount?: number | null,
          findingsCount?: number | null,
          user?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          assetRisk?: number | null,
          location?:  {
            __typename: "Location",
            id: string,
            tenantId: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            notes?: string | null,
            lat?: number | null,
            lng?: number | null,
            level?: string | null,
            parentId?: string | null,
            rootId?: string | null,
            thirdPartyId?: string | null,
            source?: string | null,
            inUseStatus?: InUseStatus | null,
            address?: string | null,
            buildingAddress?: string | null,
            tisSyncedAt?: string | null,
          } | null,
          isParent?: boolean | null,
          thirdPartyParentId?: string | null,
          thirdPartyHierarchyPath?: Array< string | null > | null,
        } | null,
        locationId?: string | null,
        model?:  {
          __typename: "Model",
          id: string,
          tenantId: string,
          createdAt: string,
          createdBy?: string | null,
          updatedAt?: string | null,
          updatedBy?: string | null,
          oemPartNumber?: string | null,
          name: string,
          manufacturerId: string,
          assetTypeId: string,
          probability?: number | null,
          severity?: number | null,
          riskScore?: number | null,
          picture?: string | null,
          specification?: string | null,
          usefulLife?: number | null,
          inUseStatus?: InUseStatus | null,
          thirdPartyId?: string | null,
          thirdPartySource?: string | null,
          tenant?:  {
            __typename: "Tenant",
            id: string,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            address?: string | null,
            contacts?: string | null,
            isActive?: boolean | null,
            cognitoGroupName?: string | null,
            tisId?: string | null,
            plan?: TenantPlan | null,
            tisSyncedAt?: string | null,
          } | null,
          manufacturer?:  {
            __typename: "Manufacturer",
            id: string,
            name: string,
            description?: string | null,
            countryId?: string | null,
            website?: string | null,
            contactPerson?: string | null,
            contactEmail?: string | null,
            contactPhone?: string | null,
            address?: string | null,
            warrantyPolicies?: string | null,
            slaDetails?: string | null,
            vendorPortalLink?: string | null,
            createdAt: string,
            createdBy: string,
            updatedAt?: string | null,
            updatedBy?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            tenantId?: string | null,
            inUseStatus?: InUseStatus | null,
          } | null,
          assetType?:  {
            __typename: "AssetType",
            id: string,
            tenantId?: string | null,
            createdAt: string,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            name: string,
            description?: string | null,
            category?: string | null,
            criticalityLevel?: number | null,
            expectedUsefulLife?: number | null,
            defaultWarrantyPeriod?: number | null,
            defaultRiskScore?: number | null,
            manufacturerRecommendations?: string | null,
            image?: string | null,
            thirdPartyId?: string | null,
            thirdPartySource?: string | null,
            inUseStatus?: string | null,
          } | null,
          createdByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
          updatedByUser?:  {
            __typename: "User",
            id: string,
            tenantId?: string | null,
            createdAt?: string | null,
            createdBy?: string | null,
            updatedAt?: string | null,
            updatedBy?: string | null,
            groups?: string | null,
            email: string,
            name: string,
            phone?: string | null,
            role?: string | null,
            address?: string | null,
            location?: string | null,
          } | null,
        } | null,
        isArchived?: boolean | null,
        thirdPartyId?: string | null,
        thirdPartySource?: string | null,
      } | null,
      findingId?: string | null,
      thirdPartyId?: string | null,
      thirdPartySource?: string | null,
      tenant?:  {
        __typename: "Tenant",
        id: string,
        createdAt: string,
        createdBy?: string | null,
        updatedAt?: string | null,
        updatedBy?: string | null,
        name: string,
        address?: string | null,
        contacts?: string | null,
        isActive?: boolean | null,
        cognitoGroupName?: string | null,
        tisId?: string | null,
        plan?: TenantPlan | null,
        tisSyncedAt?: string | null,
      } | null,
      tenantId: string,
      createdAt?: string | null,
      createdBy?: string | null,
      updatedAt?: string | null,
      updatedBy?: string | null,
    } | null > | null,
    totalCount?: number | null,
    status?: number | null,
    errors?: Array< string | null > | null,
  } | null,
};
